// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spot-container {
    color: var(--white-color);
}


.price_item_value .td_div img {
    width: 20px;
    margin-right: 5px !important;
}

.trade-wrapper {
    padding-top: 4px !important;
}

@media (min-width: 1920px) {

    .trade_body .fluid-header {
        padding: 4px 0;
    }
}

@media (max-width: 1580px) {
    .trade_body .fluid-header {
        padding: 5px 15px;
    }

    .trade-wrapper {
        padding-top: 4px !important;
    }

}



/* Mobile Favourites Popup - Hidden by default (desktop/tablet) */
.mobile-favourites-popup-overlay {
    display: none;
}

/* Mobile Favourites Toggle Button - Hidden by default */
.mobile-favourites-toggle-btn {
    display: none;
}


.spot-container-main {
    display: flex;
    flex-direction: column;
    /*padding: 0 15px;*/
    flex: 1 1;
}

.spot-container-main .top {
    display: flex;
}

.trade_row {
    margin: 0 0;
}

.trade_col {
    padding: 0 5px;
    width: 100%;
}




.spot-container-main .top-left {
    flex-grow: 1;
}

.spot-container-main .top-right {
    width: 380px;
}


#TVChartContainer {
    border-radius: 10px;
    overflow: hidden;
}

#TVChartContainer iframe {
    border-radius: 10px;
    height: 594px;
}

.tradesummary {
    height: auto;
    min-height: 0;
}

.container-chart-briefing {
    height: 80px;
    position: relative;
    justify-content: flex-start;
    width: 100%;
    padding: 20px;
    display: flex;
    align-items: center;
}



.text-danger {
    color: #E45561 !important;
}

body .assets_right {
    border-radius: 6px;
}

body .trade_summary_table_lft {
    border-radius: 6px;
}

.trade_card,
.spotLists {
    background: #181A20;
    border: none;
    border-radius: 6px;
    overflow: hidden;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    position: relative;
    color: #fffffff2;
}


body.light_theme.trade_card,
body.light_theme.spotLists {
    background-color: #ffffff;
    border: 1px solid #7878781a;
    -webkit-backdrop-filter: none;
            backdrop-filter: none;
}

.container-chart-briefing-info {
    font-size: 12px;
    text-align: left;
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

dd,
dl,
dt {
    list-style: none;
    margin: 0;
    padding: 0;
    display: block;
    line-height: 1.5;
    font-weight: 600;
}

.container-chart-briefing h2 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding-right: 20px;
    cursor: pointer;
    font-weight: 700;
    color: #ffffff;
}

.container-chart-briefing-info dd.big,
.container-chart-briefing-info dt.big {
    font-size: 18px;
    font-weight: 700;
}

.container-chart-briefing-info dd.green,
.container-chart-briefing-info dt.green {
    color: #01BC8D !important;
}

.container-chart-briefing .displayName>span {
    padding-right: 10px;
}


.trade-wrapper .btn {
    justify-content: center;
}

dd {
    font-weight: 700;
}




.tv-chart {
    width: 100%;
    height: 507px;
}


/*order book*/

.card_title {
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    padding-bottom: 1rem;
    color: currentColor;
}


.trade_tabs {
    padding: 10px;
}

.trade_card_body.single-widget ul li a {
    font-size: 14PX;
}

.price_card_head {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: "Inter", sans-serif;
    line-height: 12px;
    justify-content: space-between;
    height: 24px;
    color: #87909F;
    line-height: 24px;
    /* border-bottom: 1px solid #2b2f39 */
}


.price_card_body::-webkit-scrollbar,
.scroll_y::-webkit-scrollbar {
    width: 3px;
    background-color: transparent;
}

.price_card_body::-webkit-scrollbar-thumb,
.scroll_y::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgb(106 106 106 / 21%);
}

.price_item_value {
    display: flex;
    position: relative;
    z-index: 1;
    color: #F2F4F6;
    font-family: "Inter", sans-serif;
    width: 100%;
    padding: 2px 0;
    justify-content: space-between;
    font-weight: 500;
    align-items: center;
}

.price_item_value:hover {
    background: #ffffff14;
}

body.light_theme.trade-wrapper {
    background-color: #f5f5f55e;
}

body.light_theme.price_item_value {
    /* border-bottom: 1px solid rgb(0 0 0 / 5%); */
    border-color: #58585814;
}

.price_item_value span {
    display: block;
    /*color: #ffffff;*/
    font-size: 11px;
}

/* 
.price_item_value span.text-green,
.price_item_value span.text-danger {
    font-weight: 500;
}

.price_item_value span:first-child,
.price_card_head>div:first-child {
    display: block;
    width: 33.33333%;
    padding-left: 10px;
}

.price_item_value span:nth-child(2),
.price_card_head>div:nth-child(2) {
    display: block;
    width: 33.33333%;
    text-align: center;
}

.price_item_value span:last-child,
.price_card_head>div:last-child {
    display: block;
    width: 33.33333%;
    text-align: right;
    padding-right: 10px;
    font-weight: 600;
} */


.price_item_value:last-child {
    /* border: 0; */
}

.live_ppc {
    font-weight: 600;
    padding: 1rem 0;
    line-height: 1;
}

.price_card_body.price_card_body_full,
.scroll_y {
    height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
}

.buy_sell_row_price .scroll_y {
    height: 230px;
}

/* Full-height scroll for bids-only / asks-only (replaces #buy_orders / #sell_orders) */
.buy_sell_row_price .scroll_y.orderbook-single-side {
    height: 520px;
}

.buysell_card {
    /* height: 533px; */
}

.spot-container-right-right {
    flex: 0 0 300px;
    max-width: 300px;
}

.scroll_y_mt {
    height: 322px;
}

div#tab_3 {
    height: 594px;
    margin-top: 66px;
}

.trade_card.p-2.overflow_card.mb-1 {
    width: calc(100% + 28.46%);
    height: 62px;
    margin-bottom: 4px !important;
}

.order-4 {
    margin: 0;
}


.assets_list {
    /* width: 100%; */
    margin: 57px 21px 20px;
    position: relative;
    z-index: 666;
}

.trade_card.trade_chart.buysell_card .assets_list {
    margin: 0px 21px 20px;
}

.assets_list ul {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: space-between;
    align-items: center;
    color: #fff;
}

.assets_list ul li {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.assets_btn {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin: 20px 0px;
}

.assets_btn button {
    width: 100%;
    background-color: #2B313C;
    color: #414141;
    font-weight: 700;
    border: none;
    font-size: 16px;
    padding: 7px 16px;
    border-radius: 50px;
}

.assets_list h4 {
    font-size: 18px;
    font-weight: 600;
}

.assets_list .top_heading {
    margin-bottom: 10px;
}

.assets_list .more_btn {
    margin: 0px;
}


.trade_chart .form-select-sm {
    padding: 9px 10px !important;
    font-size: 12px;
    background: #22242c;
    border-radius: 4px !important;
    border-color: #2d303a00;
    box-shadow: none;
    color: #F2F4F6;
}

.buysellform>p {
    margin: 7px 0 11px;
    font-size: 14px;
}

.btn-mini {
    font-size: 13px !important;
    padding: 9px;
    border-radius: 50px;
    font-weight: 500;
}

.buy_sell_cards ul.nav.custom-tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Inter", sans-serif;
    padding: 0;
    box-shadow: none !important;
    background: transparent !important;
    width: 100%;
    -webkit-backdrop-filter: unset !important;
            backdrop-filter: unset !important;
}

.buy_sell_cards ul.nav.custom-tabs.nav_order li {
    max-width: -moz-fit-content;
    max-width: fit-content;
    flex: 1 1 auto;
    text-align: center;

}

.buy_sell_cards ul.nav.custom-tabs.nav_order li a {
    opacity: 0.40;
}

.buy_sell_cards ul.nav.custom-tabs.nav_order li a.active {
    opacity: 1 !important;
}


.buy_sell_cards ul.nav.custom-tabs li a {
    /* box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px; */
    display: block;
    text-align: center;
    border-radius: 40px;
    padding: 4px 6px;
    color: #fff;
    background-color: #ffffff1a !important;
    font-size: 13px;
    font-weight: 600;
    margin: 0 3px;
}

.buy_sell_cards ul.nav.custom-tabs li a.active {
    color: #000 !important;
    background-color: #fea903 !important;
    opacity: 1 !important;
}

.buy_sell_cards ul.nav.custom-tabs li a.active {
    color: #e9e9e9 !important;
}

body.light_theme.buy_sell_cards ul.nav.custom-tabs li a {
    background-color: #f1f4f4;
    color: rgba(0, 0, 0, 0.75);
}

.custom-tabs li.buy-tab a:hover {
    color: rgba(255, 255, 255, 0.75);
    /*background-color: var(--bs-green)54;*/
}

.custom-tabs li.sell-tab a:hover {
    color: rgba(255, 255, 255, 0.75);
    /*background-color: #fe535b2b;*/
}

.custom-tabs li.buysell-tab a {
    cursor: pointer;
}

.buysell_heder .custom-tabs li a {
    cursor: pointer;
}

/* .custom-tabs li.sell-tab a.active,
.custom-tabs li.sell-tab a:active {
    color: #fff !important;
    background-color: #ed5765 !important;
} */

button.btn.btn-danger {
    color: #fff !important;
    background-color: #E45561 !important;
}

/* .custom-tabs li.buysell-tab a.active {
    color: #fff !important;
    background: #01BC8D !important;
} */

.text-green {
    color: #01BC8D;
}

.spot-deal-warp {
    margin-top: 25px;
}

.custom-tabs {
    color: var(--white-color);
    background: #ffffff1c;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    padding: 4px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 50px;
    display: inline-flex;
}

.spot .input-group {
    background: transparent;
    border-radius: 40px;
    overflow: hidden;
    /* box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px; */
}

.spot .input-group>span {
    text-align: center !important;
}

.spot .input-group>span small {
    text-align: center;
    margin: 0 auto;
}

.input-group-text {
    /*background-color: #20202d0d;*/
    /* border: 1px solid #20202d; */
    border-radius: 0;
    color: currentColor;
    line-height: 1.2;
    min-width: 76px;
    font-weight: 500;
    border: 0;
    background: transparent;
}

.input-group-text small {
    font-size: 75%;
}

.spot .form-control,
.spot select {
    color: currentColor;
    background-color: #2f2f39;
    border: 0;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    border-radius: 3px !important;
    background: #ffffff17;
    color: #ffffff;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    border: 1px solid #ffffff1c;
    padding: 7px 18px;
    min-width: unset;
    border-radius: 50px !important;
}

body.light_theme.spot .form-control {
    background-color: transparent;
}

.form-control:focus {
    box-shadow: none;
}

.btn-group.btn-group-mini {
    width: 100%;
    border-radius: 0 !important;
    border: 0;
    background: transparent;
    margin-left: auto !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
}

.btn-group.btn-group-mini * {
    border-block: none;
    /* line-height: 24px; */
    font-size: 12px !important;
    font-weight: 500;
    border: 0;
    transition: 0.0s;
    padding: 15px 0px 0px;
    color: #535963 !important;
    margin: 0 auto !important;
    width: -webkit-fill-available;
    text-align: left;
    display: grid;
    min-height: auto;
    box-shadow: none !important;
    /* height: 24px; */
    /* border-radius: 0px !important; */
    background: none;
    /* border: 1px solid #2d303a; */
    -webkit-backdrop-filter: blur(5px);
    /* backdrop-filter: blur(5px); */
    /* min-width: 36px; */
    opacity: 1;
}

/* .btn-group.btn-group-mini label.btn:hover{ background: #22242c !important; color: #f3bb2b !important; }  */

body.light_theme.btn-group.btn-group-mini * {
    background: rgb(171 171 171 / 12%);
    border: 1px solid rgb(234 239 244);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    color: #000;
}


.btn-check:active+.btn-outline-success:focus,
.btn-check:checked+.btn-outline-success:focus,
.btn-outline-success.active:focus,
.btn-outline-success.dropdown-toggle.show:focus,
.btn-outline-success:active:focus {
    box-shadow: none !important;
}

.btn-group.btn-group-mini *:focus {
    background: transparent;
}

.data-buy .btn-group.btn-group-mini .btn-outline-success {}

.data-sell .btn-group.btn-group-mini .btn-outline-danger {}

.btn-dark {
    background: #ffffff26;
}

.btn-check+.btn:hover {
    color: #ffffff;
}

.btn-check+.btn:hover {
    color: var(--bs-btn-color);
    background-color: var(--bs-btn-bg);
    border-color: non;
}

.data-buy .btn-group.btn-group-mini .btn-check:checked+.btn-outline-success,
.data-buy .btn-group.btn-group-mini .btn-outline-success:hover,
.data-buy .btn-group.btn-group-mini .btn-outline-success.active {
    background: #00000000;
    border-color: #00000000;
}

.data-buy .btn-group.btn-group-mini .btn-outline-success.active {
    background: rgba(2, 192, 118, 0.15) !important;
    border-color: #fff !important;
    color: #fff !important;
}

.data-sell .btn-group.btn-group-mini .btn-check:checked+.btn-outline-danger,
.data-sell .btn-group.btn-group-mini .btn-outline-danger:hover,
.data-sell .btn-group.btn-group-mini .btn-outline-danger.active {
    background: #00000000;
    border-color: #00000000;
}

.data-sell .btn-group.btn-group-mini .btn-outline-danger.active {
    background: rgba(228, 85, 97, 0.15) !important;
    border-color: #fff !important;
    color: #fff !important;
}

html[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-check:checked+.btn-outline-success,
html[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-outline-success:hover,
html[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-check:checked+.btn-outline-danger,
html[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-outline-danger:hover {
    background: #ffffff00 !important;
    border-color: #ffffff00 !important;
}

html[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-outline-success.active {
    background: rgba(2, 192, 118, 0.15) !important;
    border-color: #02c076 !important;
    color: #ffff !important;
}

html[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-outline-danger.active {
    background: rgba(228, 85, 97, 0.15) !important;
    border-color: #E45561 !important;
    color: #ffff !important;
}




/* .data-sell .btn-group.btn-group-mini .btn-check:checked + .btn-outline-success{ 
      border-color: var(--bs-green) !important;
  }
  .data-sell .btn-group.btn-group-mini .btn-check:checked + .btn-outline-danger{ 
      border-color: var(--bs-red) !important;
  } */


.trade-wrapper select,
.trade-wrapper .nice-select {
    box-shadow: none;
    height: 30px;
    background: #f0f0f00a;
    color: #757575;
    font-size: 12px;
    font-weight: 500;
    width: 100%;
    /* backdrop-filter: blur(5px); */
    border-radius: 4px !important;
    padding: 0 8px;
}

body.light_theme .trade-wrapper select {
    background: #F6F6F7;
    color: #545454;
}

body.light_theme .trade-wrapper .nice-select {
    background: #F6F6F7;
    color: #545454;
}

.trade-wrapper select *,
.trade-wrapper .nice-select * {
    /* font-size: 13px; */
    color: #ffffff !important;
    background: #000;
}

body.light_theme.trade-wrapper select *,
body.light_theme.trade-wrapper .nice-select * {
    color: #333333 !important;
    background: #ffffff;
}

.num-select,
.num-select:focus {
    box-shadow: none !important;
}

.btn-block {
    display: block;
}

small.note {
    font-size: 74%;
    display: block;
    text-align: center;
    margin: 18px 12px 0;
    line-height: 1.2;
}

.buy_sell_cards button {
    margin: 0px;
}

.btn-group.btn-group-mini label.last-child {
    text-align: right;
    width: auto;
}

.btn-group.btn-group-mini label.last-child::before {
    right: 0px;
    left: inherit;
}

.trade_assets {
    margin-top: 1rem;
}

.trade_assets .product-owner {
    padding: 0.5rem 0;

    border-bottom: 1px solid #2f2f39;
}

.trade_assets .product-owner:last-child {
    border-bottom: 0;
}

body.light_theme.trade_assets .product-owner {
    border-color: rgb(0 0 0 / 5%);
}


.trade_card table.table,
.trade_card tbody tr:hover {
    background-color: transparent !important;
}


.form-select-sm {
    padding: 9px 6px !important;
    height: unset !important;
    /* width: min-content !important; */
    /* min-width: unset !important; */
}

/* .treade_card_header.tch_main_tab {
    display: none;
} */

.trade_card .table> :not(caption)>*>* {
    padding: .5rem .5rem;
    line-height: 1.5 !important;
    vertical-align: middle;
    font-size: 11px;
    font-weight: 400;
}

.trade-wrapper .orderbook-table {
    position: relative;
}

.trade-wrapper .orderbook-table th {
    font-size: 12px;
    align-items: start !important;
    font-weight: 500;
    font-family: "Inter", sans-serif;
    color: #87909F;
    position: static;
    padding: 4px 12px;
    top: 0;
    z-index: 5;
    background-color: #181a20 !important;
}


.trade_card .table>.btn {
    margin: 0;
}


.spot-container-main .bottom {
    display: flex;
    min-height: 500px;
    /*border-top: 1px solid #191e23;*/
    flex: 1 1;
}


.bottom-left {
    width: calc(100% - 380px);
}

.bottom-right {
    width: 380px;
}

ul.nav.custom-tabs.order_his_tabs li {
    max-width: -webkit-fill-available;
    width: auto;
    padding: 0;
}

ul.nav.custom-tabs.order_his_tabs {
    justify-content: flex-start;
}

ul.nav.custom-tabs.order_his_tabs li a {
    padding: 8px 13px;
    height: unset !important;
    line-height: 1;
}

.ant-list-item {
    display: flex;
    height: 42px;
    padding: 5px 16px;
    cursor: pointer;
}

.rankItem {
    height: 27px;
    line-height: 12px;
    width: 144px;
}





/* .spotLists {
    width: 360px;
    min-height: 360px;
    max-width: calc(100% - 12px);
    padding-bottom: 10px;
    overflow-y: auto;
    overflow-x: hidden; 
    position: absolute;
    top: 128px;
    left: 12px;
    z-index: 111111;
    border-radius: 9px;
    display: none;
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
    padding: 0;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
} */

.spotLists {
    width: 100%;
    min-height: 360px;
    max-width: calc(100% - 12px);
    padding-bottom: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    /* background: #ffffff12; */
    /* position: absolute; */
    /* top: 128px; */
    /* left: 12px; */
    z-index: 111111;
    border-radius: 9px;
    display: none;
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
    padding: 0;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    max-width: 550px;
}


.spotLists.active {

    display: block !important;

}

.show_spot {
    display: block !important;
}

.spotList .scroll_y {
    height: 357px;
}

.spot-list {
    position: absolute;
    left: 0;
    top: 0;
    width: 360px;
    min-height: 100%;
    background: #1f252a;
}

.spot-list-search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 10px;
    padding-top: 0;
}

.spot-list-search .ivu-input {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0 12px;
}

body.light_theme.spot-list-search .ivu-input {
    background: rgb(241 244 244);
    border: 1px solid rgb(241 244 244);
}

.container-chart-briefing-info h6 {
    font-size: 16px;
}

.spot-list-search i {

    margin-right: 14px;
}

.spot-list-search .ivu-input input {
    background: transparent;
    border: 0;
    outline: 0 !important;
    color: var(--white-color);
    padding: 6px 3px;
    font-size: 14px;
    width: 100%;
}

body.light_theme .spot-list-search .ivu-input input {
    color: #424242;
}

.spot-list-search .ivu-input input:focus {
    border: none !important;

}

.price_card {
    padding: 10px 0;
    padding: 0;
}

.price_card .price_card_head {
    padding: 0 15px;
}

.price_card_body {
    padding: 0 10px;
}

.trade_history_tab .price_card_body {
    padding: 0 15px;
}

/* Buy-only / sell-only order book (IDs removed; use .orderbook-single-side) */
.price_card_body.scroll_y.center_cntr.orderbook-single-side {
    justify-content: start;
}

.subhead_cntr {
    font-size: 12px;
    font-weight: 400;
    justify-content: start;
    text-align: left;
    line-height: 15px;
    color: #fff;
}

span.tokensubcnt {
    color: #949AA4;
    font-size: 12px;
}

.trade_favourites_lft img.round_img {
    width: 24px !important;
    height: 24px !important;
    min-width: 24px;
}

.price_cntr_star i {
    color: #565A62;
    font-size: 17px !important;
}

.trade_favourites_lft .price_item_value {
    padding: 10px
}

.price_cntr_star {
    gap: 7px;
}

.trade_history_tab .price_card_head {
    padding: 0px 15px;
}

.price_card_body.scroll_y {
    padding-right: 5px;
    padding-left: 5px;
}

.price_item_value .ri-xl {
    font-size: 116%;
}

.spot-list-search .ivu-input::placeholder {
    color: #ffffffde;
}

.buy_sell_cards ul.nav.custom-tabs li a.active {
    color: #000 !important;
    background-color: #fea903 !important;
}


body.light_theme.container-chart-briefing .spotList {
    background: #ffffff;
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
}


.trade-wrapper .favouriteData {
    text-align: center;
    padding: 5% 0;
    /* font-size: 300%; */
}

html[data-theme='dark'] .trade-wrapper .favouriteData p {
    color: #ffffff;
    margin: 10px 0px;
}


.scroll_y .favouriteData {
    height: 100%;
}


.btn.btn-warning {
    background-color: #f3bb2b !important;
    color: #222222 !important;
    border-radius: 50px !important;
}

.mrkt_trde_tab {
    display: flex;
    align-items: center;
    justify-content: start !important;
    font-size: 18px;
    font-family: "Inter", sans-serif;
    padding: 8px 15px;
    margin: 00;
    text-align: left;
    background: #22242c00;
}

.mrkt_trde_tab b.text-green {
    font-weight: 700;
}

.option_datatable_bl .classic_favorites_bl .order_trade_s .table-trade {
    padding: 0px 0px;
}

.option_datatable_bl .order_trade_s .buy_sell_row {
    padding: 10px 10px 0px;
}

.option_datatable_bl .order_trade_s .price_card_head {
    padding: 0px 10px;
}

.option_datatable_bl .buy_sell_row_price .scroll_y {
    padding: 0px 10px;
    height: 218px;
}

.trade-wrapper .text-success {
    color: #01BC8D !important;
}

body.light_theme.mrkt_trde_tab {
    background: #f5f5f5;
}

.buysellform .input-group {
    padding: 3px 10px;
    display: flex;
    align-items: center;
    background: #2B313C;
    border: 1px solid #2d303a00;
    border-radius: 6px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

body.light_theme.buysellform .input-group {
    background: rgb(245 245 245);
    border: 1px solid rgb(234 239 244);
}

.trade-wrapper.spot .tab-content>.tab-pane {
    height: 100% !important;
}


.buysellform .input-group .form-control {
    background: transparent;
    border: 0;
    padding-left: 0;
    font-weight: 500;
    padding-right: 0;
    border-radius: 0 !important;
    font-size: 14px !important;
    -webkit-backdrop-filter: unset !important;
            backdrop-filter: unset !important;
    color: #ffffff !important;
}

.buysellform .input-group .form-control::placeholder {
    color: #ffffff !important;
    opacity: 1;
}

body.light_theme .buysellform .input-group .form-control {
    color: #070808 !important;
}

body.light_theme .buysellform .input-group .form-control::placeholder {
    color: #9e9e9e !important;
}

.trade_card .table> :not(caption)>*>* {
    font-size: 11px;
    background-color: transparent;
    color: #F2F4F6;
}

table.table tbody tr:last-child td .favouriteData p {
    font-size: 14px;
}

.buysellform .input-group .input-group-text:not(.trade_amt_denom_addon),
.buysellform .input-group .input-group-text:not(.trade_amt_denom_addon) * {
    padding: 0;
    margin: 0;
    text-align: right !important;
    display: block;
}

/* Amount BTC/USDT picker: exclude from rule above so flex + padding work; dropdown not clipped */
.spot .trade_amount_field_wrap,
.spot .trade_amount_field_limit.input-group,
.buy_spot_form .trade_amount_field_limit.input-group,
.sell_spot_form .trade_amount_field_limit.input-group {
    overflow: visible;
    position: relative;
}

.agcx-ft-amt-hint {
    position: absolute;
    left: 10px;
    bottom: calc(100% - 8px);
    z-index: 30;
    max-width: calc(100% - 12px);
    padding: 6px 8px;
    border-radius: 4px;
    background: #3d3d3d;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}

.agcx-ft-amt-hint::after {
    content: "";
    position: absolute;
    left: 18px;
    bottom: -5px;
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: #3d3d3d transparent transparent;
}

.trade_amount_field_wrap .trade_amt_denom_addon {
    text-align: left !important;
}

.trade_price_field.is-error,
.input-group.trade_amount_field_limit.is-error {
    border-color: #f6465d !important;
}

.trade_field_error {
    margin: 6px 2px 0;
    color: #f6465d;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
}

/* Spot order form — Price field (value | quote | up/down stepper) */
.trade_price_field_wrap label {
    font-family: "Inter", sans-serif;
}

.trade_price_field {
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
    width: 100%;
    height: 40px;
    padding: 1px 1px 1px 12px;
    box-sizing: border-box;
    background: #2b313d;
    border: 1px solid transparent;
    border-radius: 8px;
    font-family: "Inter", sans-serif;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

body.theme-light .trade_price_field {
    background: #F6F6F7;
}

body.theme-dark .trade_price_field {
    background: #2b313d;
}

.trade_price_field:focus-within:not(.is-readonly),
.buysellform .input-group:focus-within {
    border-color: #d1aa67 !important;
    box-shadow: 0 0 0 0px #d1aa67;
}

.trade_price_field.is-readonly {
    opacity: 0.95;
}

.trade_price_input {
    flex: 1 1 auto;
    min-width: 0;
    border: 0;
    outline: none;
    background: transparent;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    padding: 0 8px 0 0;
    line-height: 1.25;
}

.trade_price_input::placeholder {
    color: #ffffff;
    opacity: 1;
}

body.light_theme .trade_price_input {
    color: #070808
}

body.light_theme .trade_price_input::placeholder {
    color: #9e9e9e;
}

.trade_price_field.is-readonly .trade_price_input {
    font-weight: 500;
    color: #ffffff;
    cursor: default;
}

body.light_theme .trade_price_field.is-readonly .trade_price_input {
    color: #C3C6C8;
}

.trade_card.trade_chart img.light_img {
    filter: invert(1);
}

body.light_theme .trade_card.trade_chart img.light_img {
    filter: invert(0);
}

.trade_price_suffix {
    display: inline-flex;
    align-items: center;
    padding: 0 0px 0 4px;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0px;
    color: #b4b4b4;
    text-transform: uppercase;
    flex-shrink: 0;
    font-family: "Inter", sans-serif;
}

body.light_theme .trade_price_suffix {
    color: #070808;
}

.trade_price_stepper {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 36px;
    border-left: 1px solid #dfe0e230;
    margin-left: 7px;
}

body.light_theme .trade_price_stepper {
    border-left: 1px solid #DFE0E2;
}

.bs_dropbox .trade_card.trade_chart.buysell_card .mb-3 {
    margin-bottom: 0.7rem !important;
    opacity: 1;
}

.limit_buy_extras.selllimitslidetab .trade_pct_track_line {
    top: 23px;
}

.market_pct_slider_row.selllimitslidetab .trade_pct_track_line {
    top: 23px;
}

.trade_price_step_btn {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 18px;
    border-bottom: 1px solid #dfe0e203 !important;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    color: inherit;
}

body.light_theme .trade_price_step_btn {
    border-bottom: 1px solid #DFE0E2 !important;
}

button.trade_price_step_btn.lastbtnprice {
    border-bottom: none !important;
}

.trade_price_step_btn:hover {
    background: rgba(255, 255, 255, 0.06);
}

.trade_price_step_btn+.trade_price_step_btn {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.trade_price_step_icon {
    display: block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
}

.trade_price_step_up {
    border-bottom: 5px solid #9ca3af;
}

.trade_price_step_down {
    border-top: 5px solid #9ca3af;
}

/* Buy tab — Limit order layout (mobile / light screenshot) */
.spot_limit_tabs_row .spot_limit>button {
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    padding: 4px 2px 6px;
    font-size: 13px;
    font-weight: 500;
    color: #84888c;
    font-family: "Inter", sans-serif;
}

.spot_limit_tabs_row .spot_limit>button.active {
    color: #f2f4f6;
}

.buy_spot_form .trade_total_field_wrap .trade_total_field,
.sell_spot_form .trade_total_field_wrap .trade_total_field {
    border-radius: 8px;
    overflow: hidden;
}

.buy_spot_form .trade_total_min_hint,
.sell_spot_form .trade_total_min_hint {
    margin-top: 6px;
    font-size: 12px;
    color: #9ca3af;
    font-family: "Inter", sans-serif;
}


.trade_amount_field_wrap .trade_amount_field_limit .trade_amount_coin_badge small {
    font-weight: 500;
    color: #c5c5c5;
}

body.light_theme .trade_amount_field_wrap .trade_amount_field_limit .trade_amount_coin_badge small {
    color: #111827
}

html[data-theme="dark"] .trade_amount_field_wrap .trade_amount_field_limit .trade_amount_coin_badge small {
    color: #f2f4f6;
}

.limit_buy_extras {
    margin-bottom: 8px;
    margin-top: -7px;
}

.limit_buy_slider_row {
    margin-top: 4px;
}

.limit_buy_avail .stop_plus {
    display: none;
}

.limit_buy_avail .stop_avail_rgt {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex: 1 1;
    min-width: 0;
}

.limit_buy_avail .stop_avail_val {
    display: inline-flex;
    align-items: center;
    line-height: 1.25;
}

.limit_buy_plus {
    flex-shrink: 0;
    font-weight: 700;
    padding: 0;
    background: none;
    filter: invert(1);
    align-self: center;
    box-sizing: border-box;
}

.limit_buy_checks {
    margin-bottom: 4px;
}

.stop_check span {
    -webkit-text-decoration: underline dashed;
            text-decoration: underline dashed;
    text-underline-offset: 3px;
}

.trade_maker_taker_fees {
    text-align: center;
    font-size: 12px;
    color: #6b7280;
    margin: 10px 0 4px;
    font-family: "Inter", sans-serif;
}

ul.assets_panel_asset_rows span {
    color: #fff !important;
}

body.light_theme ul.assets_panel_asset_rows span {
    color: #070808 !important;
}

.trade_maker_fees_split {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
}


.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
    border-radius: 2px;
    margin: 0px;
    background: transparent !important;
    line-height: 1;
}


.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li {
    max-width: -moz-fit-content;
    max-width: fit-content;
}

.buy_sell_row.buy_sell_cards ul.nav.custom-tabs {
    justify-content: end;
    gap: 16px;
}

.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li button {
    opacity: 0.40;
}

.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li.activepop button {
    opacity: 1 !important;
}


.buy_sell_row h6 {
    font-size: 12px;
}

.buy_sell_row {
    border-bottom: 1px solid #ffffff1a;
    margin-bottom: 10px;
    padding: 10px 10px;
}

body.light_theme.buy_sell_row {
    border-bottom: 1px solid #d2e4ff;
}

.actv_data p,
.actv_data span {
    font-size: 13px;
}


.trade-wrapper .row {
    margin-left: -5px;
    margin-right: -5px;
}

/* .trade-wrapper .row > * {
        padding-left: 5px;
        padding-right: 5px;
    }
   */
.trade-wrapper .mb-1 {
    margin-bottom: 5px !important;
}

.num-select {
    padding: 0 16px 0 0 !important;
    background-color: transparent !important;
    border: 0 !important;
    width: auto !important;
    min-width: 44px !important;
    outline: 0 !important;
    box-shadow: none !important;
    text-align: left;
    height: auto !important;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
    cursor: pointer;
    color-scheme: dark;
    color: #848e9c;
}

.num-select,
.num-select:focus,
.num-select:active {
    outline: none !important;
    box-shadow: none !important;
}

.num-select option {
    background-color: #181a20 !important;
    color: #eaecef !important;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
}

.num-select option[value="BUY"] {
    color: #0ecb81 !important;
}

.num-select option[value="SELL"] {
    color: #f6465d !important;
}

.num-select option:hover,
.num-select option:focus,
.num-select option:checked {
    background-color: #2b313a !important;
}

body.light_theme .num-select,
html[data-theme='light'] .num-select {
    color-scheme: light;
    color: #1e2329 !important;
}

body.light_theme .num-select option,
html[data-theme='light'] .num-select option {
    background-color: #ffffff !important;
    color: #1e2329 !important;
}

body.light_theme .num-select option[value="BUY"],
html[data-theme='light'] .num-select option[value="BUY"] {
    color: #0ecb81 !important;
}

body.light_theme .num-select option[value="SELL"],
html[data-theme='light'] .num-select option[value="SELL"] {
    color: #f6465d !important;
}

body.light_theme .num-select option:hover,
body.light_theme .num-select option:focus,
body.light_theme .num-select option:checked,
html[data-theme='light'] .num-select option:hover,
html[data-theme='light'] .num-select option:focus,
html[data-theme='light'] .num-select option:checked {
    background-color: #f5f5f5 !important;
}

.num-div {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    background-color: transparent;
    padding: 0;
    border-radius: 4px;
}

.num-div .num-select {
    font-size: 12px;
    font-weight: 500;
}

.num-div:after {
    display: none;
}

.trade_favourites_lft.is-open .pair-color {
    font-weight: 500;
}

.trade_summary_table_lft .num-div {
    background-color: transparent;
}

.freerate {
    background-color: #2B313C;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 10px 20px;
    border-radius: 4px;
    font-size: 12px;
    margin: 20px 0px 10px;
}

.freerate span {
    color: #949AA4;
}

body.light_theme .num-div:after {
    color: #333;
}

body.light_theme .num-div {
    background: transparent;
    color: #333 !important;
}

body.light_theme .num-div select {
    color: #333 !important;
}

.actv_sorting strong {
    font-weight: 600;
}


.price_item_value.active {
    background: #2B313C;
}

body.light_theme.price_item_value.active {
    background: #0000000d;
}

.trade_favourites_lft .spot-list-search .ivu-input {
    background: #565A62;
    border: none;
    border-radius: 8px;
    padding: 3px 12px;
}

.trade_favourites_lft .spot-list-search i {
    margin-right: 5px;
    color: #a9a9a9;
}

.trade-wrapper table tr td {
    font-size: 12px !important;
    font-weight: 500 !important;
    padding: 1px 10px !important;
    font-family: "Inter", sans-serif;
}

.trade-wrapper table tr td small {
    font-size: 12px;
}

.trade_favourites_lft .price_card_body {
    padding: 0px;
}

.trade_card.p-3 {
    padding: 11px !important;
}

.trade_favourites_lft .price_card .price_card_head {
    padding: 0 10px;
}

.assets_right .assets_list {
    margin: 10px 0px;
    padding-bottom: 2px;
}

.trade-wrapper .assets_right table tr td {
    padding: 5px 10px !important;
}


.assets_right .price_card_body.scroll_y {
    padding-right: 0px;
    padding-left: 0px;
}

/* trade new css */

.mt_tr_pr {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.assets_right .assets_panel_asset_sym {
    font-weight: 600;
}

/* Desktop Assets panel (lg+) — summary, pill actions, asset rows */
.assets_right.assets_panel_desktop {
    padding: 11px 0px 20px;
    background: #181a20;
    border-radius: 8px;
}

.assets_panel_inner {
    display: flex;
    flex-direction: column;
}

.assets_panel_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    border-bottom: 1px solid #d1d5db2e;
    padding: 0px 16px 6px;
}

body.light_theme .assets_panel_header {
    border-bottom: 1px solid #EDEFF2;
}

.no-data-row img {
    filter: invert(1);
}

body.light_theme .no-data-row img {
    filter: invert(0);
}

body.light_theme .no-data-row svg {
    filter: invert(0);
}

.assets_panel_title {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #f5f5f5;
    font-family: "Inter", sans-serif;
}

.assets_panel_refresh {
    border: none;
    background: transparent;
    color: #8e949e;
    padding: 4px;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px;
}

.assets_panel_refresh:hover {
    color: #eaecef;
}

.assets_balance_rows {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
    padding: 0px 16px;
}

.assets_balance_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.assets_balance_label {
    font-size: 11px;
    color: #848e9c;
    font-weight: 400;
}

.assets_balance_val {
    font-size: 11px;
    font-weight: 500;
    color: #eaecef;
    font-family: "Inter", sans-serif;
}

.assets_panel_actions {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    margin-bottom: 18px;
    padding: 2px 16px;
}

.assets_panel_pill {
    flex: 1 1;
    text-align: center;
    padding: 7px 8px;
    border-radius: 999px;
    background: #2b3138;
    color: #f5f5f5 !important;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none !important;
    font-family: "Inter", sans-serif;
    transition: background 0.15s ease;
}

.assets_panel_list_card {
    padding-top: 0px;
    padding: 0px 16px;
}


.col-12.mmn_btm_minus_spc {
    width: 37%;
}

.midgraph_col {
    width: 63%;
}

.assets_panel_pill:hover {
    background: #343b45;
    color: #fff !important;
}

.assets_panel_list_card {
    padding-top: 0px;
}

.assets_panel_list_head {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: #848e9c;
    margin-bottom: 8px;
    padding: 0 2px;
    font-weight: 500;
}

.assets_panel_list_head span:last-child {
    text-align: right;
}

.assets_panel_asset_rows {
    list-style: none;
    padding: 0;
    margin: 0;
    /* max-height: 240px; */
    overflow-y: auto;
}

.assets_panel_asset_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.assets_panel_asset_row:last-child {
    border-bottom: none;
}

.assets_panel_asset_left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.assets_panel_coin_icon {
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.assets_panel_asset_meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.assets_panel_sym {
    font-size: 13px;
    font-weight: 700;
    color: #eaecef;
    font-family: "Inter", sans-serif;
}

.assets_panel_full {
    font-size: 11px;
    color: #848e9c;
    font-weight: 500;
}

.assets_panel_bal {
    font-size: 13px;
    font-weight: 600;
    color: #eaecef;
    text-align: right;
    font-family: "Inter", sans-serif;
}

.assets_panel_loading,
.assets_panel_login_hint {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 28px 12px;
    text-align: center;
}

.assets_panel_login_text {
    font-size: 13px;
    color: #848e9c;
    margin: 0;
}

.assets_panel_empty {
    padding: 16px 0;
    text-align: center;
    list-style: none;
    border-bottom: none !important;
}

.mt_tr_pr .headline_bigName__dspVW i.faaa {
    font-size: 20px;
    opacity: 0.8;
    font-weight: 300;
    cursor: pointer;
    margin-left: 6px;
}

.mt_tr_pr .headline_bigName__dspVW i.ri-menu-add-line:hover {
    opacity: 1;
}

.spot-container {
    max-width: 1520px;
}

.bs_dropbox .summay_dasboard_pop {
    display: none !important;
}

.bs_dropbox .row .col-lg-6 {
    width: 100% !important;
    padding: 0px;
}


.bs_dropbox .trade_card.trade_chart.buysell_card {
    width: 97.5%;
    height: 660px;
    position: relative;
    left: 3px;
    overflow: auto;
}

.treade_card_header {
    border-bottom: 1px solid #47484a !important;
    display: flex;
    align-items: center;
    padding-inline-start: 5px;
    flex-shrink: 0;
    width: 100%;
    gap: 10px;
    justify-content: space-between;
}

body.light_theme .treade_card_header {
    border-bottom: 1px solid #F2F3F4 !important;
}

.treade_card_header.buysell_heder {
    border-bottom: none !important;
}

.menuitem {
    display: flex;
}

.treade_card_header .toggle_dotted {
    width: 10px;
    cursor: pointer;
    color: #8E949E;
    width: 24px;
}

body.light_theme .trade_favourites_lft .spotLists {
    background: #fdfdfd;
}

.tch_main_tab {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
}

.tch_main_tab::-webkit-scrollbar {
    display: none;
}

body.light_theme .treade_card_header,
body.light_theme .price_card_head {
    border-bottom: none;
    opacity: 1;
    padding-bottom: 0px !important;
}

body.light_theme .card_header_title:before {
    background-color: #d1aa67;
}

body.light_theme .card_header_title.active {
    color: #070808;
}


body.light_theme .headline_left__lBBPY .headline_symbolName__KfmIZ {
    color: #262626;
}

body.light_theme ul.favorites_list_tabs li button.active {
    color: #525252;
    border-bottom: none;
}

.card_header_title {

    padding: 10px 10px;
    cursor: pointer;
    position: relative;
    font-family: "Inter", sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #84888C;
}

.trade_favourites_lft .spotLists {
    display: block;
    border-radius: 0px;
    height: 99.6%;
    padding-top: 12px;
}

.trade-wrapper .table-responsive {
    min-height: 300px;
    max-height: 700px;
}

.trade-wrapper div#tab_3.d-none.d-lg-block .table-responsive {
    min-height: 570px;
}

.trade-wrapper div#tab_3.d-none.d-lg-block tr.no-data-row {
    width: 100%;
    height: 100%;
    text-align: center;
    display: table-row !important;
}

.trade_card button.btn.btn-success {
    color: #fff !important;
    background-color: #5EBA89 !important;
    border-radius: 50px;
    font-size: 12px;
    padding: 7px 16px;
    border-color: #5EBA89;
}

.trade_card small {
    font-size: 13px;
    color: #afafaf;
    padding-bottom: 10px;
    margin-bottom: 0px !important;
    display: block;
}

body.light_theme .limit_buy_plus img {
    filter: invert(1);
}

body.light_theme .trade_card small {
    color: #070808;
}

button.agce-margin-leverage-trigger-btn1 {
    cursor: pointer !important;
}

.spot_limit .d-flex.justify-content-between {
    width: 100%;
}

.spot_limit {
    border-bottom: none;
    position: relative;
    gap: 15px !important;
    width: 100%;
}

.spot_limit button {
    background: transparent;
    border: 0;
    border-bottom: none;
    position: relative;
    padding: 4px 2px 6px;
    font-size: 13px;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    color: #84888C;
}

.spot_limit button:before {
    content: "";
    content: "";
    position: absolute;
    content: " ";
    min-width: 30px;
    /* max-width: 32px; */
    height: 3px;
    border-radius: 10px;
    background-color: #d1aa67;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%) scaleX(.5);
    opacity: 0;
    transition: all .16s ease-in;
}

.spot_limit button.active:before {
    opacity: 1;
}

h3.headingspot {
    font-size: 13px;
    font-weight: 600;
    font-family: "Inter", sans-serif;
    color: #84888C;
    margin: 0px;
    padding: 14px 0px 14px 14px;
}

.spot_limit button.active {
    color: #fff;
}

/* Spot tabs dropdown (Conditional) */
.spot_limit_dropdown {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.spot_limit .spot_limit_dd_btn {
    background: transparent;
    border: 0;
    position: relative;
    padding: 4px 0 8px;
    font-size: 13px;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    color: #84888C;
    display: inline-flex;
    align-items: center;
    gap: 0px;
}

.info_icon {
    color: #84888C;
}

/* Trade Info Tooltip */
.trade-info-tooltip-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}

.trade-info-tooltip-wrapper .trade-info-tooltip {
    position: absolute;
    top: calc(100% + 10px);
    right: -10px;
    width: 240px;
    background-color: #1E2329;
    color: #84888C;
    padding: 12px;
    border-radius: 6px;
    font-size: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease-in-out;
    z-index: 1000;
    border: 1px solid #2B3139;
    text-align: left;
}

body.light_theme .trade-info-tooltip-wrapper .trade-info-tooltip {
    background-color: #FFFFFF;
    color: #474D57;
    border: 1px solid #EAECEF;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.trade-info-tooltip-wrapper:hover .trade-info-tooltip {
    opacity: 1;
    visibility: visible;
    top: calc(100% + 5px);
}

.trade-info-tooltip::after {
    content: '';
    position: absolute;
    bottom: 100%;
    right: 15px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #1E2329 transparent;
}

body.light_theme .trade-info-tooltip::after {
    border-color: transparent transparent #FFFFFF transparent;
}

.trade-info-tooltip .tooltip-item {
    margin-bottom: 8px;
    line-height: 1.4;
}

.trade-info-tooltip .tooltip-item:last-child {
    margin-bottom: 0;
}

.trade-info-tooltip .tooltip-item strong {
    color: #EAECEF;
    font-weight: 500;
}

body.light_theme .trade-info-tooltip .tooltip-item strong {
    color: #1E2329;
}

.d-flex.spottabs_top {
    border-bottom: 1px solid #47484a;
}

body.light_theme .d-flex.spottabs_top {
    border-bottom: 1px solid #EDEFF2;
}

.spot_limit .spot_limit_dd_btn i {
    font-size: 18px;
    line-height: 1;
}

.spot_limit .spot_limit_dd_btn.active {
    color: #fff;
}

.assets_panel_balance_row {
    font-size: 11px;
    display: flex;
    justify-content: space-between;
    gap: 12px;
}

.assets_panel_balances {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.spot_limit_dd_menu {
    position: absolute;
    top: calc(100% + 0px);
    left: 0;
    min-width: 140px;
    background: #2a303a;
    border: 1px solid rgba(15, 23, 43, 0.08);
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    padding: 15px;
    z-index: 9999;
}

body.light_theme .spot_limit_dd_menu {
    background: #ffffff;
}

.spot_limit_dd_item {
    width: 100%;
    border: 0;
    background: transparent;
    text-align: left;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #303236;
    cursor: pointer;
}

.spot_limit.d-flex.align-items-center.flex-nowrap.margin_surface_tab_strip .spot_limit_dropdown {
    display: none;
}

.limit_markettabs.margin-surface-tabs {
    padding-bottom: 0px;
}

/* .spot_limit_dd_item:hover {
    background: #f5f5f5;
} */

/* Order book aggregation (0.1 / 0.5 / 1 / 10 / 100) */
.orderbook_agg_dd {
    position: relative;
    flex-shrink: 0;
}

.orderbook_agg_dd_trigger {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 2px 4px 8px;
    border: 0;
    background: transparent;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
}

body.light_theme .orderbook_agg_dd_trigger {
    color: #070808;
}

.orderbook_agg_dd_value {
    color: #fff;
    line-height: 1;
}

body.light_theme .orderbook_agg_dd_value {
    color: #070808;
}

.orderbook_agg_dd_caret {
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #fafafa;
    transition: transform 0.15s ease;
}

body.light_theme .orderbook_agg_dd_caret {
    border-top: 5px solid #070808;
}

.orderbook_agg_dd_caret.is-open {
    transform: rotate(180deg);
}

.orderbook_agg_dd_menu {
    position: absolute;
    right: 0;
    top: calc(100% + 6px);
    z-index: 10050;
    min-width: 70px;
    margin: 0;
    padding: 0px 0;
    list-style: none;
    background: #2b313c;
    border-radius: 8px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);
}

body.light_theme .orderbook_agg_dd_menu {
    background: #fff;
}

.orderbook_agg_dd_item {
    display: block;
    width: 100%;
    padding: 7px 18px;
    border: 0;
    background: transparent;
    text-align: left;
    font-size: 12px;
    font-weight: 500;
    color: #e3e3e3;
    cursor: pointer;
}

body.light_theme .orderbook_agg_dd_item {
    color: #111827;
}

.orderbook_agg_dd_item:hover {
    background: rgba(0, 0, 0, 0.04);
}

/* Order book view toggles (split / bids / asks) — buttons match former tab links */
.buy_sell_cards ul.nav.custom-tabs.nav_order li button.orderbook-view-toggle {
    display: block;
    width: 100%;
    text-align: center;
    border-radius: 40px;
    padding: 4px 0px;
    color: #fff;
    background-color: transparent;
    font-size: 13px;
    font-weight: 600;
    margin: 0px;
    border: 0;
    cursor: pointer;
    line-height: 1;
}

.buy_sell_cards ul.nav.custom-tabs.nav_order li button.orderbook-view-toggle img {
    display: block;
    margin: 0 auto;
    vertical-align: middle;
}

/* Active toggle — mode-specific rings (Binance-style): split / bids / asks */
.buy_sell_cards ul.nav.custom-tabs.nav_order li.fav-tab.activepop button.orderbook-view-toggle {
    /* background: rgba(255, 255, 255, 0.14) !important; */
    /* box-shadow: 0 0 0 1px rgba(148, 154, 164, 0.55), inset 0 0 0 1px rgba(255, 255, 255, 0.06); */
    color: #e9e9e9 !important;
}

.buy_sell_cards ul.nav.custom-tabs.nav_order li.usdt-tab.activepop button.orderbook-view-toggle {
    /* background: rgba(1, 188, 141, 0.14) !important;
    box-shadow: 0 0 0 1.5px #01bc8d, 0 0 0 3px rgba(1, 188, 141, 0.22); */
    color: #e9e9e9 !important;
}

.buy_sell_cards ul.nav.custom-tabs.nav_order li.btc-tab.activepop button.orderbook-view-toggle {
    /* background: rgba(228, 85, 97, 0.14) !important; */
    /* box-shadow: 0 0 0 1.5px #e45561, 0 0 0 3px rgba(228, 85, 97, 0.2); */
    color: #e9e9e9 !important;
}

body.light_theme .buy_sell_cards ul.nav.custom-tabs.nav_order li button.orderbook-view-toggle {
    /* background-color: #f1f4f4; */
    color: rgba(0, 0, 0, 0.75);
}

body.light_theme .buy_sell_cards ul.nav.custom-tabs.nav_order li.fav-tab.activepop button.orderbook-view-toggle {
    /* background: #f1f4f4 !important; */
    /* box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14); */
    color: #070808 !important;
}

body.light_theme .buy_sell_cards ul.nav.custom-tabs.nav_order li.usdt-tab.activepop button.orderbook-view-toggle {
    /* background: #ecf9f3 !important;
    box-shadow: 0 0 0 1.5px #01bc8d, 0 0 0 3px rgba(1, 188, 141, 0.18); */
    color: #070808 !important;
}

body.light_theme .buy_sell_cards ul.nav.custom-tabs.nav_order li.btc-tab.activepop button.orderbook-view-toggle {
    /* background: #ffedf0 !important; */
    /* box-shadow: 0 0 0 1.5px #e45561, 0 0 0 3px rgba(228, 85, 97, 0.16); */
    color: #070808 !important;
}

.buy_sell_cards ul.nav.custom-tabs.nav_order li.btc-tab button.orderbook-view-toggle,
.buy_sell_cards ul.nav.custom-tabs.nav_order li button.orderbook-view-toggle--last {
    margin-inline-end: 0;
}

.orderbook-single-side {
    box-sizing: border-box;
}

/* —— Binance-style order book (screenshot match): grey headers, swap, neutral Amount/Total —— */
.orderbook-table--ss .orderbook-thead {
    display: table-header-group;
}

.orderbook-table--ss th.orderbook-th-sticky {
    position: sticky;
    top: 0;
    z-index: 11;
    background: var(--bs-body-bg, #181a20);
    font-size: 12px;
    font-weight: 500;
    color: #848e9c !important;
    border: 0;
    padding: 6px 10px;
    vertical-align: middle;
    font-family: "Inter", sans-serif;
}

body.light_theme .orderbook-table--ss th.orderbook-th-sticky {
    background: #ffffff !important;
    color: #848e9c !important;
}

.orderbook-th-total-inner {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    width: 100%;
    flex-wrap: nowrap;
}

.orderbook-col-swap-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    margin: 0;
    border: 0;
    background: transparent;
    color: #848e9c;
    cursor: pointer;
    line-height: 1;
    font-size: 14px;
    flex-shrink: 0;
}

.orderbook-col-swap-btn:hover {
    color: #01bc8d;
}

.orderbook-table--ss tbody td.orderbook-col-num {
    color: #eaecef;
    font-variant-numeric: tabular-nums;
    font-weight: 500;
}

body.light_theme .orderbook-table--ss tbody td.orderbook-col-num {
    color: #1e2329 !important;
}

.orderbook-table--ss .orderbook-depth-text {
    color: #eaecef !important;
    font-variant-numeric: tabular-nums;
    font-weight: 500;
}

body.light_theme .orderbook-table--ss .orderbook-depth-text {
    color: #1e2329 !important;
}

.orderbook-col-price--bid {
    color: #01bc8d !important;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.orderbook-col-price--ask {
    color: #e45561 !important;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.orderbook-mid-price--ss .orderbook-mid-main {
    font-size: 1.25rem;
    font-weight: 700;
    letter-spacing: -0.02em;
}

.orderbook-mid-price--ss .orderbook-mid-arrow {
    font-size: 1.1rem;
}

body.light_theme .orderbook-card--ss .price_card_body2,
body.light_theme .orderbook-card--ss {
    background: #ffffff;
}

/* Order book depth (Total column) + bid/ask ratio */
.orderbook-depth-cell {
    position: relative;
    overflow: hidden;
    text-align: right !important;
    vertical-align: middle;
    padding-right: 10px !important;
}

.orderbook-depth-fill {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    max-width: 100%;
    pointer-events: none;
    z-index: 0;
    /* border-radius: 2px 0 0 2px; */
}

.orderbook-depth-fill--ask {
    background: rgba(228, 85, 97, 0.16);
}

.orderbook-depth-fill--bid {
    background: rgba(1, 188, 141, 0.16);
}

body.light_theme .orderbook-depth-fill--ask {
    background: rgba(228, 85, 97, 0.12);
}

body.light_theme .orderbook-depth-fill--bid {
    background: rgba(1, 188, 141, 0.12);
}

.orderbook-depth-text {
    position: relative;
    z-index: 1;
}

.orderbook_bid_ask_footer {
    padding: 10px 12px 5px;
    border-top: none;
}



body.light_theme .orderbook_bid_ask_footer {
    border-top-color: rgba(0, 0, 0, 0.06);
}

.orderbook_bid_ask_labels {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    margin-bottom: 6px;
}

.orderbook_bid_ask_bar {
    display: flex;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    overflow: visible;
    gap: 4px;
    background: transparent;
}

body.light_theme .orderbook_bid_ask_bar {
    background: transparent;
}

.orderbook_bid_ask_seg {
    min-width: 0;
    height: 100%;
    border-radius: 2px;
}

.orderbook_bid_ask_seg--bid {
    background: #01bc8d;
}

.orderbook_bid_ask_seg--ask {
    background: #e45561;
}

.orderbook-mid-price {
    padding: 8px 12px;
    /* border-top: 1px solid rgba(255, 255, 255, 0.06);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06); */
}

body.light_theme .orderbook-mid-price {
    border-top-color: rgba(0, 0, 0, 0.06);
    border-bottom-color: rgba(0, 0, 0, 0.06);
}

.orderbook-mid-usd {
    font-weight: 600;
}

/* Sell-only / buy-only: list first, dashed rule, then mid price (mobile app style) */
.orderbook-section-dash {
    margin: 0px;
    height: 0;
    border: 0;
    border-top: none;
}

body.light_theme .orderbook-section-dash {
    border-top-color: rgba(0, 0, 0, 0.12);
}

.orderbook-mid-price--after-list {
    border-top: none !important;
    padding-top: 10px;
    padding-bottom: 10px;
}

/* Sell-only tab: brighter ask red, soft rose depth (screenshot match) */
.orderbook-asks-only .orderbook-col-price--ask {
    color: #f84960 !important;
    font-weight: 700;
}

.orderbook-asks-only .orderbook-depth-fill--ask {
    background: rgba(248, 73, 96, 0.14) !important;
}

body.light_theme .orderbook-asks-only .orderbook-depth-fill--ask {
    background: rgba(248, 73, 96, 0.1) !important;
}

.orderbook-asks-only .orderbook-mid-main.text-danger {
    font-size: 1.35rem;
}

.orderbook-asks-scroll,
.orderbook-bids-scroll {
    flex: 1 1 auto;
    min-height: 190px;
}

.orderbook-side-scroll {
    min-height: 190px !important;
}

/* Order book: center loader / empty state in the scroll pane; data rows stay top-aligned when class is absent */
.price_card_body.scroll_y.orderbook-side-scroll--placeholder,
.orderbook-ob-table-wrap.orderbook-side-scroll--placeholder {
    display: grid !important;
    place-items: center;
    align-content: center;
    justify-items: center;
    box-sizing: border-box;
}

.orderbook-side-scroll--placeholder>table.orderbook-table--ss,
.orderbook-ob-table-wrap.orderbook-side-scroll--placeholder>table.orderbook-table--ss {
    width: 100%;
    max-width: 100%;
    align-self: center;
    justify-self: center;
}

.orderbook-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 0;
    box-sizing: border-box;
    padding: 12px;
    text-align: center;
}

/* Theme-aware spinner — same colors as TV chart loader */
.agce-theme-spinner {
    width: 1.5rem;
    height: 1.5rem;
    border-color: rgba(255, 255, 255, 0.3) !important;
    border-right-color: transparent !important;
}

body.light_theme .agce-theme-spinner {
    border-color: rgba(0, 0, 0, 0.3) !important;
    border-right-color: transparent !important;
}

.spinner-border-sm.agce-theme-spinner {
    width: 1rem;
    height: 1rem;
}

/* Large layout bids-only: mid price row + table; center spinner in remaining area */
.orderbook-single-side.orderbook-bids-scroll .orderbook-ob-table-wrap {
    flex: 1 1 auto;
    min-height: 0;
}

/* Stop order (Stop Limit / Stop Market) blocks */
.stop_amt_suffix {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-width: 86px;
}

.stop_order_block {
    margin-top: 6px;
    margin-bottom: 12px;
}

.stop_slider_row {
    margin: 6px 0 10px;
}

/* Percent slider — process bar (active/inactive track, thumb, dots, Inter labels) */
.trade_pct_slider_row {
    margin: 0px 0 5px;
}

.trade_pct_slider_shell {
    --fill-pct: 25%;
    position: relative;
    width: 100%;
    padding: 6px 0 4px;
    font-family: "Inter", sans-serif;
}

.trade_pct_track_line {
    position: absolute;
    left: 9px;
    right: 7px;
    top: 17px;
    height: 1px;
    border-radius: 2px;
    background: linear-gradient(to right, #1e2329 0%, #1e2329 var(--fill-pct), #eaecef var(--fill-pct), #eaecef 100%);
    pointer-events: none;
    z-index: 0;
}

.trade_pct_slider_input {
    position: relative;
    z-index: 2;
    display: block;
    width: 100%;
    height: 38px;
    margin: 0;
    padding: 0 8px;
    box-sizing: border-box;
    background: transparent;
    appearance: none;
    cursor: pointer;
}

.trade_pct_slider_input:focus {
    outline: none;
}

.trade_pct_slider_input::-webkit-slider-runnable-track {
    height: 3px;
    background: transparent;
    border: none;
    border-radius: 2px;
}

.trade_pct_slider_input::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    margin-top: -5px;
    border-radius: 50%;
    background: #1e2329;
    border: 2px solid rgba(255, 255, 255, 0.35);
    box-shadow: 0 0 0 4px rgba(30, 35, 41, 0.12), 0 1px 3px rgba(0, 0, 0, 0.15);
}

.trade_pct_slider_input::-moz-range-track {
    height: 3px;
    background: transparent;
    border: none;
    border-radius: 2px;
}

.trade_pct_slider_input::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-radius: 50%;
    background: #1e2329;
    box-shadow: 0 0 0 4px rgba(30, 35, 41, 0.12);
}

.trade_pct_marks {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    margin-top: -24px;
    margin-bottom: 10px;
    position: relative;
    z-index: 1;
    pointer-events: none;
}

.trade_pct_dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #eaecef;
    flex-shrink: 0;
}

.trade_pct_dot--anchor,
.trade_pct_dot--fill {
    background: #1e2329;
}

.trade_pct_labels {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 4px;
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    font-family: "Inter", sans-serif;
}

.trade_pct_labels span {
    text-align: center;
    min-width: 0;
}

html[data-theme="dark"] .trade_pct_track_line {
    background: linear-gradient(to right,
            #f2f4f6 0%,
            #f2f4f6 var(--fill-pct),
            #374151 var(--fill-pct),
            #374151 100%);
}

html[data-theme="dark"] .trade_pct_dot {
    background: #4b5563;
}

html[data-theme="dark"] .trade_pct_dot--anchor,
html[data-theme="dark"] .trade_pct_dot--fill {
    background: #f2f4f6;
}

html[data-theme="dark"] .trade_pct_labels {
    color: #9ca3af;
}

html[data-theme="dark"] .trade_pct_slider_input::-webkit-slider-thumb {
    background: #f2f4f6;
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: 0 0 0 4px rgba(242, 244, 246, 0.12);
}

html[data-theme="dark"] .trade_pct_slider_input::-moz-range-thumb {
    background: #f2f4f6;
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: 0 0 0 4px rgba(242, 244, 246, 0.12);
}

.stop_avail_block {
    margin-top: 14px;
    margin-bottom: 8px;
}

.stop_avail_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 6px 0;
}

.stop_avail_label {
    color: #9aa1af;
    font-size: 13px;
    font-weight: 500;
}

.stop_avail_val {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
}

body.light_theme .stop_avail_val {
    color: #111827;
}

html[data-theme='dark'] .stop_avail_val {
    color: #f9fafb;
}

.stop_plus {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #0f172b;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1;
}

.stop_checks {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 12px;
}

.stop_check {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #111827;
    font-weight: 600;
}

html[data-theme='dark'] .stop_check {
    color: #f9fafb;
}

.stop_check input[type=\\"checkbox\\"] {
    width: 18px;
    height: 18px;
    border-radius: 4px;
}

.stop_apr_card {
    margin-top: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 14px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: rgb(255 255 255 / 20%);
    cursor: pointer;
}

html[data-theme='dark'] .stop_apr_card {
    border-color: rgba(255, 255, 255, 0.08);
    background: rgba(43, 49, 60, 0.55);
}

.stop_apr_text {
    color: #f59e0b;
    font-weight: 700;
}

.stop_apr_card i {
    color: #9aa1af;
    font-size: 20px;
}

.mrkt_trde_tab span {
    font-size: 11px;
    color: #919499;
}

.d-flex.fullwidth_align {
    width: 100%;
    color: #84888C;
    gap: 12px;
}

.trade-wrapper .assets_list .top_heading {
    justify-content: space-between;
    align-items: center;
}

.assets_list .more_btn {
    font-size: 12px;
    color: #d3d3d3;
}

.trade-wrapper .assets_list h4 {
    font-size: 13px;
    font-weight: 500;
    color: #dbdbdb;
    margin: 0px;
}

.assets_btn button a {
    color: #F2F4F6;
    font-weight: 500;
}

.card_header_title:before {
    position: absolute;
    content: " ";
    width: 16px;
    height: 3px;
    border-radius: 10px;
    background-color: #F2F4F6;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%) scaleX(.5);
    opacity: 0;
    transition: all .16s ease-in;
}

.card_header_title.active {
    color: #F2F4F6;
}

body.light_theme.card_header_title.active {
    color: #000000;
}

.card_header_title.active:before {
    opacity: 1;
    transform: translateX(-50%) scaleX(1);
}

.nav.custom-tabs.nav_order {
    width: auto !important;
}

.trade_tabs.buy_sell_cards.buy_sell_row.d-flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* height: 26px; */
    padding: 15px 15px 5px;
    border: 0;
    margin: 0;
}

.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {
    background: transparent !important;
}

body.light_theme.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {
    background: #e9e9e9 !important;
}

body.light_theme.price_card_head {
    border-color: #00000012;
}

.scroll_y_hidden {
    overflow: hidden;
}



.headline_left__lBBPY {
    display: flex;
    align-items: center;
}

.headline_left__lBBPY .headline_symbolName__KfmIZ {
    white-space: nowrap;
    margin-right: 0;
    cursor: pointer;
}

.headline_bigName__dspVW {
    display: flex;
    align-items: center;
    margin-inline-end: 7px;
}

.headline_bigName__dspVW,
.headline_bigName__dspVW h1 {
    line-height: 20px;
    font-size: 14px !important;
    font-weight: 700;
}

.headline_bigName__dspVW h1 {
    margin: 0;
}

.headline_etfDisplay__P4Hdv {
    font-size: 10px;
    line-height: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    margin-inline-end: 10px;
    opacity: 0.7;
}

.headline_leftItem__7BFYq {
    margin-inline-start: 15px;
    font-size: 12px;
    color: #4d4d4d;
    line-height: 20px;
    white-space: nowrap;
    font-weight: 500;
    font-weight: 400;
}



/* token info */

.inf_row {
    padding: 1.5rem;
}

.inf_row .mt_tr_pr {
    margin-bottom: 16px;
}

.inf_row .headline_bigName__dspVW,
.headline_bigName__dspVW h1 {
    font-size: 14px !important;
}


.infor_row li {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.infor_row li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    padding: 8px 0;
}

.infor_row li span {
    font-weight: 600;
    color: #fff;
}

body.light_theme.infor_row li span {
    color: #000;
}


.orderbook_two .buy_sell_row_price .scroll_y {
    height: 197px;
}

/* Single-side mode: taller pane so full depth list scrolls (overrides 257px above) */
.orderbook_two .buy_sell_row_price .scroll_y.orderbook-single-side {
    height: 430px;
    max-height: 430px;
    min-height: 430px;
    overflow: scroll;
}

.orderbook_two .buy_sell_row_price .scroll_y.orderbook-single-side.orderbook-asks-scroll.orderbook-asks-sell-list {
    height: 380px;
    max-height: 380px;
    min-height: 380px;
}

.t_info h5 {
    font-size: 15px;
    font-weight: 700;
}

.t_info p {
    font-weight: 400;
    font-size: 13px;
}

.inf_row {
    padding: 1.5rem;
    height: 429px;
    overflow-y: auto;
}

@media (min-width:1601px) {
    .headline_leftItem__7BFYq {
        margin-inline-start: 30px;
    }

}

.headline_latestPrice__AYXu0 .headline_title__x1csO {
    font-size: 14px;
}

.scroll-subtabs_scrollSubInfo__T5nZF {
    flex: 1 1;
    width: 0;
    margin-inline-start: 0;
    position: relative;
}

.scroll-subtabs_tabs__Prom8 {
    flex-flow: row nowrap;
    display: flex;
    /* overflow: hidden; */
    position: relative;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding-right: 10px;
}

.scroll-subtabs_subMarketWrap__XVmHp {
    overflow: auto hidden;
    white-space: nowrap;
    scroll-behavior: smooth;
    scrollbar-width: none;
}

.headline_extendInfoWrapper__dooIS,
.headline_left__lBBPY,
.headline_wrapper__BKn9L {
    display: flex;
    align-items: center;
}

.headline_leftItem__7BFYq {
    /* margin-inline-end: 60px; */
    font-size: 11px;
    line-height: 20px;
    white-space: nowrap;
}

.headline_withBorder__a6ZD2 {
    border-bottom: 1px dashed transparent;
    color: #fff;
    font-weight: 600;
}

body.light_theme .headline_withBorder__a6ZD2 {
    color: #000;
}

/* 24h Volume: slightly higher contrast (labels use opacity 0.7 by default) */
.headline_volumeStat__label {
    opacity: 0.88 !important;
}

.headline_volumeStat__value {
    color: #c8ccd4;
}

body.light_theme .headline_volumeStat__value {
    color: #4a4e55;
}

body.light_theme .headline_volumeStat__label {
    color: black;
}

.trade-wrapper.spot .container-fluid {
    padding: 0px 5px;
}

.limit_markettabs {
    padding: 10px 12px 10px 15px;
}


.buysell_heder {
    padding: 0px 10px 14px 14px !important
}

.buysell_heder .custom-tabs {
    padding: 0px 5px;
    width: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
    border-radius: 0px;
    gap: 10px;
    background-color: transparent;
    flex-wrap: nowrap;
}


body.light_theme .buysell_heder .custom-tabs {
    background: #F6F6F7;
}

body.light_theme .spot_limit button.active {
    border-bottom: none;
    color: #070808;
}

body.light_theme .actions_balance__kTHO0 {
    color: #000;
}

body.light_theme .buysellform .input-group {
    background: #F6F6F7;
}

body.light_theme .assets_list ul li {
    color: #000;
}

body.light_theme .assets_list ul li span {
    color: #3a3a3a;
}

body.light_theme .spotLists {
    background: #ffffff50;
}


body.light_theme .trade_favourites_lft .spot-list-search .ivu-input {
    background: #f9f9f9;
}

body.light_theme .trade_card {
    background: #ffffffd1;
}

.buysell_heder .custom-tabs li {
    width: 50%;
    position: relative;
}

.status_info {
    display: flex;
    gap: 5px;
}

.status_info input {
    background-color: #999;
    border: 1px solid #666;
    border-radius: 50px;
}

.status_info input {
    background-color: #22242c;
    border: 1px solid #353535;
    border-radius: 50px;
    color: #fff;
    padding: 2px 12px;
    width: 130px;
}

.status_info button {
    border-radius: 50px !important;
}

.buysell_heder .custom-tabs li a {
    width: 100%;
    display: block;
    /* transform: skewX(-20deg); */
    text-align: center;
    padding: 6px 0;
    /* background-color: #ffffff0f; */
    border-radius: 4px;
    font-size: 12px;
    color: currentColor !important;
    transition: unset !important;
}

/* .buysell_heder .custom-tabs li a::before{     width: 16px;
    transform: rotate(-19deg);
    position: absolute;
    left: -6px;
    background-color: #1f1f22;
    height: 110%;
    content: "";
    top: -3px; } */

.buysell_heder .custom-tabs li a.active button {
    background: #2BC287 !important;
    color: #fff;
}

.buysell_heder .custom-tabs li a.active button span {
    color: #fff !important;
}

/* .buysell_heder .custom-tabs li.sell-tab button::before {
    left: inherit;
    background-color: #1f1f22;
    right: -6px;
    top: 0px;
} */

/* .buysell_heder .custom-tabs li.sell-tab a.active::before{ background-color: #ed5765 !important; } */

/* .buysell_heder .custom-tabs li.buysell-tab.buy-tab button {
    border-radius: 4px;
    -ms-transform: skewX(-20deg);
    -webkit-transform: skewX(-20deg);
    transform: skewX(-20deg);
} */

.buysell_heder .custom-tabs.padding-0 li a {
    padding: 0px !important;
}

/* .buysell_heder .custom-tabs li button span {
    -ms-transform: skewX(20deg);
    -webkit-transform: skewX(20deg);
    transform: skewX(20deg);
    display: block;
} */

/* .buysell_two .buysell_heder .custom-tabs li button span {
    -ms-transform: skewX(35deg);
    -webkit-transform: skewX(35deg);
    transform: skewX(35deg);
    display: block;
} */

.actions_balance__kTHO0 {
    margin-bottom: 12px;
    min-height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
}

.midgraph_col {
    position: relative;
    padding-right: 3px;
}

/* .col-12.col-lg-12.col-xl-5.col-xxl-5.mmn_btm_minus_spc .col-lg-6 {
    padding: 2px;
} */

ul.favorites_list_tabs {
    display: flex;
    gap: 12px;
    overflow: auto;
    align-items: center;
    border-bottom: none;
    margin: 12px 12px;
}

ul.favorites_list_tabs li button {
    font-size: 13px;
    font-weight: 600;
    color: #949AA4;
    position: relative;
    background-color: transparent;
    border-bottom: none;
    border: none;
    padding: 0px 0px 8px;
}

ul.favorites_list_tabs li button:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    display: none;
    right: 0;
    margin: 0 auto;
    width: 35%;
    height: 2px;
    background-color: #d1aa67;
}

ul.favorites_list_tabs li button.active:before {
    display: block;
}

ul.favorites_list_tabs li button.active {
    color: #fff;
    border-bottom: none;
}

.midgraph_col .trade_card.trade_chart {
    height: 594px;
}

.actions_primaryText__ufKT0 {
    opacity: 0.7;
    margin-right: 10px;
}

body.light_theme.actions_primaryText__ufKT0 {
    opacity: 1;
}

body.light_theme.actions_balance__kTHO0 .text-muted {
    color: #3b3d3e !important;
}

a.actions_deposit__Ydutk {
    color: #01BC8D;
    font-size: 125%;
    margin-left: 10px;
    line-height: 1;
}

.buysellform .form-group label {
    display: block;
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 11px;
    /* opacity: 0.7; */
    font-family: "Inter", sans-serif;
    color: #F2F4F6;
}

.assets_list ul li span {
    color: #c0c0c0;
}

.process_step {
    position: relative;
}

.process_step:before {
    width: 100%;
    background-color: #DEDFE1;
    height: 1px;
    position: absolute;
    content: "";
    left: 0px;
    top: 4px;
}

.process_step label.btn {
    position: relative;
}

.process_step label.btn:before {
    width: 7px;
    background-color: #393F4F40;
    height: 7px;
    position: absolute;
    content: "";
    border-radius: 50px;
    border: 1px solid #393F4F;
    left: 0px;
    top: 1px;
}


.process_step label.btn.checked:before {
    width: 14px;
    background-color: #181a20;
    height: 14px;
    border: 2px solid #F2F4F6;
    top: -3px;
}

.pair-color {
    color: #fff;
    font-weight: 600;
}

.no-orderbook {
    font-weight: 500;
}

.buysell_heder .custom-tabs {
    padding: 1px;
    width: 100%;
    display: flex;
    position: relative;
    overflow: inherit;
    border: none;
    border-radius: 4px;
    gap: 10px;
    background-color: #2B313C;
    flex-wrap: nowrap;
    margin-top: 10px;
}

.buysell_heder .custom-tabs li button {
    width: 100%;
    display: block;
    /* transform: skewX(-20deg); */
    text-align: center;
    border: none;
    font-weight: 400;
    padding: 4px 10px;
    background-color: #2B313C;
    border-radius: 4px;
    font-size: 13px;
    color: #87909F;
    transition: unset !important;
}

.relative_select_right .buysell_heder .custom-tabs li.active button {
    background-color: #5EBA89 !important;
    border-bottom: none !important;
}

.relative_select_right .buysell_heder .custom-tabs li.selltab.active button {
    background-color: #ed5765 !important;
}

.selltab
/* .buysell_heder .custom-tabs li button::before {
    width: 16px;
    transform: rotate(0deg);
    position: absolute;
    transform: skewX(20deg);
    left: -6px;
    background-color: #1f1f22;
    height: 100%;
    content: "";
    border-radius: 3px;
    top: 0px;
} */


/* .buysell_heder .custom-tabs li.active button::before {
    background: #01BC8D !important;
}

.buysell_heder .custom-tabs li a.active button::before {
    background: #01BC8D !important;
}

.buysell_heder .custom-tabs li button.active::before {
    background: #01BC8D !important;
}

.buysell_heder .custom-tabs li button.selltab::before {
    left: inherit;
    background-color: #1f1f22;
    right: -5px;
    top: 0px;
    border-radius: 3px;
} */

.buysell_heder.padding_space_l {
    padding: 0px !important;
}

.relative_select_right .cnt_table_two {
    display: none;
}

.relative_select_right .cnt_table_two.active {
    display: block;
}

/* .buysell_two .buysell_heder .custom-tabs li button::before {
    width: 28px;
    transform: skewX(35deg);
    left: -11px;
}

.buysell_two .buysell_heder .custom-tabs li.sell-tab button::before {
    left: inherit;
    background-color: #1f1f22;
    right: -10px;
    top: 0px;
} */

.buysell_two .buysell_heder .custom-tabs li.sell-tab a.active button {
    background-color: #F74B60 !important;
}

/* .buysell_heder .custom-tabs li.sell-tab a.active button:before {
    background-color: #ed5765 !important;
}

.buysell_heder .custom-tabs li.selltab button.active::before {
    background-color: #ed5765 !important;
} */


body.light_theme.buysellform .form-group label {
    opacity: 1;
}

.order-btns .btn-mini {
    margin: 5px 0;
    line-height: 1;
    min-height: 36px;
}


.bs_box_header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;
}

.bs_box_header h6 {
    font-size: 14px;
    font-weight: 700;
    margin: 0;
}

.bs_box_header i {
    font-size: 22px;
}



.bs_tab_row {
    position: fixed;
    bottom: 0;
    z-index: 9999;
    width: 100%;
    left: 0;
    padding: 13px;
    border-radius: 0;
    border: 0;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    background: #1e1d3054;
    border-top: 1px solid #2c2c3d8a;
}

body.light_theme.bs_tab_row {
    background: #ffffffc9;
    border-color: #F5F5F5;
}

.bs_tab_row .btn {
    font-weight: 600;
}


.bs_dropbox.spotLists_bs_dropbox {
    display: none;
}

.bs_dropbox.spotLists_bs_dropbox.active {
    display: flex;
}



.spotLists_bs_dropbox {
    position: fixed;
    width: 100%;
    height: 100vh;
    background: #00000075;
    top: 0;
    bottom: 0;
    z-index: 99;
    left: 0;
    align-items: center;
    justify-content: center;

}


body.light_theme .bs_tab_row {
    background: #ffffff54;
}

@media screen and (max-width: 1100px) and (min-width: 768px) {

    .mmn_btm_minus_spc .col-lg-6 {
        margin: -1px;
    }

    div#tab_3 {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    div#tab_4 {
        margin-top: -17px !important;
        border-radius: 0px 0px 10px 10px;
    }



}


@media screen and (max-width: 991px) {

    .mmn_btm_minus_spc {
        display: block;
    }

    .mmn_btm_minus_spc .col-lg-6.ordermarketcntr {
        display: none;
    }

    .price_card_body.scroll_y.orderbook-side-scroll.orderbook-asks-sell-list {
        min-height: 210px !important;
        height: 210px;
    }

    .price_card_body.scroll_y.orderbook-side-scroll.ordertwo {
        height: 390px;
    }

    .price_card_body.scroll_y.orderbook-side-scroll.orderbook-asks-sell-list.orderthree {
        height: 390px;
    }

    .price_card_body.scroll_y.orderbook-side-scroll {
        min-height: 100% !important;
        height: 180px;
    }

}

/* Market Trades (below lg): empty = header row + flex region that fills viewport and centers art; with data = normal table */
@media screen and (max-width: 991.98px) {
    div#tab_4_mobile_trade {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    div#tab_4_mobile_trade>.trade_card.orderbook_two {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
    }

    div#tab_4_mobile_trade .trade_history_tab {
        padding: 0;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
    }

    div#tab_4_mobile_trade .table-responsive {
        max-height: calc(100vh - 400px);
        overflow-y: auto;
    }

    div#tab_4_mobile_trade .price_card_body {
        padding: 0;
    }

    /* Override global .trade-wrapper .table-responsive min-height for empty state */
    .trade-wrapper div#tab_4_mobile_trade .table-responsive.market-trades-mobile--empty {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: calc(100vh - 200px) !important;
        max-height: none;
        overflow: hidden;
    }

    div#tab_4_mobile_trade .market-trades-mobile-empty-wrap {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: calc(100vh - 200px);
        width: 100%;
    }

    div#tab_4_mobile_trade .market-trades-mobile-header-table {
        flex: 0 0 auto;
    }

    div#tab_4_mobile_trade .market-trades-mobile-empty-body {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: min(62vh, 560px);
        padding: 16px;
        box-sizing: border-box;
    }

    div#tab_4_mobile_trade .market-trades-mobile-empty-body .no-data-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: 100%;
    }

    div#tab_4_mobile_trade .market-trades-mobile-empty-body .no_data_s {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}

@media screen and (max-width: 767px) and (min-width: 320px) {

    .treade_card_header.tch_main_tab {
        display: flex;
    }

    .limit_markettabs.margin-surface-tabs .d-lg-none.mt-1 {
        margin: 0px !important;
    }

    .stop_avail_val {
        font-size: 12px;
    }

    .stop_avail_label {
        font-size: 12px;
    }

    .price_card_body.scroll_y.orderbook-side-scroll.orderbook-asks-sell-list {
        min-height: 210px !important;
        height: 210px;
    }

    .price_card_body.scroll_y.orderbook-side-scroll.ordertwo {
        height: 410px;
    }

    .price_card_body.scroll_y.orderbook-side-scroll.orderbook-asks-sell-list.orderthree {
        height: 410px;
    }

    .price_card_body.scroll_y.orderbook-side-scroll {
        min-height: 100% !important;
        height: 205px;
    }

    .orderbook-side-scroll {
        min-height: 210px !important;
    }

    .trade_price_input {
        font-size: 12px;
    }

    .trade_price_suffix {
        font-size: 11px;
    }

    .headline_bigName__dspVW h1 i {
        display: flex;
    }


    div#tab_3 {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    /* Hide tab_3 on mobile when Chart tab is active */
    div#tab_3.d-none {
        display: none !important;
    }

    div#tab_mobile_trade_history {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    /* Hide mobile Market Trades when Chart tab is active */
    div#tab_mobile_trade_history.d-none {
        display: none !important;
    }

    /* Mobile Market Trades styling */
    div#tab_mobile_trade_history .trade_history_tab {
        padding: 0;
    }

    div#tab_mobile_trade_history .table-responsive {
        max-height: calc(100vh - 400px);
        overflow-y: auto;
    }

    div#tab_mobile_trade_history .price_card_body {
        padding: 0;
    }

    div#tab_4 {
        border-radius: 0px 0px 10px 10px;
    }

    /* Hide mobile Wallets when Chart tab is active */
    div#tab_4_mobile.d-none {
        display: none !important;
    }

    div#tab_4_mobile {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    /* Mobile Wallets styling */
    div#tab_4_mobile .assets_list {
        padding: 0px;
    }

    .assets_btn {
        gap: 10px;
    }

    div#tab_4_mobile .table-responsive {
        max-height: calc(100vh - 400px);
        overflow-y: auto;
    }

    div#tab_4_mobile .price_card_body {
        padding: 0;
    }

    .trade-wrapper.spot.pb-3 .col-12.col-lg-6.col-xl-3.col-xxl-3 {
        margin-top: 7px;
    }


    .mmn_btm_minus_spc .col-lg-6 {
        margin-top: -2px;
    }

    .trade-wrapper {
        padding-top: 5px !important;
        overflow-x: hidden;
    }

    .select_mini {
        font-size: 14px;
        min-width: initial !important;
        height: unset !important;
        padding: 5px 11px !important;
    }


    .container-chart-briefing .spotList {
        background: #22242c;
        left: 0;
        top: 62px;
    }


    .container-chart-briefing {
        height: auto;
        padding: 15px 15px 0;
    }

    .spot-container-main .top {
        flex-direction: column;
    }

    .spot-container {
        flex-direction: column;
    }

    .buysellform .form-group label {
        font-size: 12px;
    }

    .wm-50 {
        flex: 0 0 auto;
        margin-bottom: 17px;
        width: 50%;
    }

    .container-chart-briefing-info {
        width: 100%;
        justify-content: unset;
        flex-wrap: wrap;
    }

    .container-chart-briefing h2 {
        justify-content: flex-start;
    }

    .spot-container-main .bottom {
        min-height: unset;
        flex-direction: column;
    }

    .bottom-left {
        width: 100%;
        margin-bottom: 20px;
    }

    .bottom-right {
        width: 100%;
    }

    .spot-container-right-right {
        flex: auto;
        max-width: 100%;
    }

    .trade_card {
        padding: 11px 11px;
        padding: 0;
    }

    ul.nav.custom-tabs.order_his_tabs li a {
        padding: 8px 13px;
        font-size: 13px;
        line-height: 1;
    }

    .buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {
        padding: 3px;
        margin: 0 3px 0 0;
    }

    .buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {
        background: transparent !important;
    }

}


@media screen and (max-width: 991px) and (min-width: 768px) {


    .spot-container-main .top {
        flex-direction: column;
    }

    .spot-container {
        flex-direction: column;
    }

    .wm-50 {
        flex: 0 0 auto;
        margin-bottom: 17px;
        width: 33.3333333%;
    }

    .container-chart-briefing-info {
        width: 100%;
        justify-content: unset;
        flex-wrap: wrap;
    }

    .container-chart-briefing h2 {
        justify-content: flex-start;
    }

    .spot-container-main .bottom {
        min-height: unset;
        flex-direction: column;
    }

    .bottom-left {
        width: 100%;
        margin-bottom: 20px;
    }

    .bottom-right,
    .spot-container-main .top-right {
        width: 100%;
    }

    .spot-container-right-right {
        flex: auto;
        max-width: 100%;
    }

    ul.nav.custom-tabs.order_his_tabs li a {
        padding: 7px 20px;
        font-size: 14px;
    }

    .container-chart-briefing {
        height: unset;
        padding-bottom: 10px;
    }

    .trade-wrapper.spot {
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .trade-wrapper.spot.pb-3 {
        max-width: 100%;
    }


}


@media screen and (max-width: 1299px) and (min-width: 992px) {

    .spot-container {
        flex-direction: column;
    }

    .spot-container-right-right {
        flex: auto;
        max-width: 100%;
        display: flex;
    }

    /* .inner-page-banner {
            padding: 77px 0 43px;
        } */
    section.pb-90.account_sec {
        padding-bottom: 0;
    }
}

@media screen and (max-width:1550px) {

    .trade_card.p-2.overflow_card.mb-1 {
        width: calc(100% + 28.5%);
    }

    ul.favorites_list_tabs {
        gap: 12px;
        margin: 12px 7px;
    }

    .trade_card .table> :not(caption)>*>* {
        font-size: 11px;
    }

    .trade-wrapper .orderbook-table th {
        padding: 4px 7px;
    }

    .trade-wrapper .orderbook-table td {
        padding: 4px 7px;
    }

    ul.favorites_list_tabs li button {
        font-size: 13px;
    }




}

@media screen and (max-width:1440px) {
    .assets_btn {
        gap: 10px;
    }

    .stop_avail_val {
        font-size: 12px;
    }

    .stop_avail_label {
        font-size: 12px;
    }

    .trade-wrapper .orderbook-table th {
        font-size: 10px !important;
        padding: 4px 5px;
    }

    .trade-wrapper .orderbook-table td {
        font-size: 10px !important;
        padding: 4px 5px !important;
    }

    .card_header_title {
        font-size: 12px;
    }

    ul.favorites_list_tabs li button {
        font-size: 12px;
        padding: 0px 0px 5px;
    }

    ul.favorites_list_tabs {
        gap: 10px;
        margin: 5px 5px;
    }

    .assets_btn button {
        font-size: 12px;
        padding: 5px 5px;
    }

}

@media screen and (max-width:1367px) {

    .trade_card.p-2.overflow_card.mb-1 {
        width: calc(100% + 244px);
    }

    .assets_right {
        width: 18.9%;
    }

    .trade_favourites_lft .spotLists {
        height: 100%;
    }

    .bs_dropbox .trade_card.trade_chart.buysell_card {
        width: 98.5%;
    }

    div#tab_3 {
        border-radius: 0px;
    }


}


@media screen and (max-width: 1200px) {

    .trade_card.p-2.overflow_card.mb-1 {
        width: calc(100% + 0px);
    }

    .midgraph_col {
        width: 100%;
    }

    .trade_favourites_lft {
        width: 30%;
    }

    .trade-wrapper .row {
        row-gap: 0px;
    }

    div#tab_3 {
        border-radius: 0px;
    }

    div#tab_4 {
        border-radius: 10px;
        margin-top: 0px !important;
    }

}

/* Ensure tab_3 shows on desktop (lg+) even if d-none is present */
@media screen and (min-width: 992px) {
    div#tab_3.d-none.d-lg-block {
        display: block !important;
    }
}

@media screen and (max-width: 991px) {

    .midgraph_col {
        width: 100%;
    }

    .trade_favourites_lft {
        width: 100%;
    }

    .bs_tab_row {
        z-index: 999999;
    }

    .mmn_btm_minus_spc button.btn.btn-danger {
        font-size: 12px;
        padding: 6px 16px;
    }

    .bs_tab_row button.btn.btn-success {
        padding: 6px 16px;
    }

    .bs_dropbox .trade_card.trade_chart.buysell_card {
        left: 1px;
    }

}

/* Trade account summary: mobile cardbox only (desktop unchanged) */
@media screen and (max-width: 991px) {

    /* Sticky container logic */
    .trade_account_summary_assets {
        position: sticky !important;
        top: 80px !important;
        z-index: 100;
    }

    .trade_account_summary_assets.is-stuck {
        height: calc(100vh - 80px) !important;
    }

    /* When stuck, the table container becomes internally scrollable */
    .trade_account_summary_assets.is-stuck .mobile_view2,
    .trade_account_summary_assets.is-stuck .order_history_mobile_view {
        max-height: calc(100vh - 80px - 55px) !important;
        /* 55px accounts for the sticky tabs header */
        overflow-y: auto !important;
    }

    /* When NOT stuck, everything displays fully and scrolls natively with the page */
    .trade_account_summary_assets:not(.is-stuck) .mobile_view2,
    .trade_account_summary_assets:not(.is-stuck) .order_history_mobile_view {
        max-height: none !important;
        overflow-y: visible !important;
    }

    .trade_summary_table_lft_position_order.position_order {
        overflow: visible !important;
    }

    .trade_account_summary_assets .desktop_view2 {
        display: none !important;
    }

    .trade_account_summary_assets .order_history_mobile_view {
        display: block !important;
        margin-top: 10px;
        color: #000;
        padding-bottom: 75px;
        margin-bottom: 0px;
    }

    body.light_theme .trade_account_summary_assets {
        background-color: #ffffff;
        border-radius: 14px 14px 0px 0px;
    }

    .mobile-favourites-popup-overlay span.agce-margin-filter-arrow {
        display: none;
    }

    .mobile-favourites-popup-overlay .agce-margin-filter-bar {
        grid-template-columns: 1fr 1fr !important;
        display: grid;
    }

    .mobile-favourites-popup-overlay .agce-margin-filter-select {
        min-width: 100%;
        max-width: 100%;
    }

    .mobile-favourites-popup-overlay .agce-margin-filter-input {
        width: 100% !important;
    }

    .trade_account_summary_assets .order_history_mobile_view .d-flex.datalist_mbl {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    /* Executed fills block sits under mobile order card (order history) */
    .trade_account_summary_assets .trade_page_mob_execBelow {
        /* margin: -8px 0 4px 0; */
        /* padding: 10px 12px 12px;
        border: 1px solid #efefef;
        border-radius: 0 0 8px 8px;
        background: #f9fafb; */
    }

    html[data-theme="dark"] .trade_account_summary_assets .trade_page_mob_execBelow {
        background: #181a20;
        border-color: #2b3139;
    }

    .trade_account_summary_assets .order_datalist {
        /* border: 1px solid #efefef;
        padding: 12px; */
        margin: 0;
    }

    .trade_account_summary_assets .order_datalist .listdata {
        gap: 9px;
        padding: 0;
    }

    .trade_account_summary_assets .order_datalist .listdata li {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
        padding-bottom: 7px;
    }

    .trade_account_summary_assets .order_datalist .listdata li:last-child {
        border-bottom: 0;
        padding-bottom: 0;
    }

    .trade_account_summary_assets .order_datalist .listdata li span:first-child {
        color: #8e949e;
        min-width: 110px;
        flex: 0 0 110px;
    }

    .trade_account_summary_assets .order_datalist .listdata li span:last-child {
        text-align: right;
        min-width: 0;
        overflow-wrap: anywhere;
        word-break: break-word;
    }
}

/* Favourites left panel: open only on click */
.trade_favourites_lft.is-collapsed {
    display: none !important;
}

.trade_favourites_lft.is-open {
    display: block !important;
}

/* Desktop hover dropdown behaviour: start below headline, extend to bottom */
@media screen and (min-width: 992px) {
    .trade-wrapper.spot.pb-3 .row.g-1.g-md-2 {
        position: relative;
    }

    .trade_favourites_lft.is-open {
        position: absolute;
        left: 0;
        top: auto;
        margin-top: 75px;
        height: 100%;
        bottom: auto;
        width: 360px;
        max-width: calc(100vw - 16px);
        z-index: 99999;
        background-color: #2b313c;
        border-radius: 0px;
        padding: 0;
        overflow: hidden;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
        /* height: calc(100vh - 120px); */
        border-radius: 5px;
    }

    .trade_favourites_lft.is-open .spotLists {
        max-height: 100%;
        flex-direction: column;
        overflow: hidden;
    }

    .trade_favourites_lft.is-open .spot-list-search {
        flex-shrink: 0;
        padding: 12px 12px 0;
    }

    .trade_favourites_lft.is-open ul.favorites_list_tabs {
        flex-shrink: 0;
        margin: 12px 12px 0;
        padding-bottom: 10px;
        background-color: transparent;
        position: sticky;
        border: none;
        top: 56px;
        z-index: 2;
    }

    .trade_favourites_lft.is-open .price_card {
        flex: 1 1;
        min-height: 0;
        overflow: auto;
        padding: 0;
    }

    .trade_favourites_lft.is-open .price_card.table-responsive {
        overflow: auto;
        max-height: 96vh;
    }
}


@media screen and (max-width: 1600px) and (min-width: 1200px) {
    .spot-container .col-xxl-2 {
        flex: 0 0 auto;
        width: 24%;
    }

    .spot-container .col-xxl-4 {
        flex: 0 0 auto;
        width: 48%;
    }

    .spot-container .col-xxl-8 {
        flex: 0 0 auto;
        width: 52%;
    }


}

@media screen and (max-width: 3000px) and (min-width: 1601px) {
    .spot-container .col-xxl-2 {
        flex: 0 0 auto;
        width: 20%;
    }

    .spot-container .col-xxl-4 {
        flex: 0 0 auto;
        width: 40%;
    }

    .spot-container .col-xxl-8 {
        flex: 0 0 auto;
        width: 60%;
    }
}

.scroll_y_reverse {
    display: flex;
    flex-direction: column-reverse;
}


.font-weight-boldd {
    font-weight: 500;
    font-size: 13px;
    color: #ebebeb;
}

body.theme-light .font-weight-boldd {
    color: #070808;
}

span.font-weight-boldd.text-green {
    font-weight: 600;
}

@media (max-width: 1200px) {

    body .agce-margin-filter-toggle-btn {
        border: none;
        color: #fff;
        padding: 0px !important;
    }

    body.light_theme .agce-margin-filter-toggle-btn {
        color: #000;
    }

    .trade_account_summary_assets .order_history_mobile_view {
        color: #f7f7f7;
    }

    body.light_theme .trade_account_summary_assets .order_history_mobile_view {
        color: #000000;
    }

    .agce-margin-pos-val-primary {
        font-size: 13px;
    }

}


/* responsive */
@media (max-width: 991.98px) {

    /* Mobile Favourites Toggle Button */
    .mobile-favourites-toggle-btn {
        display: block;
        margin-bottom: 15px;
    }

    ul.favorites_list_tabs {
        border-bottom: none;
    }

    .favourites-toggle-btn-mobile {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        background-color: #2B313C;
        border: 1px solid #434343;
        border-radius: 8px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .favourites-toggle-btn-mobile:hover {
        background-color: #373E4B;
        border-color: #565A62;
    }

    .favourites-toggle-btn-mobile:focus-visible {
        background-color: #373E4B;
        border-color: #565A62;
    }

    .favourites-toggle-btn-mobile:active {
        background-color: #373E4B !important;
        border-color: #565A62 !important;
    }

    .favourites-toggle-btn-mobile i {
        font-size: 16px;
    }

    body.light_theme.favourites-toggle-btn-mobile {
        background-color: #f5f5f5;
        border-color: #e0e0e0;
        color: #333;
    }


    body.light_theme.favourites-toggle-btn-mobile:hover {
        background-color: #e9e9e9;
        border-color: #d0d0d0;
    }

    .trade_favourites_lft.hide-favourites-mobile {
        display: none;
    }

    .trade_favourites_lft.show-favourites-mobile {
        display: block;
    }



    .midgraph_col {
        width: 100%;
    }

    .bs_dropbox .trade_card.trade_chart.buysell_card {
        left: 0px;
    }

    .trade_favourites_lft {
        width: 100%;
        display: none;
    }

    /* Mobile Favourites Popup */
    .mobile-favourites-popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgb(0 0 0 / 50%);
        -webkit-backdrop-filter: blur(4px);
                backdrop-filter: blur(4px);
        z-index: 9999999999 !important;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        animation: fadeIn 0.3s ease;
    }

    body.light_theme .mobile-favourites-popup-overlay {
        background-color: rgb(255 255 255 / 33%);
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0);
        }
    }

    .mobile-favourites-popup {
        width: 100%;
        max-height: 85vh;
        background-color: #000000a8;
        -webkit-backdrop-filter: blur(4px);
                backdrop-filter: blur(4px);
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        display: flex;
        padding-bottom: 80px !important;
        flex-direction: column;
        animation: slideUp 0.3s ease;
        box-shadow: 0px 5px 20px #494949;
        overflow: hidden;
        border-radius: 10px 10px 0px 0px;
    }

    .mobile-favourites-popup .spotLists {
        -webkit-backdrop-filter: blur(0px) !important;
                backdrop-filter: blur(0px) !important;
    }

    .mobile-favourites-popup.pairpopup {
        padding-bottom: 10px !important;
    }

    .mobile-favourites-popup .btn {
        font-size: 14px !important;
        margin-top: 0px !important;
    }

    .agce-margin-mobile-filter-header {
        padding: 10px 0px !important;
    }

    .mobile-favourites-popup .orderbook-table th {
        background: #2b313c00;
        padding: 3px 8px;
    }

    .mobile-favourites-popup.pairpopup table thead th {
        background-color: #121213;
    }

    body.light_theme .mobile-favourites-popup.pairpopup table thead th {
        background-color: #fff;
    }

    .headline_bigName__dspVW h1 {
        display: flex;
    }

    .treade_card_header {
        border-bottom: none !important;
    }

    body.light_theme.mobile-favourites-popup {
        background-color: #ffffff;
    }

    .mobile-favourites-popup-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #000000a1;
        padding: 9px 15px 5px;
        border-bottom: none;
    }

    body.light_theme .mobile-favourites-popup-header {
        border-bottom-color: #e0e0e0;
        background-color: #ffffff2b;
    }

    .mobile-favourites-popup-header h4 {
        margin: 0;
        font-size: 15px;
        font-weight: 500;
        color: #fff;
    }

    body.light_theme.mobile-favourites-popup-header h4 {
        color: #333;
    }

    .mobile-favourites-close-btn {
        background: transparent;
        border: none;
        color: #9b9b9b;
        font-size: 22px;
        cursor: pointer;
        padding: 5px;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        transition: background-color 0.2s ease;
    }



    .mobile-favourites-close-btn:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    body.light_theme.mobile-favourites-close-btn {
        color: #333;
    }

    body.light_theme.mobile-favourites-close-btn:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .mobile-favourites-popup-content {
        flex: 1 1;
        overflow-y: auto;
    }

    .mobile-favourites-popup-content .spotLists {
        background: transparent;
        padding: 0;
        display: block;
        top: 0px;
        max-width: calc(100% - 0px);
        left: 0px;
    }

    .mobile-favourites-popup-content ul.favorites_list_tabs {
        padding: 0px 10px;
    }

    .mobile-favourites-popup-content img.round_img {
        width: 24px !important;
        height: 24px !important;
        min-width: 24px;
    }

    .orderbook-table td {
        padding: 4px 7px;
    }

    ul.favorites_list_tabs li button {
        font-size: 14px;
    }

    ul.favorites_list_tabs {
        gap: 15px;
        margin: 7px 0px;
    }

    .headline_left__lBBPY_leftmain.d-flex.align-items-center {
        width: 50%;
    }

    .scroll-subtabs_subMarketWrap__XVmHp {
        /* max-width: 264px; */
        min-width: 194px;
    }

    .mmn_btm_minus_spc {
        margin: 4px 0px 0px
    }

    .tch_main_tab .card_header_title {
        padding: 8px 7px 6px;
    }

    /* .trade_summary_table_lft {
        padding: 10px !important;
    } */

    .infor_row li {
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        padding: 5px 0;
    }

    .inf_row {
        padding: 1rem;
        height: 429px !important;
        overflow-y: auto;
    }



    .scroll-subtabs_scrollSubInfo__T5nZF {
        flex: 1 1;
        width: 0;
        margin-inline-start: 0;
        position: relative;
    }

    .headline_left__lBBPY_leftmain.d-flex.align-items-center {
        align-items: flex-start !important;
        justify-content: flex-start;
        flex-direction: column;
    }

    .trade_card.p-2.overflow_card.mb-1 {
        height: auto;
        padding: 20px 16px 12px !important;
    }

    .headline_left__lBBPY_leftmain .headline_symbolName__KfmIZ {
        margin-bottom: 0;
    }

    /* .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS {
        flex-direction: column;
        align-items: flex-start !important;
    } */

    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 5px;
        align-items: flex-start !important;
    }

    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq {
        display: flex;
        width: 100%;
        justify-content: flex-end;
    }

    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq .headline_withBorder__a6ZD2 {
        flex: 1 1;
        font-size: 9px;
        text-align: start;
        margin-inline-end: 0;
    }

    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq .headline_title__x1csO {
        flex: 1 1;
        text-align: right;
        margin-inline-end: 0;
    }

    .headline_latestPrice__AYXu0 .headline_title__x1csO {
        font-size: 20px;
    }

    .trade-wrapper .assets_list h4 {
        font-size: 14px;
        align-items: center;
        gap: 5px;
        display: flex;
    }

    .inf_row .headline_bigName__dspVW,
    .headline_bigName__dspVW h1 {
        font-size: 14px !important;
    }

    span.headline_change__tGyxo {
        font-size: 16px;
    }

    .headline_leftItem__7BFYq {
        /* margin-inline-end: 60px; */
        font-size: 12px;
        line-height: 1.2;
        white-space: nowrap;
        padding: 4px 0;
        font-weight: 500;
    }

    .headline_leftItem__7BFYq {
        margin-inline-start: 0;
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 3px;
    }

    .scroll-container {
        overflow-y: auto;
        max-height: 175px;
        height: auto;
    }

    .exchange_chartContent__Ijukg {
        height: auto;
        overflow-y: auto;
    }

    .information_bright__F_RTd {
        opacity: 1 !important;
        margin-left: 6px;
    }

    .information_left__vgFSY,
    .information_right__kqyPI {
        width: 41%;
    }

    .trade-wrapper .btn {
        height: auto !important;
        min-height: unset !important;
        margin-top: 5px;
        border-radius: 50px;
    }

    .btn-group.btn-group-mini {
        margin-bottom: 3px;
    }

    .btn-group.btn-group-mini * {
        padding: 0px 0px;
        min-height: unset;
        border-radius: 9px !important;
        line-height: 29px;
        font-size: 11px !important;
    }

    .col-12.col-sm-6.col-lg-6.col-xl-3.col-xxl-2.order-2,
    .col-12.col-sm-6.col-lg-6.col-xl-3.col-xxl-2.order-3.order-xl-3 {
        margin-top: 0;
    }

    .price_card_body.price_card_body_full,
    .scroll_y {
        height: 240px;
    }

    .scroll_y_full {
        height: 502.8px;
    }

    .scroll_y_full {
        /* height: 480px; */
    }

    .scroll_y_coins {
        height: 339px;
    }

    footer.footer-wrapper {
        margin-top: 0;
    }

    .trade-wrapper .container-fluid {
        padding-right: 8px;
        padding-left: 8px;
        overflow: hidden;
    }

    .scroll-subtabs_tabs__Prom8 {
        justify-content: flex-end;
    }

    .d-flex.spottabs_top {
        border-bottom: none;
    }


    .trade_tabs .num-select {
        font-size: 10px;
    }

    .buysell_heder {
        padding: 10px !important;
    }

    .spot .form-control,
    .spot select {
        padding: 4px 18px;
        min-width: unset;
    }

    .trade_chart .form-select-sm {
        padding: 6px 9px !important;
        font-size: 12px;
    }

    .actions_balance__kTHO0 {
        flex-direction: column;
        align-items: start;
        line-height: 1.5;
    }

    .actions_primaryText__ufKT0 {
        opacity: 0.7;
        margin-right: 10px;
        font-size: 10px;
        margin-bottom: 3px;
    }

    .trade-wrapper .mb-1 {
        margin-bottom: 4px !important;
    }

    .price_card_head>div {
        word-break: break-all;
        font-size: 10px;
        vertical-align: bottom;
        padding: 0 6px;
    }

    .price_card .price_card_head {
        padding: 0 5px;
        margin: 0;
        min-height: 24px;
        line-height: 1.1;
    }

    .trade_tabs.buy_sell_cards.buy_sell_row.d-flex-between {
        padding: 0px 7px 0px 9px;
    }

    .price_item_value span:first-child,
    .price_card_head>div:first-child {
        padding-left: 5px;
    }

    body .trade_card#tab_mobile_trade_history .table> :not(caption)>*>* {
        padding: 5px !important;
    }

    .price_item_value span {
        word-break: break-all;
        white-space: nowrap;
        line-height: 1.1;
    }

    .buysellform .input-group {
        padding: 0px 11px;
    }

    .buysell_card {
        /* height: 504px; */
    }

    .price_item_value span:last-child,
    .price_card_head>div:last-child {
        padding-right: 5px;
    }

    .buy_sell_row_price .scroll_y {
        height: 400px;
    }

    .usd_future_dashboard .table_info_data table tr td {
        font-size: 10px;
    }

    .usd_future_dashboard .table_info_data table tr th {
        font-size: 10px;
    }

    .buy_sell_row_price .scroll_y.orderbook-single-side {
        height: 400px;
        max-height: min(65vh, 560px);
    }

    .spotLists {
        width: 100%;
        max-width: calc(100% - 12px);
        left: 6px;
        top: 162px;
        min-height: 150px;
        max-height: 470px;
    }

    .mobile-favourites-popup-overlay .pair-color {
        font-weight: 400;
    }

    .limit_markettabs {
        padding: 10px 16px 0px 16px;
    }

    .bs_dropbox .spotLists {
        width: 100%;
        width: 100%;
        max-width: 500px;
        top: unset;
        left: 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .spotLists .price_card_body.tab-content.scroll_y {
        height: 345px;
    }

    body .agce-margin-leverage-row {
        padding: 0px 0px 8px;
    }

}

@media screen and (max-width: 660px) {

    .headline_leftItem__7BFYq {
        font-size: 11px;
    }
}

@media screen and (max-width: 991px) and (min-width: 320px) {

    /* .bs_dropbox .summay_dasboard_pop {
        display: block !important;
    } */

    .bs_dropbox .trade_card.trade_chart.buysell_card {
        width: 100%;
        min-height: 100%;
    }

    div#tab_4 {
        margin-top: -0.5rem;
    }

    .bs_dropbox .col-lg-6 {
        padding: 0px;
    }

    .summay_dasboard_pop {
        height: auto !important;
        width: 40%;
        border-radius: 0px !important;
    }

    .letsidebar_tradetbl .bs_tab_row {
        background: none;
        border-top: none;
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        /* background: #1e1d3054; */
    }

    .letsidebar_tradetbl .bs_tab_row button.btn.btn-danger {
        font-size: 14px;
    }

    .letsidebar_tradetbl .bs_tab_row button.btn.btn-success {
        font-size: 14px;
    }


    .bs_dropbox {
        position: fixed;
        width: 100%;
        background-color: rgba(109, 109, 109, 0.4);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        top: 0;
        bottom: 0;
        z-index: 99999999;
        left: 0;
        display: flex;
        align-items: end;
        justify-content: center;
        min-width: 100%;
        max-width: 100%;
    }


    body.light_theme .bs_dropbox {
        background-color: rgb(255 255 255 / 20%);
    }

    .trade-wrapper .bs_dropbox .row {
        width: 100%;
    }

    .bs_dropbox .buysell_card {
        height: auto;
        width: 100%;
        max-width: 100%;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        overflow-y: auto;
        max-height: 100%;
        background-color: #111114b8;
    }

    .bs_dropbox .summay_dasboard_pop {
        padding: 0px 3px;
    }

    .bs_dropbox .price_card_head>div {
        font-size: 8px;
    }

    .bottm_lightbox_two {
        height: 80vh;
        box-shadow: 0px 0px 30px #0000009c;
        border-radius: 14px 14px 0px 0px;
        overflow: hidden;
    }

    .bottm_lightbox_two .trade_card,
    .spotLists {
        border: none;
        border-radius: 0px;
    }

    .bs_box_header h6 {
        font-size: 18px;
    }

    .bottm_lightbox_two .assets_btn {
        flex-direction: row;
    }

    .bottm_lightbox_two .assets_list {
        margin: 10px 20px 20px;
    }

    .bs_dropbox .buysell_card .btn-mini {
        font-size: 12px !important;
        padding: 10px 10px 9px;
    }

    .bs_dropbox .bs_box_header {
        margin-bottom: 3px;
    }

    .bs_dropbox .spot_limit select {
        background: transparent !important;
        box-shadow: none;
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        border: none;
        padding: 0px;
        min-width: unset;
        border-radius: 0px !important;
    }

    .bs_dropbox .buysell_card .p-2.p-md-3 {
        padding: 15px !important;
    }

    .bs_dropbox .price_card_body.scroll_y.scroll_y_reverse {
        align-items: normal;
        justify-content: start;
        max-height: 100%;
        min-height: 100%;
        height: 100%;
    }

    .bs_dropbox .buysell_heder .custom-tabs li.buysell-tab.buy-tab a {
        border-radius: 0px;
    }

    .bs_dropbox .buysell_heder .custom-tabs li a {
        border-radius: 0px;
    }

    .bs_dropbox .trade_card.trade_chart.buysell_card .assets_list {
        margin: 0px 15px 15px;
    }


    .bs_dropbox .buysellform .input-group .form-control {
        font-size: 12px !important;
        padding: 3px 6px;
    }

    .bs_dropbox .price_card_body.scroll_y {
        max-height: 39%;
        min-height: 39%;
        overflow: auto;
    }

    .bs_dropbox .buysell_card.trade_chart .form-select-sm {
        padding: 0px !important;
        font-size: 12px;
    }

    .bs_dropbox .buysellform .input-group {
        padding: 7px 7px 7px 3px;
    }

    .bs_dropbox .btn-group.btn-group-mini * {
        font-size: 10px !important;
    }

    .bs_dropbox .assets_list h4 {
        font-size: 15px;
    }

    .bs_dropbox a.more_btn {
        font-size: 11px;
    }

    .bs_dropbox .assets_list .top_heading {
        flex-direction: row;
    }

    .bs_dropbox .buysell_heder {
        padding: 13px 15px !important;
    }

    .bs_dropbox .buysell_heder .custom-tabs li a {
        padding: 4px 0;
        font-size: 12px;
        font-weight: 700;
    }


    .headline_extendInfoWrapper__dooIS,
    .headline_left__lBBPY,
    .headline_wrapper__BKn9L {
        display: flex;
        align-items: start;
    }

    .bs_dropbox.active {
        display: flex !important;
    }
}

@media (max-width: 991.98px) {

    /* Allow chart card to grow on small screens (desktop had fixed 594px) */
    .midgraph_col .trade_card.trade_chart {
        height: auto !important;
        min-height: 0;
    }

    body.light_theme .trade-wrapper .orderbook-table td {
        color: #191919 !important;
    }

    /* Chart tab: let TVChartContainer set height (taller while loading for centered spinner) */
    .trade_card.trade_chart #tab_1.cc_tab:not(.d-none) {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
        height: auto !important;
    }
}

@media (max-width: 480px) {
    #tab_1 {
        min-height: 400px;
    }
}

/* —— Spot bottom panel: Open Orders (tabs, filters, table, empty state) —— */
.position_order .cnt_table {
    display: none;
    flex-direction: column;
    width: 100%;
    padding: 0px 13px;
}

.position_order .cnt_table.active {
    display: flex;
}

.trade_summary_table_lft_position_order.position_order {
    background: #181a20;
    border-radius: 8px;
    overflow: hidden;
}

/* .position_order .spot_orders_top {
    background: #ececec;
} */

.spot_orders_primary_tabs_scrollWrap {
    position: relative;
    width: 100%;
    min-width: 0;
}

.position_order .position_list.spot_orders_primary_tabs {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 4px 8px;
    list-style: none;
    margin: 0;
    padding: 0 12px;
    border-bottom: 1px solid #d1d5db2e;
}

body.light_theme .position_order .position_list.spot_orders_primary_tabs {
    border-bottom: 1px solid #d1d5db
}

/* Single horizontal row: never wrap tabs; scroll when needed (arrows on narrow viewports below) */
.position_order .position_list.spot_orders_primary_tabs.spot_orders_primary_tabs--scroller {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    overscroll-behavior-x: contain;
    min-width: 0;
}

.position_order .position_list.spot_orders_primary_tabs.spot_orders_primary_tabs--scroller::-webkit-scrollbar {
    display: none;
}

.position_order .position_list.spot_orders_primary_tabs.spot_orders_primary_tabs--scroller>li {
    flex: 0 0 auto;
}

.position_order .spot_orders_primary_tabs li {
    margin: 0;
    padding: 0;
}

.position_order .spot_orders_primary_tabs li button {
    border: none;
    background: transparent;
    color: #6b7280;
    font-size: 13px;
    font-weight: 600;
    position: relative;
    font-family: "Inter", sans-serif;
    padding: 12px 8px 10px;
    margin: 0;
    border-bottom: none;
    white-space: nowrap;
    cursor: pointer;
}

.position_order .spot_orders_primary_tabs li button::before {
    content: "";
    position: absolute;
    content: " ";
    min-width: 30px;
    height: 3px;
    border-radius: 10px;
    background-color: #d1aa67;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%) scaleX(.5);
    opacity: 0;
    transition: all .16s ease-in;
}

.position_order .spot_orders_primary_tabs li.active button::before {
    opacity: 1;
}

.position_order .spot_orders_primary_tabs li.active button {
    color: #fff;
    font-weight: 600;
    border-bottom-color: #111827;
}

body.light_theme .position_order .spot_orders_primary_tabs li.active button {
    color: #111827;
}

.spot_orders_filter_bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: start;
    gap: 10px;
    padding: 12px 18px 10px;
    background: none;
    border-bottom: none;
}

/* Scroll row + arrows (Open Orders chips) — inner scroller; arrows shown on mobile only */
.spot_orders_filter_scrollWrap {
    position: relative;
    width: 100%;
    min-width: 0;
    flex: 1 1 auto;
    display: flex;
    align-items: center;
}

.spot_orders_filter_chips--scroll {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    flex: 1 1;
    min-width: 0;
}

.spot_orders_chipsArrow {
    display: none;
}

.spot_orders_filter_chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
    flex: 1 1;
    min-width: 0;
}

.spot_orders_chip {
    border: none;
    background: #f6f6f714;
    color: #909397;
    font-size: 12px;
    font-weight: 400;
    font-family: "Inter", sans-serif;
    padding: 7px 16px;
    border-radius: 999px;
    border-radius: 4px !important;
    cursor: pointer;
    white-space: nowrap;
}

.agce-margin-filter-popup-content .spot_orders_chip {
    background: #f0f0f017;
}

body.light_theme .spot_orders_chip {
    background: #f6f6f7;
}


.spot_orders_chip.is-active {
    background: #F6F6F7;
    color: #000000;
    font-weight: 500;
}

.spot_orders_filter_actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.spot_orders_side_select {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #fff;
    color: #111827;
    font-size: 12px;
    padding: 6px 28px 6px 10px;
    font-family: "Inter", sans-serif;
    cursor: pointer;
}

.spot_orders_reset {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: transparent;
    color: #909397;
    font-size: 14px;
    font-weight: 500;
    font-family: "Inter", sans-serif;
    cursor: pointer;
    padding: 4px 11px;
}

.spot_orders_reset:hover {
    color: #e7e7e7;
}

body.light_theme .spot_orders_reset:hover {
    color: #111827;
}

.spot_orders_table thead th {
    font-size: 11px;
    font-weight: 600;
    color: #9ca3af;
    text-transform: none;
    border-bottom: 1px solid #ececec;
    padding: 10px 8px !important;
    white-space: nowrap;
    font-family: "Inter", sans-serif;
}

.spot_orders_table tbody td {
    font-size: 12px;
    color: #111827;
    vertical-align: middle;
    padding: 10px 8px !important;
    font-family: "Inter", sans-serif;
}

.spot_orders_no_data_row {
    width: 100% !important;
    display: table-row !important;
}

.spot_orders_no_data_row td {
    width: 100% !important;
    display: table-cell !important;
    border: none !important;
    vertical-align: middle !important;
    text-align: center !important;
    padding: 0 !important;
}

.spot_orders_empty_state {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    width: 100% !important;
    min-height: 280px;
    padding: 48px 0 !important;
}

.spot_orders_empty_telescope {
    display: block !important;
    margin: 0 auto !important;
}

.spot_orders_empty_caption {
    margin: 16px 0 0;
    font-size: 14px;
    color: #6b7280;
    font-family: "Inter", sans-serif;
}

.spot_orders_placeholder_shell {
    min-height: 320px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

html[data-theme="dark"] .spot_orders_table_wrap,
html[data-theme="dark"] .spot_orders_placeholder_shell {
    background: #181a20;
}

html[data-theme="dark"] .spot_orders_table thead th {
    color: #848e9c;
    border-bottom-color: #2b3138;
}

html[data-theme="dark"] .spot_orders_table tbody td {
    color: #eaecef;
}

html[data-theme="dark"] .spot_orders_empty_caption {
    color: #9ca3af;
}

.spot_orders_empty_telescope {
    display: block;
    max-width: 120px;
    height: auto;
    filter: none;
}

html[data-theme="dark"] .spot_orders_empty_telescope {
    filter: invert(1) brightness(1.08);
}

body.light_theme .spot_orders_empty_telescope {
    filter: none !important;
}

html[data-theme="dark"] .spot_orders_filter_bar {
    background: #1e2329;
    border-bottom-color: #2b3138;
}

html[data-theme="dark"] .spot_orders_chip {
    color: #9ca3af;
}

html[data-theme="dark"] .spot_orders_chip.is-active {
    background: #2b3138;
    color: #eaecef;
}

html[data-theme="dark"] .spot_orders_side_select {
    background: #181a20;
    border-color: #2b3138;
    color: #eaecef;
}

html[data-theme="dark"] .spot_orders_reset {
    color: #9ca3af;
}

html[data-theme="dark"] .position_order .spot_orders_top {
    background: #181a20;
}

html[data-theme="dark"] .position_order .position_list.spot_orders_primary_tabs {
    background: #181a20;
    border-bottom-color: #2b3138;
}

html[data-theme="dark"] .position_order .spot_orders_primary_tabs li button {
    color: #9ca3af;
}

html[data-theme="dark"] .position_order .spot_orders_primary_tabs li.active button {
    color: #eaecef;
    border-bottom-color: #eaecef;
}

body.light_theme .trade_summary_table_lft_position_order.position_order {
    background: #ffffff;
}

.bs_dropbox.d-lg-block.false {
    margin-top: 0px;
}

.col-lg-6.ordermarketcntr {
    padding: 0px 2px;
    width: 48%;
}

.col-lg-6.letsidebar_tradetbl {
    /* min-width: 328px; */
    width: 52%;
}


body.light_theme .position_order .spot_orders_top {
    background: none;
}

body.light_theme .position_order .position_list.spot_orders_primary_tabs {
    background: none;
    border-bottom-color: #EDEFF2;
}

body.light_theme .spot_orders_filter_bar {
    background: none;
    border-bottom-color: #EDEFF2;
}

/* Tablet + mobile: primary tabs + chip filters — one row, scroll + left/right arrows when overflow */
@media (max-width: 991.98px) {


    .agce-margin-order-tabs-scroller .spot_limit {
        width: auto;
    }

    .position_order .top_th_easyop.spot_orders_top {
        display: block;
        min-width: 0;
        overflow: visible;
    }

    .stop_apr_card {
        margin-bottom: 20px;
    }

    .position_order .spot_orders_primary_tabs_scrollWrap {
        min-width: 0;
    }

    .position_order .position_list.spot_orders_primary_tabs.spot_orders_primary_tabs--scroller {
        padding: 0 5px;
    }

    .spot_orders_filter_bar {
        flex-wrap: nowrap;
        overflow-x: visible;
        overflow-y: visible;
        justify-content: flex-start;
        gap: 8px;
        padding: 12px 8px 10px;
        min-width: 0;
    }

    .spot_orders_filter_chips--scroll {
        /* flex-wrap: nowrap; */
        /* overflow-x: auto; */
        /* overflow-y: hidden; */
        -webkit-overflow-scrolling: touch;
        /* scrollbar-width: none; */
        /* overscroll-behavior-x: contain; */
        gap: 8px;
        padding: 0 5px;
    }

    .spot_orders_filter_chips--scroll::-webkit-scrollbar {
        display: none;
    }

    .spot_orders_chipsArrow {
        display: inline-flex;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        align-items: center;
        justify-content: center;
        /* width: 28px; */
        height: 28px;
        font-size: 18px;
        padding: 0;
        border-radius: 0px !important;
        border: none;
        border-radius: 999px;
        background: #26292f;
        color: #afafaf;
        box-shadow: none;
        z-index: 2;
    }

    body.light_theme .spot_orders_chipsArrow {
        background: #ffffff;
        color: #111827;
    }

    .spot_orders_chipsArrow--left {
        left: 0;
    }

    .spot_orders_chipsArrow--right {
        right: 0;
    }

    .spot_orders_chipsArrow.is-hidden {
        display: none !important;
    }

    .spot_orders_filter_actions {
        flex-shrink: 0;
    }

    .spot_orders_chip {
        flex: 0 0 auto;
    }
}

html[data-theme="dark"] .spot_orders_chipsArrow {
    background: #2b3138;
    color: #eaecef;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);
}

body.light_theme .spot_orders_chipsArrow {
    background: #ffffff;
    color: #7d7d7d;
}

/* Amount field: base / quote currency picker (Market, Stop Market, Stop Limit — not plain Limit) */
.trade_amt_denom_addon {
    display: flex;
    align-items: stretch;
}

.trade_amt_denom_select {
    position: relative;
    flex-shrink: 0;
    z-index: 5;
}

.trade_amt_denom_select__trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    padding: 0;
    margin: 0;
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    background: none;
    border: none;
    cursor: pointer;
    line-height: 1.2;
    height: 100%;
}

body.light_theme .trade_amt_denom_select__trigger {
    color: #070808;
}

.input-group-text.text-start.trade_amt_denom_addon.trade_amount_coin_badge {
    padding: 0;
    min-width: auto;
}

.trade_amt_denom_select__trigger:hover {
    background: none;
}

.trade_amt_denom_select__label {
    text-align: left;
}

.trade_amt_denom_select__chev {
    font-size: 14px;
    color: #fff;
}

body.light_theme .trade_amt_denom_select__chev {
    color: #070808;
}

.trade_amt_denom_select__panel {
    list-style: none;
    margin: 4px 0 0;
    padding: 6px 0;
    position: absolute;
    right: 0;
    top: 100%;
    min-width: 120px;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    z-index: 20;
}

.trade_amt_denom_select__option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
    padding: 10px 14px;
    border: none;
    background: transparent;
    font-size: 14px;
    font-weight: 600;
    color: #070808;
    cursor: pointer;
    text-align: left;
}

.trade_amt_denom_select__option:hover {
    background: #f5f5f5;
}

.trade_amt_denom_select__check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: rgb(255 255 255 / 30%);
    color: #fff;
    flex-shrink: 0;
}

body.light_theme .trade_amt_denom_select__check {
    background: #000;
}

.trade_amt_denom_select__check i {
    font-size: 10px;
    line-height: 1;
}

body.light_theme .trade_amt_denom_select__trigger {
    color: #070808;
}

body:not(.light_theme) .trade_amt_denom_select__trigger {

    color: #eaecef;
}

body:not(.light_theme) .trade_amt_denom_select__panel {
    background: #1e2329;
    border-color: #2b3138;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}

body:not(.light_theme) .trade_amt_denom_select__option {
    color: #eaecef;
}

body:not(.light_theme) .trade_amt_denom_select__option:hover {
    background: #2b3138;
}


@media screen and (max-width: 1367px) {

    .orderbook_two .buy_sell_row_price .scroll_y {
        height: 190px;
    }

}



@media screen and (max-width: 1200px) {


    .col-lg-6.ordermarketcntr {
        width: 50%;
        margin: 0px;
    }

    .col-lg-6.ordermarketcntr div#tab_3 {
        height: 660px;
        margin-top: 0px;
    }

    .orderbook_two .buy_sell_row_price .scroll_y {
        height: 225px;
    }

    .orderbook_two .buy_sell_row_price .scroll_y.orderbook-single-side {
        height: 490px;
        max-height: 490px;
    }

    .orderbook_two .buy_sell_row_price .scroll_y.orderbook-single-side.orderbook-asks-scroll.orderbook-asks-sell-list {
        height: 430px;
        max-height: 430px;
    }

    .col-lg-6.letsidebar_tradetbl {
        width: 50%;
        margin: 0px;
    }

    div#tab_3.d-none.d-lg-block {
        border-radius: 4px;
    }


}

@media screen and (max-width: 767px) {

    /* .bs_dropbox .limit_markettabs {
        overflow: hidden;
    } */

    .limit_markettabs {
        padding: 10px 16px 15px 16px;
    }

    .position_order .position_list.spot_orders_primary_tabs {
        border-bottom: none !important;
    }

    .spot_orders_empty_state {
        min-height: 500px;
    }

    #TVChartContainer iframe {
        height: 404px;
    }

    .trade_amt_denom_select__check {
        width: 12px;
        height: 12px;
    }

    .trade_amt_denom_select__check i {
        font-size: 10px;
    }

    .trade_amt_denom_select__option {
        padding: 4px 12px;
        font-size: 12px;
    }

    body .agce-margin-lvg-btn {
        padding: 9px 14px;
        border-radius: 8px;
        font-size: 13px;
    }

}

/* --- Spot BUY/SELL accents: dedicated classes (+ !important) override .spot_orders_table tbody td etc. --- */
.trade_summary_table_lft td.agce-spot-side-buy {
    color: #01bc8d !important;
}

.trade_summary_table_lft td.agce-spot-side-sell {
    color: #e45561 !important;
}

.trade_summary_table_lft .order_history_mobile_view .order_datalist .listdata li span.agce-spot-side-buy {
    color: #01bc8d !important;
}

.trade_summary_table_lft .order_history_mobile_view .order_datalist .listdata li span.agce-spot-side-sell {
    color: #e45561 !important;
}

.buysell_heder .custom-tabs li.buysell-tab.buy-tab a:not(.active) button span {
    color: #01bc8d !important;
}

.buysell_heder .custom-tabs li.sell-tab a:not(.active) button span {
    color: #e45561 !important;
}

html[data-theme="dark"] .trade_summary_table_lft table.spot_orders_table tbody td.agce-spot-side-buy {
    color: #01bc8d !important;
}

html[data-theme="dark"] .trade_summary_table_lft table.spot_orders_table tbody td.agce-spot-side-sell {
    color: #e45561 !important;
}

html[data-theme="dark"] .trade_summary_table_lft table.table_home tbody td.agce-spot-side-buy {
    color: #01bc8d !important;
}

html[data-theme="dark"] .trade_summary_table_lft table.table_home tbody td.agce-spot-side-sell {
    color: #e45561 !important;
}

.margin_surface_tab_strip {
    gap: 12px 16px;
}

/* --- Mobile Filter Popup Styles Ported from Margin --- */
.agce-margin-mobile-filter-wrap {
    display: none;
}

@media (max-width: 1200px) {
    .agce-margin-mobile-filter-wrap {
        display: block;
    }

    .spot_orders_chip {
        min-height: 34px;
    }
}

.spot_orders_filter_bar.agce-margin-filter-bar {
    flex-wrap: wrap;
    overflow-x: visible;
}

.agce-margin-filter-toggle-btn {
    border-radius: 6px;
    font-size: 13px;
    background: transparent;
    border: 1px solid #4a4a4a;
    color: inherit;
}

.agce-filter-overlay-active {
    display: flex !important;
    z-index: 99999999;
}

.agce-margin-filter-popup {
    height: auto !important;
    max-height: 80vh !important;
    padding-bottom: 60px;
}

.agce-margin-filter-popup-content {
    background: transparent !important;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 10px;
    padding-bottom: 15px !important;
}

.agce-margin-filter-popup-content>* {
    grid-column: 1 / -1;
}

.agce-margin-filter-popup-content>.agce-margin-filter-btn {
    grid-column: span 1;
}

.agce-margin-filter-popup-content>.agce-margin-filter-arrow {
    display: none !important;
}

.agce-margin-filter-apply-btn {
    background: #000000 !important;
    border: none !important;
    border-radius: 50px !important;
    font-weight: 600 !important;
    padding: 8px !important;
    font-size: 13px;
    color: white;
}

.agce-margin-filter-apply-btn:hover,
.agce-margin-filter-apply-btn:active {
    background: #141414 !important;
}

/* ── Trade page skeleton/shimmer while data loads ── */
@keyframes agce-shimmer {
    0% {
        background-position: -400px 0;
    }

    100% {
        background-position: 400px 0;
    }
}

.agce-skel {
    display: inline-block;
    border-radius: 4px;
    background: linear-gradient(90deg, rgba(128, 128, 128, 0.12) 25%, rgba(128, 128, 128, 0.22) 50%, rgba(128, 128, 128, 0.12) 75%);
    background-size: 800px 100%;
    animation: agce-shimmer 1.4s infinite linear;
    color: transparent !important;
    -webkit-user-select: none;
            user-select: none;
    min-width: 40px;
    min-height: 1em;
    vertical-align: middle;
}

.agce-skel--sm {
    min-width: 28px;
    min-height: 0.8em;
}

.agce-skel--md {
    min-width: 60px;
}

.agce-skel--lg {
    min-width: 90px;
}

/* Dark Theme Fixes for Filters Popup */
.agce-margin-filter-popup {
    background: rgb(30 35 41 / 50%) !important;
}

body.light_theme .agce-margin-filter-popup {
    background: rgb(255 255 255 / 20%) !important;
    box-shadow: 0px 5px 22px #0000009c;
}

body.light_theme .futures-margin-modal.position-fixed.w-100.h-100.top-0.start-0 {
    background-color: rgb(255 255 255 / 50%) !important;
}

.futures-margin-modal.position-fixed.w-100.h-100.top-0.start-0 {
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}

.agce-margin-filter-popup h6 {
    color: #eaecef !important;
}

body.light_theme .agce-margin-filter-popup h6 {
    color: #1e2329 !important;
}

.agce-margin-filter-popup .btn-close {
    filter: invert(1) brightness(200%);
}

body.light_theme .agce-margin-filter-popup .btn-close {
    filter: none;
}

.spot_orders_side_select {
    background: #181a20 !important;
    border-color: #2b3138 !important;
    color: #eaecef !important;
}

body.light_theme .spot_orders_side_select {
    background: #ffffff !important;
    border-color: #d1d5db !important;
    color: #111827 !important;
}

.spot_orders_reset {
    color: #eaecef !important;
}

body.light_theme .spot_orders_reset {
    color: #909397 !important;
}

.spot_orders_reset:hover {
    color: #ffffff !important;
}

body.light_theme .spot_orders_reset:hover {
    color: #111827 !important;
}

.agce-margin-filter-apply-btn {
    background: #fcd535 !important;
    color: #181a20 !important;
}

body.light_theme .agce-margin-filter-apply-btn {
    background: #000000 !important;
    color: #ffffff !important;
}

@supports (-webkit-touch-callout: none) {
    .trade-wrapper.spot {
        padding-bottom: env(safe-area-inset-bottom) !important;
    }
}

/* AGCX Custom Filter Select Styles */
.agce-custom-select-container {
    position: relative;
    width: auto;
    min-width: 95px;
    display: inline-block;
    margin-right: 6px;
    margin-bottom: 0;
    vertical-align: middle;
}

.agce-custom-select-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 30px;
    padding: 0 10px;
    background: #181a20;
    border: 1px solid #2b3139;
    border-radius: 4px;
    color: #eaecef;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    box-sizing: border-box;
    transition: border-color 0.2s, background-color 0.2s;
    gap: 8px;
    white-space: nowrap;
}

body.light_theme .agce-custom-select-trigger {
    background: #f6f6f7;
    border: 1px solid #cbd5e1;
    color: #1e2329;
}

/* .agce-custom-select-trigger:focus,
.agce-custom-select-trigger:hover {
    border-color: #d1aa67;
} */

.agce-custom-select-trigger i {
    font-size: 14px;
    transition: transform 0.2s ease;
    color: #848e9c;
}

.agce-custom-select-trigger i.open {
    transform: rotate(180deg);
}

.agce-custom-select-options {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    min-width: 100%;
    width: max-content;
    max-width: 200px;
    max-height: 220px;
    overflow-y: auto;
    background: #181a20;
    border: 1px solid #2b3139;
    border-radius: 6px;
    z-index: 100000;
    padding: 4px 0;
    margin: 0;
    list-style: none;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);
    box-sizing: border-box;
}

body.light_theme .agce-custom-select-options {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
}

.agce-custom-select-option {
    padding: 8px 14px;
    font-size: 12px;
    color: #eaecef;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.15s, color 0.15s;
    white-space: nowrap;
}

body.light_theme .agce-custom-select-option {
    color: #1e2329;
}

.agce-custom-select-option:hover {
    background: #2b3139;
    color: #d1aa67;
}

body.light_theme .agce-custom-select-option:hover {
    background: #f1f5f9;
    color: #d1aa67;
}

.agce-custom-select-option.selected {
    background: rgba(209, 170, 103, 0.15);
    color: #d1aa67;
    font-weight: 600;
}

body.light_theme .agce-custom-select-option.selected {
    background: rgba(209, 170, 103, 0.1);
    color: #d1aa67;
    font-weight: 600;
}

/* Scrollbar customization for custom dropdown list */
.agce-custom-select-options::-webkit-scrollbar {
    width: 4px;
}

.agce-custom-select-options::-webkit-scrollbar-track {
    background: transparent;
}

.agce-custom-select-options::-webkit-scrollbar-thumb {
    background: #474f59;
    border-radius: 4px;
}

body.light_theme .agce-custom-select-options::-webkit-scrollbar-thumb {
    background: #cbd5e1;
}

/* Mobile popup filter content adjustments */
.agce-margin-filter-popup-content .agce-custom-select-container {
    display: block;
    width: 100%;
    max-width: 100%;
    margin-bottom: 12px;
}

.agce-margin-filter-popup-content .agce-custom-select-trigger {
    height: 38px;
    font-size: 13px;
    padding: 0 12px;
    border-radius: 8px;
}

/* Table Header Side Select Dropdown Styles */
.th-side-select-container {
    position: relative;
    display: inline-block;
}

.th-side-select-trigger {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;
    font-size: 12px;
    -webkit-user-select: none;
            user-select: none;
    padding: 2px 6px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.th-side-select-trigger:hover {
    background-color: rgba(255, 255, 255, 0.08) !important;
}

.th-side-select-arrow {
    font-size: 14px;
    transition: transform 0.2s ease;
    opacity: 0.8;
}

.th-side-select-arrow.open {
    transform: rotate(180deg);
}

.th-side-select-menu {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    min-width: 90px;
    background: #181a20;
    border: 1px solid #2b3139;
    border-radius: 6px;
    padding: 0px 0;
    margin: 0;
    list-style: none;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    text-align: left;
}

.th-side-select-item {
    font-size: 12px;
    font-weight: 400;
    padding: 6px 12px;
    transition: background-color 0.15s ease;
    color: #eaecef;
}

.th-side-select-item.active {
    font-weight: 600;
    background-color: rgb(255 255 255 / 10%);
}

.th-side-select-item:hover {
    background-color: #2b3139 !important;
}

.th-side-select-check {
    color: #d3d3d3;
    font-size: 13px;
}

body.light_theme .th-side-select-check {
    color: #4e4e4e;
}

/* Light Theme Overrides */
body.light_theme .th-side-select-trigger:hover {
    background-color: rgba(0, 0, 0, 0.06) !important;
}

body.light_theme .th-side-select-menu {
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;
}

body.light_theme .th-side-select-item {
    color: #1e2329 !important;
}

body.light_theme .th-side-select-item:hover {
    background-color: #f1f5f9 !important;
}

body.light_theme .th-side-select-item.active {
    background-color: rgba(240, 185, 11, 0.1) !important;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TradePage/trade_new.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;AAEJ;;;;AAIA,iEAAiE;AACjE;IACI,aAAa;AACjB;;AAEA,wDAAwD;AACxD;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;;;;AAKA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;;;AAIA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;;IAEI,yBAAyB;IACzB,2BAA2B;IAC3B,6BAAqB;YAArB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;;IAGI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;;;;AAKA;IACI,WAAW;IACX,aAAa;AACjB;;;AAGA,aAAa;;AAEb;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,qCAAqC;AACzC;;;AAGA;;IAEI,UAAU;IACV,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,gCAAgC;IAChC,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;;AAGH;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,uFAAuF;AACvF;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb;;;AAGA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,UAAU;IACV,2BAA2B;IAC3B,kCAAkC;IAClC,WAAW;IACX,yCAAiC;YAAjC,iCAAiC;AACrC;;AAEA;IACI,2BAAsB;IAAtB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,wDAAwD;IACxD,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;GAIG;;AAEH;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;GAGG;;AAEH;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAC1B,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,sEAAsE;IACtE,6BAA6B;IAC7B,qBAAqB;IACrB,cAAc;IACd,kCAA0B;YAA1B,0BAA0B;IAC1B,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,uBAAuB;IACvB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,+BAA+B;IAC/B,kCAAkC;IAClC,gCAAgC;IAChC,qBAAqB;IACrB,UAAU;AACd;;AAEA,6GAA6G;;AAE7G;IACI,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,0BAA0B;IAC1B,WAAW;AACf;;;AAGA;;;;;IAKI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,0DAA0D;;AAE1D,0DAA0D;;AAE1D;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;;IAGI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;;;IAII,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,8CAA8C;IAC9C,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,gCAAgC;IAChC,uBAAuB;AAC3B;;;;;AAKA;;;;;KAKK;;;AAGL;;IAEI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;;IAEjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;;IAEI,wCAAwC;AAC5C;;;AAGA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;;GAEG;;AAEH;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,MAAM;IACN,UAAU;IACV,oCAAoC;AACxC;;;AAGA;IACI,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,iBAAiB;IACjB,iCAAiC;IACjC,SAAO;AACX;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;;;;;AAMA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;IACI,WAAW;IACX,iBAAiB;IACjB,4BAA4B;IAC5B,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,UAAU;IACV,kCAAkC;IAClC,0BAA0B;IAC1B,gBAAgB;AACpB;;;AAGA;;IAEI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,8EAA8E;AAC9E;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;;AAGA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,YAAY;AAChB;;;AAGA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,eAAe;IACf,gCAAgC;IAChC,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,0DAA0D;AAC9D;;AAEA;IACI,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;IAC1B,yCAAiC;YAAjC,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,SAAS;IACT,4BAA4B;IAC5B,cAAc;AAClB;;AAEA,iGAAiG;AACjG;;;;IAII,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,oEAAoE;AACpE;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,gCAAgC;IAChC,0DAA0D;AAC9D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,6CAA6C;IAC7C,SAAS;IACT,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,6DAA6D;AAC7D;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gCAAgC;AACpC;;;AAGA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yCAAiC;YAAjC,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,kCAAkC;IAClC,cAAc;AAClB;;;AAGA;IACI,2BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,eAAe;AACnB;;;AAGA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;IAII;AACJ;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;;IAGI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;;;;IAMI,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,kBAAkB;;AAElB;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;IACnB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,sCAAsC;IACtC,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yCAAyC;IACzC,UAAU;IACV,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;GAEG;;AAEH,sDAAsD;AACtD;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;IACxB,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,mFAAmF;AACnF;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,sBAAsB;AAC1B;;AAEA,6EAA6E;AAC7E;IACI,sDAAsD;IACtD,gGAAgG;IAChG,yBAAyB;AAC7B;;AAEA;IACI;yEACqE;IACrE,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;IACpD,uEAAuE;IACvE,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;IACI;yEACqE;IACrE,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,wEAAwE;IACxE,yBAAyB;AAC7B;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,gGAAgG;AAChG;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA,oDAAoD;AACpD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;;;AAIA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB;yDACqD;AACzD;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA,qFAAqF;AACrF;IACI,WAAW;IACX,SAAS;IACT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA,wEAAwE;AACxE;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,gHAAgH;AAChH;;IAEI,wBAAwB;IACxB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,cAAc;IACd,iDAAiD;IACjD,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;IAC3C,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,oFAAoF;AACpF;IACI,cAAc;IACd,aAAa;AACjB;;AAEA,iDAAiD;AACjD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,oFAAoF;AACpF;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,iHAAiH;IACjH,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;IACZ,SAAS;IACT,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IAEvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,2EAA2E;AAC/E;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;;;;yBAIqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,sCAAsC;IACtC,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IAEnB,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;;;AAIA,eAAe;;AAEf;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;AAC9B;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,aAAa;AACjB;;AAEA,qFAAqF;AACrF;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;AAEJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA,6EAA6E;AAC7E;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,6BAA6B;IAC7B,iBAAiB;AACrB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;;;;;;;kBAOkB;;AAElB;IACI,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;;GAKG;;AAEH,sGAAsG;;AAEtG;;;;;GAKG;;AAEH;IACI,uBAAuB;AAC3B;;AAEA;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,QAAQ;IACR,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,QAAQ;AACZ;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAoCI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;;;;;;;GAWG;;AAEH;IACI,oCAAoC;AACxC;;AAEA;;;;;;GAMG;;;AAGH;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;;;AAIA;IACI,eAAe;IACf,SAAS;IACT,aAAa;IACb,WAAW;IACX,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,kCAAkC;IAClC,0BAA0B;IAC1B,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;;;AAIA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,MAAM;IACN,SAAS;IACT,WAAW;IACX,OAAO;IACP,mBAAmB;IACnB,uBAAuB;;AAE3B;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA;QACI,4BAA4B;QAC5B,gCAAgC;IACpC;;;;AAIJ;;;AAGA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,4BAA4B;QAC5B,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;QAC3B,aAAa;IACjB;;AAEJ;;AAEA,6HAA6H;AAC7H;IACI;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,+BAA+B;QAC/B,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA,gFAAgF;IAChF;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,0CAA0C;QAC1C,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,+BAA+B;QAC/B,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,4BAA4B;QAC5B,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;QAC3B,aAAa;IACjB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;;IAGA;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA,kDAAkD;IAClD;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA,uDAAuD;IACvD;QACI,wBAAwB;IAC5B;;IAEA,iCAAiC;IACjC;QACI,UAAU;IACd;;IAEA;QACI,+BAA+B;QAC/B,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gCAAgC;IACpC;;IAEA,iDAAiD;IACjD;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA,2BAA2B;IAC3B;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,+BAA+B;QAC/B,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,6BAA6B;QAC7B,wBAAwB;QACxB,4BAA4B;IAChC;;;IAGA;QACI,mBAAmB;QACnB,OAAO;QACP,SAAS;IACb;;;IAGA;QACI,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,kCAAkC;IACtC;;AAEJ;;;AAGA;;;IAGI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;;AAGJ;;;AAGA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,eAAe;QACf,aAAa;IACjB;;IAEA;;WAEO;IACP;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;;;;AAKJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;AAEJ;;AAEA;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;;AAGJ;;;AAGA;;IAEI;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,0BAA0B;IAC9B;;AAEJ;;AAEA,kEAAkE;AAClE;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;AAEJ;;AAEA,mEAAmE;AACnE;;IAEI,2BAA2B;IAC3B;QACI,2BAA2B;QAC3B,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,qCAAqC;IACzC;;IAEA,kEAAkE;IAClE;;QAEI,gDAAgD;QAChD,6CAA6C;QAC7C,2BAA2B;IAC/B;;IAEA,iFAAiF;IACjF;;QAEI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,WAAW;QACX,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yCAAyC;QACzC,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA,sEAAsE;IACtE;QACI,0BAA0B;QAC1B;;;8BAGsB;IAC1B;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI;wBACgB;QAChB,SAAS;IACb;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;QACvB,SAAS;QACT,mDAAmD;QACnD,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,uBAAuB;QACvB,sBAAsB;IAC1B;AACJ;;AAEA,8CAA8C;AAC9C;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,6EAA6E;AAC7E;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,YAAY;QACZ,YAAY;QACZ,6BAA6B;QAC7B,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,gBAAgB;QAChB,2CAA2C;QAC3C,iCAAiC;QACjC,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,oBAAoB;QACpB,6BAA6B;QAC7B,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,UAAU;IACd;;IAEA;QACI,SAAO;QACP,aAAa;QACb,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;;AAGA;IACI;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;;AAGJ;;AAEA;IACI;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI;QACI,YAAY;QACZ,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA,eAAe;AACf;;IAEI,oCAAoC;IACpC;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,yBAAyB;QACzB,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,oCAAoC;QACpC,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;IACf;;;IAGA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;;;IAIA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA,4BAA4B;IAC5B;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,kCAAkC;QAClC,kCAA0B;gBAA1B,0BAA0B;QAC1B,8BAA8B;QAC9B,aAAa;QACb,qBAAqB;QACrB,uBAAuB;QACvB,2BAA2B;IAC/B;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;IACJ;;IAEA;QACI;YACI,2BAA2B;QAC/B;;QAEA;YACI,wBAAwB;QAC5B;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,2BAA2B;QAC3B,kCAA0B;gBAA1B,0BAA0B;QAC1B,2BAA2B;QAC3B,4BAA4B;QAC5B,aAAa;QACb,+BAA+B;QAC/B,sBAAsB;QACtB,4BAA4B;QAC5B,gCAAgC;QAChC,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,6CAAqC;gBAArC,qCAAqC;IACzC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,2BAA2B;QAC3B,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,YAAY;QACZ,cAAc;QACd,eAAe;QACf,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,sCAAsC;IAC1C;;;;IAIA;QACI,0CAA0C;IAC9C;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,SAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,UAAU;QACV,cAAc;QACd,QAAQ;QACR,2BAA2B;QAC3B,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;OAEG;;IAEH;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,wBAAwB;QACxB,gBAAgB;IACpB;;;;IAIA;QACI,SAAS;QACT,QAAQ;QACR,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,kCAAkC;QAClC,2BAA2B;QAC3B,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,kCAAkC;IACtC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;OAGG;;IAEH;QACI,aAAa;QACb,8BAA8B;QAC9B,QAAQ;QACR,kCAAkC;IACtC;;IAEA;QACI,aAAa;QACb,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,SAAS;QACT,cAAc;QACd,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,iBAAiB;QAEjB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,QAAQ;QACR,aAAa;IACjB;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;;QAEI,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB,4BAA4B;QAC5B,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,6BAA6B;QAC7B,iBAAiB;QACjB,0BAA0B;IAC9B;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,SAAS;QACT,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,4BAA4B;IAChC;;IAEA;QACI,WAAW;QACX,4BAA4B;QAC5B,SAAS;QACT,UAAU;QACV,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV,OAAO;QACP,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;OAEG;;IAEH;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,UAAU;QACV,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kCAAkC;QAClC,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;QACf,WAAW;QACX,0CAA0C;QAC1C,0BAA0B;QAC1B,kCAAkC;QAClC,MAAM;QACN,SAAS;QACT,iBAAiB;QACjB,OAAO;QACP,aAAa;QACb,gBAAgB;QAChB,uBAAuB;QACvB,eAAe;QACf,eAAe;IACnB;;;IAGA;QACI,wCAAwC;IAC5C;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,4BAA4B;QAC5B,6BAA6B;QAC7B,gBAAgB;QAChB,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,kCAAkC;QAClC,gCAAgC;QAChC,gBAAgB;IACpB;;IAEA;;QAEI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kCAAkC;QAClC,gBAAgB;QAChB,kCAAkC;QAClC,0BAA0B;QAC1B,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;;IAGA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;;IAGA;;;QAGI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI,wEAAwE;IACxE;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,2FAA2F;IAC3F;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,aAAa;QACb,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI;AACJ;;AAEA,kGAAkG;AAClG;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,sCAAsC;IACtC,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,0FAA0F;AAC1F;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gCAAgC;IAChC,4BAA4B;IAC5B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,qGAAqG;AACrG;;;IAGI;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;QACnB,2BAA2B;QAC3B,QAAQ;QACR,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,wBAAwB;QACxB,iCAAiC;QACjC,2BAA2B;QAC3B,oCAAoC;QACpC,QAAQ;QACR,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,QAAQ;QACR,2BAA2B;QAC3B,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,YAAY;QACZ,eAAe;QACf,UAAU;QACV,6BAA6B;QAC7B,YAAY;QACZ,oBAAoB;QACpB,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mGAAmG;AACnG;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,UAAU;IACV,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;;IAEI;QACI,aAAa;IACjB;;AAEJ;;;;AAIA;;;IAGI;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;;AAGJ;;AAEA;;IAEI;;OAEG;;IAEH;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;AAEJ;;AAEA,8GAA8G;AAC9G;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA,0DAA0D;AAC1D;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA,uDAAuD;AACvD;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,+HAA+H;IAC/H,2BAA2B;IAC3B,4CAA4C;IAC5C,6BAA6B;IAC7B,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,uCAAuC;AACvC;IACI,0CAA0C;AAC9C;;AAEA;IACI,6CAA6C;IAC7C,kCAAkC;AACtC;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI;QACI,sDAAsD;IAC1D;AACJ;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,sBAAsB;IACtB,oDAAoD;IACpD,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;GAGG;;AAEH;IACI,eAAe;IACf,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,gBAAgB;AACpB;;AAEA,qDAAqD;AACrD;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,uDAAuD;AAC3D;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,gDAAgD;AACpD;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,qDAAqD;AACzD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oDAAoD;AACxD","sourcesContent":[".spot-container {\n    color: var(--white-color);\n}\n\n\n.price_item_value .td_div img {\n    width: 20px;\n    margin-right: 5px !important;\n}\n\n.trade-wrapper {\n    padding-top: 4px !important;\n}\n\n@media (min-width: 1920px) {\n\n    .trade_body .fluid-header {\n        padding: 4px 0;\n    }\n}\n\n@media (max-width: 1580px) {\n    .trade_body .fluid-header {\n        padding: 5px 15px;\n    }\n\n    .trade-wrapper {\n        padding-top: 4px !important;\n    }\n\n}\n\n\n\n/* Mobile Favourites Popup - Hidden by default (desktop/tablet) */\n.mobile-favourites-popup-overlay {\n    display: none;\n}\n\n/* Mobile Favourites Toggle Button - Hidden by default */\n.mobile-favourites-toggle-btn {\n    display: none;\n}\n\n\n.spot-container-main {\n    display: flex;\n    flex-direction: column;\n    /*padding: 0 15px;*/\n    flex: 1;\n}\n\n.spot-container-main .top {\n    display: flex;\n}\n\n.trade_row {\n    margin: 0 0;\n}\n\n.trade_col {\n    padding: 0 5px;\n    width: 100%;\n}\n\n\n\n\n.spot-container-main .top-left {\n    flex-grow: 1;\n}\n\n.spot-container-main .top-right {\n    width: 380px;\n}\n\n\n#TVChartContainer {\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n#TVChartContainer iframe {\n    border-radius: 10px;\n    height: 594px;\n}\n\n.tradesummary {\n    height: auto;\n    min-height: 0;\n}\n\n.container-chart-briefing {\n    height: 80px;\n    position: relative;\n    justify-content: flex-start;\n    width: 100%;\n    padding: 20px;\n    display: flex;\n    align-items: center;\n}\n\n\n\n.text-danger {\n    color: #E45561 !important;\n}\n\nbody .assets_right {\n    border-radius: 6px;\n}\n\nbody .trade_summary_table_lft {\n    border-radius: 6px;\n}\n\n.trade_card,\n.spotLists {\n    background: #181A20;\n    border: none;\n    border-radius: 6px;\n    overflow: hidden;\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none;\n    position: relative;\n    color: #fffffff2;\n}\n\n\nbody.light_theme.trade_card,\nbody.light_theme.spotLists {\n    background-color: #ffffff;\n    border: 1px solid #7878781a;\n    backdrop-filter: none;\n}\n\n.container-chart-briefing-info {\n    font-size: 12px;\n    text-align: left;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\ndd,\ndl,\ndt {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: block;\n    line-height: 1.5;\n    font-weight: 600;\n}\n\n.container-chart-briefing h2 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    padding-right: 20px;\n    cursor: pointer;\n    font-weight: 700;\n    color: #ffffff;\n}\n\n.container-chart-briefing-info dd.big,\n.container-chart-briefing-info dt.big {\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.container-chart-briefing-info dd.green,\n.container-chart-briefing-info dt.green {\n    color: #01BC8D !important;\n}\n\n.container-chart-briefing .displayName>span {\n    padding-right: 10px;\n}\n\n\n.trade-wrapper .btn {\n    justify-content: center;\n}\n\ndd {\n    font-weight: 700;\n}\n\n\n\n\n.tv-chart {\n    width: 100%;\n    height: 507px;\n}\n\n\n/*order book*/\n\n.card_title {\n    font-size: 16px;\n    font-weight: 700;\n    text-align: center;\n    padding-bottom: 1rem;\n    color: currentColor;\n}\n\n\n.trade_tabs {\n    padding: 10px;\n}\n\n.trade_card_body.single-widget ul li a {\n    font-size: 14PX;\n}\n\n.price_card_head {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    font-family: \"Inter\", sans-serif;\n    line-height: 12px;\n    justify-content: space-between;\n    height: 24px;\n    color: #87909F;\n    line-height: 24px;\n    /* border-bottom: 1px solid #2b2f39 */\n}\n\n\n.price_card_body::-webkit-scrollbar,\n.scroll_y::-webkit-scrollbar {\n    width: 3px;\n    background-color: transparent;\n}\n\n.price_card_body::-webkit-scrollbar-thumb,\n.scroll_y::-webkit-scrollbar-thumb {\n    border-radius: 3px;\n    background: rgb(106 106 106 / 21%);\n}\n\n.price_item_value {\n    display: flex;\n    position: relative;\n    z-index: 1;\n    color: #F2F4F6;\n    font-family: \"Inter\", sans-serif;\n    width: 100%;\n    padding: 2px 0;\n    justify-content: space-between;\n    font-weight: 500;\n    align-items: center;\n}\n\n.price_item_value:hover {\n    background: #ffffff14;\n}\n\nbody.light_theme.trade-wrapper {\n    background-color: #f5f5f55e;\n}\n\nbody.light_theme.price_item_value {\n    /* border-bottom: 1px solid rgb(0 0 0 / 5%); */\n    border-color: #58585814;\n}\n\n.price_item_value span {\n    display: block;\n    /*color: #ffffff;*/\n    font-size: 11px;\n}\n\n/* \n.price_item_value span.text-green,\n.price_item_value span.text-danger {\n    font-weight: 500;\n}\n\n.price_item_value span:first-child,\n.price_card_head>div:first-child {\n    display: block;\n    width: 33.33333%;\n    padding-left: 10px;\n}\n\n.price_item_value span:nth-child(2),\n.price_card_head>div:nth-child(2) {\n    display: block;\n    width: 33.33333%;\n    text-align: center;\n}\n\n.price_item_value span:last-child,\n.price_card_head>div:last-child {\n    display: block;\n    width: 33.33333%;\n    text-align: right;\n    padding-right: 10px;\n    font-weight: 600;\n} */\n\n\n.price_item_value:last-child {\n    /* border: 0; */\n}\n\n.live_ppc {\n    font-weight: 600;\n    padding: 1rem 0;\n    line-height: 1;\n}\n\n.price_card_body.price_card_body_full,\n.scroll_y {\n    height: 450px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.buy_sell_row_price .scroll_y {\n    height: 230px;\n}\n\n/* Full-height scroll for bids-only / asks-only (replaces #buy_orders / #sell_orders) */\n.buy_sell_row_price .scroll_y.orderbook-single-side {\n    height: 520px;\n}\n\n.buysell_card {\n    /* height: 533px; */\n}\n\n.spot-container-right-right {\n    flex: 0 0 300px;\n    max-width: 300px;\n}\n\n.scroll_y_mt {\n    height: 322px;\n}\n\ndiv#tab_3 {\n    height: 594px;\n    margin-top: 66px;\n}\n\n.trade_card.p-2.overflow_card.mb-1 {\n    width: calc(100% + 28.46%);\n    height: 62px;\n    margin-bottom: 4px !important;\n}\n\n.order-4 {\n    margin: 0;\n}\n\n\n.assets_list {\n    /* width: 100%; */\n    margin: 57px 21px 20px;\n    position: relative;\n    z-index: 666;\n}\n\n.trade_card.trade_chart.buysell_card .assets_list {\n    margin: 0px 21px 20px;\n}\n\n.assets_list ul {\n    font-size: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    justify-content: space-between;\n    align-items: center;\n    color: #fff;\n}\n\n.assets_list ul li {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.assets_btn {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    margin: 20px 0px;\n}\n\n.assets_btn button {\n    width: 100%;\n    background-color: #2B313C;\n    color: #414141;\n    font-weight: 700;\n    border: none;\n    font-size: 16px;\n    padding: 7px 16px;\n    border-radius: 50px;\n}\n\n.assets_list h4 {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.assets_list .top_heading {\n    margin-bottom: 10px;\n}\n\n.assets_list .more_btn {\n    margin: 0px;\n}\n\n\n.trade_chart .form-select-sm {\n    padding: 9px 10px !important;\n    font-size: 12px;\n    background: #22242c;\n    border-radius: 4px !important;\n    border-color: #2d303a00;\n    box-shadow: none;\n    color: #F2F4F6;\n}\n\n.buysellform>p {\n    margin: 7px 0 11px;\n    font-size: 14px;\n}\n\n.btn-mini {\n    font-size: 13px !important;\n    padding: 9px;\n    border-radius: 50px;\n    font-weight: 500;\n}\n\n.buy_sell_cards ul.nav.custom-tabs {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: \"Inter\", sans-serif;\n    padding: 0;\n    box-shadow: none !important;\n    background: transparent !important;\n    width: 100%;\n    backdrop-filter: unset !important;\n}\n\n.buy_sell_cards ul.nav.custom-tabs.nav_order li {\n    max-width: fit-content;\n    flex: 1 1 auto;\n    text-align: center;\n\n}\n\n.buy_sell_cards ul.nav.custom-tabs.nav_order li a {\n    opacity: 0.40;\n}\n\n.buy_sell_cards ul.nav.custom-tabs.nav_order li a.active {\n    opacity: 1 !important;\n}\n\n\n.buy_sell_cards ul.nav.custom-tabs li a {\n    /* box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px; */\n    display: block;\n    text-align: center;\n    border-radius: 40px;\n    padding: 4px 6px;\n    color: #fff;\n    background-color: #ffffff1a !important;\n    font-size: 13px;\n    font-weight: 600;\n    margin: 0 3px;\n}\n\n.buy_sell_cards ul.nav.custom-tabs li a.active {\n    color: #000 !important;\n    background-color: #fea903 !important;\n    opacity: 1 !important;\n}\n\n.buy_sell_cards ul.nav.custom-tabs li a.active {\n    color: #e9e9e9 !important;\n}\n\nbody.light_theme.buy_sell_cards ul.nav.custom-tabs li a {\n    background-color: #f1f4f4;\n    color: rgba(0, 0, 0, 0.75);\n}\n\n.custom-tabs li.buy-tab a:hover {\n    color: rgba(255, 255, 255, 0.75);\n    /*background-color: var(--bs-green)54;*/\n}\n\n.custom-tabs li.sell-tab a:hover {\n    color: rgba(255, 255, 255, 0.75);\n    /*background-color: #fe535b2b;*/\n}\n\n.custom-tabs li.buysell-tab a {\n    cursor: pointer;\n}\n\n.buysell_heder .custom-tabs li a {\n    cursor: pointer;\n}\n\n/* .custom-tabs li.sell-tab a.active,\n.custom-tabs li.sell-tab a:active {\n    color: #fff !important;\n    background-color: #ed5765 !important;\n} */\n\nbutton.btn.btn-danger {\n    color: #fff !important;\n    background-color: #E45561 !important;\n}\n\n/* .custom-tabs li.buysell-tab a.active {\n    color: #fff !important;\n    background: #01BC8D !important;\n} */\n\n.text-green {\n    color: #01BC8D;\n}\n\n.spot-deal-warp {\n    margin-top: 25px;\n}\n\n.custom-tabs {\n    color: var(--white-color);\n    background: #ffffff1c;\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    padding: 4px;\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 50px;\n    display: inline-flex;\n}\n\n.spot .input-group {\n    background: transparent;\n    border-radius: 40px;\n    overflow: hidden;\n    /* box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px; */\n}\n\n.spot .input-group>span {\n    text-align: center !important;\n}\n\n.spot .input-group>span small {\n    text-align: center;\n    margin: 0 auto;\n}\n\n.input-group-text {\n    /*background-color: #20202d0d;*/\n    /* border: 1px solid #20202d; */\n    border-radius: 0;\n    color: currentColor;\n    line-height: 1.2;\n    min-width: 76px;\n    font-weight: 500;\n    border: 0;\n    background: transparent;\n}\n\n.input-group-text small {\n    font-size: 75%;\n}\n\n.spot .form-control,\n.spot select {\n    color: currentColor;\n    background-color: #2f2f39;\n    border: 0;\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    border-radius: 3px !important;\n    background: #ffffff17;\n    color: #ffffff;\n    backdrop-filter: blur(5px);\n    border: 1px solid #ffffff1c;\n    padding: 7px 18px;\n    min-width: unset;\n    border-radius: 50px !important;\n}\n\nbody.light_theme.spot .form-control {\n    background-color: transparent;\n}\n\n.form-control:focus {\n    box-shadow: none;\n}\n\n.btn-group.btn-group-mini {\n    width: 100%;\n    border-radius: 0 !important;\n    border: 0;\n    background: transparent;\n    margin-left: auto !important;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 5px;\n}\n\n.btn-group.btn-group-mini * {\n    border-block: none;\n    /* line-height: 24px; */\n    font-size: 12px !important;\n    font-weight: 500;\n    border: 0;\n    transition: 0.0s;\n    padding: 15px 0px 0px;\n    color: #535963 !important;\n    margin: 0 auto !important;\n    width: -webkit-fill-available;\n    text-align: left;\n    display: grid;\n    min-height: auto;\n    box-shadow: none !important;\n    /* height: 24px; */\n    /* border-radius: 0px !important; */\n    background: none;\n    /* border: 1px solid #2d303a; */\n    -webkit-backdrop-filter: blur(5px);\n    /* backdrop-filter: blur(5px); */\n    /* min-width: 36px; */\n    opacity: 1;\n}\n\n/* .btn-group.btn-group-mini label.btn:hover{ background: #22242c !important; color: #f3bb2b !important; }  */\n\nbody.light_theme.btn-group.btn-group-mini * {\n    background: rgb(171 171 171 / 12%);\n    border: 1px solid rgb(234 239 244);\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    color: #000;\n}\n\n\n.btn-check:active+.btn-outline-success:focus,\n.btn-check:checked+.btn-outline-success:focus,\n.btn-outline-success.active:focus,\n.btn-outline-success.dropdown-toggle.show:focus,\n.btn-outline-success:active:focus {\n    box-shadow: none !important;\n}\n\n.btn-group.btn-group-mini *:focus {\n    background: transparent;\n}\n\n.data-buy .btn-group.btn-group-mini .btn-outline-success {}\n\n.data-sell .btn-group.btn-group-mini .btn-outline-danger {}\n\n.btn-dark {\n    background: #ffffff26;\n}\n\n.btn-check+.btn:hover {\n    color: #ffffff;\n}\n\n.btn-check+.btn:hover {\n    color: var(--bs-btn-color);\n    background-color: var(--bs-btn-bg);\n    border-color: non;\n}\n\n.data-buy .btn-group.btn-group-mini .btn-check:checked+.btn-outline-success,\n.data-buy .btn-group.btn-group-mini .btn-outline-success:hover,\n.data-buy .btn-group.btn-group-mini .btn-outline-success.active {\n    background: #00000000;\n    border-color: #00000000;\n}\n\n.data-buy .btn-group.btn-group-mini .btn-outline-success.active {\n    background: rgba(2, 192, 118, 0.15) !important;\n    border-color: #fff !important;\n    color: #fff !important;\n}\n\n.data-sell .btn-group.btn-group-mini .btn-check:checked+.btn-outline-danger,\n.data-sell .btn-group.btn-group-mini .btn-outline-danger:hover,\n.data-sell .btn-group.btn-group-mini .btn-outline-danger.active {\n    background: #00000000;\n    border-color: #00000000;\n}\n\n.data-sell .btn-group.btn-group-mini .btn-outline-danger.active {\n    background: rgba(228, 85, 97, 0.15) !important;\n    border-color: #fff !important;\n    color: #fff !important;\n}\n\nhtml[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-check:checked+.btn-outline-success,\nhtml[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-outline-success:hover,\nhtml[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-check:checked+.btn-outline-danger,\nhtml[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-outline-danger:hover {\n    background: #ffffff00 !important;\n    border-color: #ffffff00 !important;\n}\n\nhtml[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-outline-success.active {\n    background: rgba(2, 192, 118, 0.15) !important;\n    border-color: #02c076 !important;\n    color: #ffff !important;\n}\n\nhtml[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-outline-danger.active {\n    background: rgba(228, 85, 97, 0.15) !important;\n    border-color: #E45561 !important;\n    color: #ffff !important;\n}\n\n\n\n\n/* .data-sell .btn-group.btn-group-mini .btn-check:checked + .btn-outline-success{ \n      border-color: var(--bs-green) !important;\n  }\n  .data-sell .btn-group.btn-group-mini .btn-check:checked + .btn-outline-danger{ \n      border-color: var(--bs-red) !important;\n  } */\n\n\n.trade-wrapper select,\n.trade-wrapper .nice-select {\n    box-shadow: none;\n    height: 30px;\n    background: #f0f0f00a;\n    color: #757575;\n    font-size: 12px;\n    font-weight: 500;\n    width: 100%;\n    /* backdrop-filter: blur(5px); */\n    border-radius: 4px !important;\n    padding: 0 8px;\n}\n\nbody.light_theme .trade-wrapper select {\n    background: #F6F6F7;\n    color: #545454;\n}\n\nbody.light_theme .trade-wrapper .nice-select {\n    background: #F6F6F7;\n    color: #545454;\n}\n\n.trade-wrapper select *,\n.trade-wrapper .nice-select * {\n    /* font-size: 13px; */\n    color: #ffffff !important;\n    background: #000;\n}\n\nbody.light_theme.trade-wrapper select *,\nbody.light_theme.trade-wrapper .nice-select * {\n    color: #333333 !important;\n    background: #ffffff;\n}\n\n.num-select,\n.num-select:focus {\n    box-shadow: none !important;\n}\n\n.btn-block {\n    display: block;\n}\n\nsmall.note {\n    font-size: 74%;\n    display: block;\n    text-align: center;\n    margin: 18px 12px 0;\n    line-height: 1.2;\n}\n\n.buy_sell_cards button {\n    margin: 0px;\n}\n\n.btn-group.btn-group-mini label.last-child {\n    text-align: right;\n    width: auto;\n}\n\n.btn-group.btn-group-mini label.last-child::before {\n    right: 0px;\n    left: inherit;\n}\n\n.trade_assets {\n    margin-top: 1rem;\n}\n\n.trade_assets .product-owner {\n    padding: 0.5rem 0;\n\n    border-bottom: 1px solid #2f2f39;\n}\n\n.trade_assets .product-owner:last-child {\n    border-bottom: 0;\n}\n\nbody.light_theme.trade_assets .product-owner {\n    border-color: rgb(0 0 0 / 5%);\n}\n\n\n.trade_card table.table,\n.trade_card tbody tr:hover {\n    background-color: transparent !important;\n}\n\n\n.form-select-sm {\n    padding: 9px 6px !important;\n    height: unset !important;\n    /* width: min-content !important; */\n    /* min-width: unset !important; */\n}\n\n/* .treade_card_header.tch_main_tab {\n    display: none;\n} */\n\n.trade_card .table> :not(caption)>*>* {\n    padding: .5rem .5rem;\n    line-height: 1.5 !important;\n    vertical-align: middle;\n    font-size: 11px;\n    font-weight: 400;\n}\n\n.trade-wrapper .orderbook-table {\n    position: relative;\n}\n\n.trade-wrapper .orderbook-table th {\n    font-size: 12px;\n    align-items: start !important;\n    font-weight: 500;\n    font-family: \"Inter\", sans-serif;\n    color: #87909F;\n    position: static;\n    padding: 4px 12px;\n    top: 0;\n    z-index: 5;\n    background-color: #181a20 !important;\n}\n\n\n.trade_card .table>.btn {\n    margin: 0;\n}\n\n\n.spot-container-main .bottom {\n    display: flex;\n    min-height: 500px;\n    /*border-top: 1px solid #191e23;*/\n    flex: 1;\n}\n\n\n.bottom-left {\n    width: calc(100% - 380px);\n}\n\n.bottom-right {\n    width: 380px;\n}\n\nul.nav.custom-tabs.order_his_tabs li {\n    max-width: -webkit-fill-available;\n    width: auto;\n    padding: 0;\n}\n\nul.nav.custom-tabs.order_his_tabs {\n    justify-content: flex-start;\n}\n\nul.nav.custom-tabs.order_his_tabs li a {\n    padding: 8px 13px;\n    height: unset !important;\n    line-height: 1;\n}\n\n.ant-list-item {\n    display: flex;\n    height: 42px;\n    padding: 5px 16px;\n    cursor: pointer;\n}\n\n.rankItem {\n    height: 27px;\n    line-height: 12px;\n    width: 144px;\n}\n\n\n\n\n\n/* .spotLists {\n    width: 360px;\n    min-height: 360px;\n    max-width: calc(100% - 12px);\n    padding-bottom: 10px;\n    overflow-y: auto;\n    overflow-x: hidden; \n    position: absolute;\n    top: 128px;\n    left: 12px;\n    z-index: 111111;\n    border-radius: 9px;\n    display: none;\n    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;\n    padding: 0;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n} */\n\n.spotLists {\n    width: 100%;\n    min-height: 360px;\n    max-width: calc(100% - 12px);\n    padding-bottom: 10px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    /* background: #ffffff12; */\n    /* position: absolute; */\n    /* top: 128px; */\n    /* left: 12px; */\n    z-index: 111111;\n    border-radius: 9px;\n    display: none;\n    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;\n    padding: 0;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    max-width: 550px;\n}\n\n\n.spotLists.active {\n\n    display: block !important;\n\n}\n\n.show_spot {\n    display: block !important;\n}\n\n.spotList .scroll_y {\n    height: 357px;\n}\n\n.spot-list {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 360px;\n    min-height: 100%;\n    background: #1f252a;\n}\n\n.spot-list-search {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    padding: 10px;\n    padding-top: 0;\n}\n\n.spot-list-search .ivu-input {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    padding: 0 12px;\n}\n\nbody.light_theme.spot-list-search .ivu-input {\n    background: rgb(241 244 244);\n    border: 1px solid rgb(241 244 244);\n}\n\n.container-chart-briefing-info h6 {\n    font-size: 16px;\n}\n\n.spot-list-search i {\n\n    margin-right: 14px;\n}\n\n.spot-list-search .ivu-input input {\n    background: transparent;\n    border: 0;\n    outline: 0 !important;\n    color: var(--white-color);\n    padding: 6px 3px;\n    font-size: 14px;\n    width: 100%;\n}\n\nbody.light_theme .spot-list-search .ivu-input input {\n    color: #424242;\n}\n\n.spot-list-search .ivu-input input:focus {\n    border: none !important;\n\n}\n\n.price_card {\n    padding: 10px 0;\n    padding: 0;\n}\n\n.price_card .price_card_head {\n    padding: 0 15px;\n}\n\n.price_card_body {\n    padding: 0 10px;\n}\n\n.trade_history_tab .price_card_body {\n    padding: 0 15px;\n}\n\n/* Buy-only / sell-only order book (IDs removed; use .orderbook-single-side) */\n.price_card_body.scroll_y.center_cntr.orderbook-single-side {\n    justify-content: start;\n}\n\n.subhead_cntr {\n    font-size: 12px;\n    font-weight: 400;\n    justify-content: start;\n    text-align: left;\n    line-height: 15px;\n    color: #fff;\n}\n\nspan.tokensubcnt {\n    color: #949AA4;\n    font-size: 12px;\n}\n\n.trade_favourites_lft img.round_img {\n    width: 24px !important;\n    height: 24px !important;\n    min-width: 24px;\n}\n\n.price_cntr_star i {\n    color: #565A62;\n    font-size: 17px !important;\n}\n\n.trade_favourites_lft .price_item_value {\n    padding: 10px\n}\n\n.price_cntr_star {\n    gap: 7px;\n}\n\n.trade_history_tab .price_card_head {\n    padding: 0px 15px;\n}\n\n.price_card_body.scroll_y {\n    padding-right: 5px;\n    padding-left: 5px;\n}\n\n.price_item_value .ri-xl {\n    font-size: 116%;\n}\n\n.spot-list-search .ivu-input::placeholder {\n    color: #ffffffde;\n}\n\n.buy_sell_cards ul.nav.custom-tabs li a.active {\n    color: #000 !important;\n    background-color: #fea903 !important;\n}\n\n\nbody.light_theme.container-chart-briefing .spotList {\n    background: #ffffff;\n    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;\n}\n\n\n.trade-wrapper .favouriteData {\n    text-align: center;\n    padding: 5% 0;\n    /* font-size: 300%; */\n}\n\nhtml[data-theme='dark'] .trade-wrapper .favouriteData p {\n    color: #ffffff;\n    margin: 10px 0px;\n}\n\n\n.scroll_y .favouriteData {\n    height: 100%;\n}\n\n\n.btn.btn-warning {\n    background-color: #f3bb2b !important;\n    color: #222222 !important;\n    border-radius: 50px !important;\n}\n\n.mrkt_trde_tab {\n    display: flex;\n    align-items: center;\n    justify-content: start !important;\n    font-size: 18px;\n    font-family: \"Inter\", sans-serif;\n    padding: 8px 15px;\n    margin: 00;\n    text-align: left;\n    background: #22242c00;\n}\n\n.mrkt_trde_tab b.text-green {\n    font-weight: 700;\n}\n\n.option_datatable_bl .classic_favorites_bl .order_trade_s .table-trade {\n    padding: 0px 0px;\n}\n\n.option_datatable_bl .order_trade_s .buy_sell_row {\n    padding: 10px 10px 0px;\n}\n\n.option_datatable_bl .order_trade_s .price_card_head {\n    padding: 0px 10px;\n}\n\n.option_datatable_bl .buy_sell_row_price .scroll_y {\n    padding: 0px 10px;\n    height: 218px;\n}\n\n.trade-wrapper .text-success {\n    color: #01BC8D !important;\n}\n\nbody.light_theme.mrkt_trde_tab {\n    background: #f5f5f5;\n}\n\n.buysellform .input-group {\n    padding: 3px 10px;\n    display: flex;\n    align-items: center;\n    background: #2B313C;\n    border: 1px solid #2d303a00;\n    border-radius: 6px;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\nbody.light_theme.buysellform .input-group {\n    background: rgb(245 245 245);\n    border: 1px solid rgb(234 239 244);\n}\n\n.trade-wrapper.spot .tab-content>.tab-pane {\n    height: 100% !important;\n}\n\n\n.buysellform .input-group .form-control {\n    background: transparent;\n    border: 0;\n    padding-left: 0;\n    font-weight: 500;\n    padding-right: 0;\n    border-radius: 0 !important;\n    font-size: 14px !important;\n    backdrop-filter: unset !important;\n    color: #ffffff !important;\n}\n\n.buysellform .input-group .form-control::placeholder {\n    color: #ffffff !important;\n    opacity: 1;\n}\n\nbody.light_theme .buysellform .input-group .form-control {\n    color: #070808 !important;\n}\n\nbody.light_theme .buysellform .input-group .form-control::placeholder {\n    color: #9e9e9e !important;\n}\n\n.trade_card .table> :not(caption)>*>* {\n    font-size: 11px;\n    background-color: transparent;\n    color: #F2F4F6;\n}\n\ntable.table tbody tr:last-child td .favouriteData p {\n    font-size: 14px;\n}\n\n.buysellform .input-group .input-group-text:not(.trade_amt_denom_addon),\n.buysellform .input-group .input-group-text:not(.trade_amt_denom_addon) * {\n    padding: 0;\n    margin: 0;\n    text-align: right !important;\n    display: block;\n}\n\n/* Amount BTC/USDT picker: exclude from rule above so flex + padding work; dropdown not clipped */\n.spot .trade_amount_field_wrap,\n.spot .trade_amount_field_limit.input-group,\n.buy_spot_form .trade_amount_field_limit.input-group,\n.sell_spot_form .trade_amount_field_limit.input-group {\n    overflow: visible;\n    position: relative;\n}\n\n.agcx-ft-amt-hint {\n    position: absolute;\n    left: 10px;\n    bottom: calc(100% - 8px);\n    z-index: 30;\n    max-width: calc(100% - 12px);\n    padding: 6px 8px;\n    border-radius: 4px;\n    background: #3d3d3d;\n    color: #fff;\n    font-size: 12px;\n    line-height: 16px;\n    white-space: nowrap;\n    pointer-events: none;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n\n.agcx-ft-amt-hint::after {\n    content: \"\";\n    position: absolute;\n    left: 18px;\n    bottom: -5px;\n    border-width: 5px 5px 0;\n    border-style: solid;\n    border-color: #3d3d3d transparent transparent;\n}\n\n.trade_amount_field_wrap .trade_amt_denom_addon {\n    text-align: left !important;\n}\n\n.trade_price_field.is-error,\n.input-group.trade_amount_field_limit.is-error {\n    border-color: #f6465d !important;\n}\n\n.trade_field_error {\n    margin: 6px 2px 0;\n    color: #f6465d;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n}\n\n/* Spot order form — Price field (value | quote | up/down stepper) */\n.trade_price_field_wrap label {\n    font-family: \"Inter\", sans-serif;\n}\n\n.trade_price_field {\n    display: flex;\n    align-items: stretch;\n    flex-wrap: nowrap;\n    width: 100%;\n    height: 40px;\n    padding: 1px 1px 1px 12px;\n    box-sizing: border-box;\n    background: #2b313d;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    font-family: \"Inter\", sans-serif;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\nbody.theme-light .trade_price_field {\n    background: #F6F6F7;\n}\n\nbody.theme-dark .trade_price_field {\n    background: #2b313d;\n}\n\n.trade_price_field:focus-within:not(.is-readonly),\n.buysellform .input-group:focus-within {\n    border-color: #d1aa67 !important;\n    box-shadow: 0 0 0 0px #d1aa67;\n}\n\n.trade_price_field.is-readonly {\n    opacity: 0.95;\n}\n\n.trade_price_input {\n    flex: 1 1 auto;\n    min-width: 0;\n    border: 0;\n    outline: none;\n    background: transparent;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    color: #ffffff;\n    padding: 0 8px 0 0;\n    line-height: 1.25;\n}\n\n.trade_price_input::placeholder {\n    color: #ffffff;\n    opacity: 1;\n}\n\nbody.light_theme .trade_price_input {\n    color: #070808\n}\n\nbody.light_theme .trade_price_input::placeholder {\n    color: #9e9e9e;\n}\n\n.trade_price_field.is-readonly .trade_price_input {\n    font-weight: 500;\n    color: #ffffff;\n    cursor: default;\n}\n\nbody.light_theme .trade_price_field.is-readonly .trade_price_input {\n    color: #C3C6C8;\n}\n\n.trade_card.trade_chart img.light_img {\n    filter: invert(1);\n}\n\nbody.light_theme .trade_card.trade_chart img.light_img {\n    filter: invert(0);\n}\n\n.trade_price_suffix {\n    display: inline-flex;\n    align-items: center;\n    padding: 0 0px 0 4px;\n    font-size: 13px;\n    font-weight: 500;\n    letter-spacing: 0px;\n    color: #b4b4b4;\n    text-transform: uppercase;\n    flex-shrink: 0;\n    font-family: \"Inter\", sans-serif;\n}\n\nbody.light_theme .trade_price_suffix {\n    color: #070808;\n}\n\n.trade_price_stepper {\n    display: flex;\n    flex-direction: column;\n    flex-shrink: 0;\n    width: 36px;\n    border-left: 1px solid #dfe0e230;\n    margin-left: 7px;\n}\n\nbody.light_theme .trade_price_stepper {\n    border-left: 1px solid #DFE0E2;\n}\n\n.bs_dropbox .trade_card.trade_chart.buysell_card .mb-3 {\n    margin-bottom: 0.7rem !important;\n    opacity: 1;\n}\n\n.limit_buy_extras.selllimitslidetab .trade_pct_track_line {\n    top: 23px;\n}\n\n.market_pct_slider_row.selllimitslidetab .trade_pct_track_line {\n    top: 23px;\n}\n\n.trade_price_step_btn {\n    flex: 1 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 18px;\n    border-bottom: 1px solid #dfe0e203 !important;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    cursor: pointer;\n    color: inherit;\n}\n\nbody.light_theme .trade_price_step_btn {\n    border-bottom: 1px solid #DFE0E2 !important;\n}\n\nbutton.trade_price_step_btn.lastbtnprice {\n    border-bottom: none !important;\n}\n\n.trade_price_step_btn:hover {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.trade_price_step_btn+.trade_price_step_btn {\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.trade_price_step_icon {\n    display: block;\n    width: 0;\n    height: 0;\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n}\n\n.trade_price_step_up {\n    border-bottom: 5px solid #9ca3af;\n}\n\n.trade_price_step_down {\n    border-top: 5px solid #9ca3af;\n}\n\n/* Buy tab — Limit order layout (mobile / light screenshot) */\n.spot_limit_tabs_row .spot_limit>button {\n    background: transparent;\n    border: none;\n    border-bottom: 2px solid transparent;\n    padding: 4px 2px 6px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #84888c;\n    font-family: \"Inter\", sans-serif;\n}\n\n.spot_limit_tabs_row .spot_limit>button.active {\n    color: #f2f4f6;\n}\n\n.buy_spot_form .trade_total_field_wrap .trade_total_field,\n.sell_spot_form .trade_total_field_wrap .trade_total_field {\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.buy_spot_form .trade_total_min_hint,\n.sell_spot_form .trade_total_min_hint {\n    margin-top: 6px;\n    font-size: 12px;\n    color: #9ca3af;\n    font-family: \"Inter\", sans-serif;\n}\n\n\n.trade_amount_field_wrap .trade_amount_field_limit .trade_amount_coin_badge small {\n    font-weight: 500;\n    color: #c5c5c5;\n}\n\nbody.light_theme .trade_amount_field_wrap .trade_amount_field_limit .trade_amount_coin_badge small {\n    color: #111827\n}\n\nhtml[data-theme=\"dark\"] .trade_amount_field_wrap .trade_amount_field_limit .trade_amount_coin_badge small {\n    color: #f2f4f6;\n}\n\n.limit_buy_extras {\n    margin-bottom: 8px;\n    margin-top: -7px;\n}\n\n.limit_buy_slider_row {\n    margin-top: 4px;\n}\n\n.limit_buy_avail .stop_plus {\n    display: none;\n}\n\n.limit_buy_avail .stop_avail_rgt {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n    flex: 1;\n    min-width: 0;\n}\n\n.limit_buy_avail .stop_avail_val {\n    display: inline-flex;\n    align-items: center;\n    line-height: 1.25;\n}\n\n.limit_buy_plus {\n    flex-shrink: 0;\n    font-weight: 700;\n    padding: 0;\n    background: none;\n    filter: invert(1);\n    align-self: center;\n    box-sizing: border-box;\n}\n\n.limit_buy_checks {\n    margin-bottom: 4px;\n}\n\n.stop_check span {\n    text-decoration: underline dashed;\n    text-underline-offset: 3px;\n}\n\n.trade_maker_taker_fees {\n    text-align: center;\n    font-size: 12px;\n    color: #6b7280;\n    margin: 10px 0 4px;\n    font-family: \"Inter\", sans-serif;\n}\n\nul.assets_panel_asset_rows span {\n    color: #fff !important;\n}\n\nbody.light_theme ul.assets_panel_asset_rows span {\n    color: #070808 !important;\n}\n\n.trade_maker_fees_split {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: left;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0px;\n    border-radius: 2px;\n    margin: 0px;\n    background: transparent !important;\n    line-height: 1;\n}\n\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li {\n    max-width: fit-content;\n}\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs {\n    justify-content: end;\n    gap: 16px;\n}\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li button {\n    opacity: 0.40;\n}\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li.activepop button {\n    opacity: 1 !important;\n}\n\n\n.buy_sell_row h6 {\n    font-size: 12px;\n}\n\n.buy_sell_row {\n    border-bottom: 1px solid #ffffff1a;\n    margin-bottom: 10px;\n    padding: 10px 10px;\n}\n\nbody.light_theme.buy_sell_row {\n    border-bottom: 1px solid #d2e4ff;\n}\n\n.actv_data p,\n.actv_data span {\n    font-size: 13px;\n}\n\n\n.trade-wrapper .row {\n    margin-left: -5px;\n    margin-right: -5px;\n}\n\n/* .trade-wrapper .row > * {\n        padding-left: 5px;\n        padding-right: 5px;\n    }\n   */\n.trade-wrapper .mb-1 {\n    margin-bottom: 5px !important;\n}\n\n.num-select {\n    padding: 0 16px 0 0 !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    width: auto !important;\n    min-width: 44px !important;\n    outline: 0 !important;\n    box-shadow: none !important;\n    text-align: left;\n    height: auto !important;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.2;\n    cursor: pointer;\n    color-scheme: dark;\n    color: #848e9c;\n}\n\n.num-select,\n.num-select:focus,\n.num-select:active {\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n.num-select option {\n    background-color: #181a20 !important;\n    color: #eaecef !important;\n    padding: 8px 12px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.num-select option[value=\"BUY\"] {\n    color: #0ecb81 !important;\n}\n\n.num-select option[value=\"SELL\"] {\n    color: #f6465d !important;\n}\n\n.num-select option:hover,\n.num-select option:focus,\n.num-select option:checked {\n    background-color: #2b313a !important;\n}\n\nbody.light_theme .num-select,\nhtml[data-theme='light'] .num-select {\n    color-scheme: light;\n    color: #1e2329 !important;\n}\n\nbody.light_theme .num-select option,\nhtml[data-theme='light'] .num-select option {\n    background-color: #ffffff !important;\n    color: #1e2329 !important;\n}\n\nbody.light_theme .num-select option[value=\"BUY\"],\nhtml[data-theme='light'] .num-select option[value=\"BUY\"] {\n    color: #0ecb81 !important;\n}\n\nbody.light_theme .num-select option[value=\"SELL\"],\nhtml[data-theme='light'] .num-select option[value=\"SELL\"] {\n    color: #f6465d !important;\n}\n\nbody.light_theme .num-select option:hover,\nbody.light_theme .num-select option:focus,\nbody.light_theme .num-select option:checked,\nhtml[data-theme='light'] .num-select option:hover,\nhtml[data-theme='light'] .num-select option:focus,\nhtml[data-theme='light'] .num-select option:checked {\n    background-color: #f5f5f5 !important;\n}\n\n.num-div {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-start;\n    background-color: transparent;\n    padding: 0;\n    border-radius: 4px;\n}\n\n.num-div .num-select {\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.num-div:after {\n    display: none;\n}\n\n.trade_favourites_lft.is-open .pair-color {\n    font-weight: 500;\n}\n\n.trade_summary_table_lft .num-div {\n    background-color: transparent;\n}\n\n.freerate {\n    background-color: #2B313C;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 10px 20px;\n    border-radius: 4px;\n    font-size: 12px;\n    margin: 20px 0px 10px;\n}\n\n.freerate span {\n    color: #949AA4;\n}\n\nbody.light_theme .num-div:after {\n    color: #333;\n}\n\nbody.light_theme .num-div {\n    background: transparent;\n    color: #333 !important;\n}\n\nbody.light_theme .num-div select {\n    color: #333 !important;\n}\n\n.actv_sorting strong {\n    font-weight: 600;\n}\n\n\n.price_item_value.active {\n    background: #2B313C;\n}\n\nbody.light_theme.price_item_value.active {\n    background: #0000000d;\n}\n\n.trade_favourites_lft .spot-list-search .ivu-input {\n    background: #565A62;\n    border: none;\n    border-radius: 8px;\n    padding: 3px 12px;\n}\n\n.trade_favourites_lft .spot-list-search i {\n    margin-right: 5px;\n    color: #a9a9a9;\n}\n\n.trade-wrapper table tr td {\n    font-size: 12px !important;\n    font-weight: 500 !important;\n    padding: 1px 10px !important;\n    font-family: \"Inter\", sans-serif;\n}\n\n.trade-wrapper table tr td small {\n    font-size: 12px;\n}\n\n.trade_favourites_lft .price_card_body {\n    padding: 0px;\n}\n\n.trade_card.p-3 {\n    padding: 11px !important;\n}\n\n.trade_favourites_lft .price_card .price_card_head {\n    padding: 0 10px;\n}\n\n.assets_right .assets_list {\n    margin: 10px 0px;\n    padding-bottom: 2px;\n}\n\n.trade-wrapper .assets_right table tr td {\n    padding: 5px 10px !important;\n}\n\n\n.assets_right .price_card_body.scroll_y {\n    padding-right: 0px;\n    padding-left: 0px;\n}\n\n/* trade new css */\n\n.mt_tr_pr {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.assets_right .assets_panel_asset_sym {\n    font-weight: 600;\n}\n\n/* Desktop Assets panel (lg+) — summary, pill actions, asset rows */\n.assets_right.assets_panel_desktop {\n    padding: 11px 0px 20px;\n    background: #181a20;\n    border-radius: 8px;\n}\n\n.assets_panel_inner {\n    display: flex;\n    flex-direction: column;\n}\n\n.assets_panel_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 14px;\n    border-bottom: 1px solid #d1d5db2e;\n    padding: 0px 16px 6px;\n}\n\nbody.light_theme .assets_panel_header {\n    border-bottom: 1px solid #EDEFF2;\n}\n\n.no-data-row img {\n    filter: invert(1);\n}\n\nbody.light_theme .no-data-row img {\n    filter: invert(0);\n}\n\nbody.light_theme .no-data-row svg {\n    filter: invert(0);\n}\n\n.assets_panel_title {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 500;\n    color: #f5f5f5;\n    font-family: \"Inter\", sans-serif;\n}\n\n.assets_panel_refresh {\n    border: none;\n    background: transparent;\n    color: #8e949e;\n    padding: 4px;\n    line-height: 1;\n    cursor: pointer;\n    border-radius: 4px;\n}\n\n.assets_panel_refresh:hover {\n    color: #eaecef;\n}\n\n.assets_balance_rows {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding: 0px 16px;\n}\n\n.assets_balance_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n}\n\n.assets_balance_label {\n    font-size: 11px;\n    color: #848e9c;\n    font-weight: 400;\n}\n\n.assets_balance_val {\n    font-size: 11px;\n    font-weight: 500;\n    color: #eaecef;\n    font-family: \"Inter\", sans-serif;\n}\n\n.assets_panel_actions {\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n    margin-bottom: 18px;\n    padding: 2px 16px;\n}\n\n.assets_panel_pill {\n    flex: 1 1;\n    text-align: center;\n    padding: 7px 8px;\n    border-radius: 999px;\n    background: #2b3138;\n    color: #f5f5f5 !important;\n    font-size: 13px;\n    font-weight: 500;\n    text-decoration: none !important;\n    font-family: \"Inter\", sans-serif;\n    transition: background 0.15s ease;\n}\n\n.assets_panel_list_card {\n    padding-top: 0px;\n    padding: 0px 16px;\n}\n\n\n.col-12.mmn_btm_minus_spc {\n    width: 37%;\n}\n\n.midgraph_col {\n    width: 63%;\n}\n\n.assets_panel_pill:hover {\n    background: #343b45;\n    color: #fff !important;\n}\n\n.assets_panel_list_card {\n    padding-top: 0px;\n}\n\n.assets_panel_list_head {\n    display: flex;\n    justify-content: space-between;\n    font-size: 11px;\n    color: #848e9c;\n    margin-bottom: 8px;\n    padding: 0 2px;\n    font-weight: 500;\n}\n\n.assets_panel_list_head span:last-child {\n    text-align: right;\n}\n\n.assets_panel_asset_rows {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    /* max-height: 240px; */\n    overflow-y: auto;\n}\n\n.assets_panel_asset_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.assets_panel_asset_row:last-child {\n    border-bottom: none;\n}\n\n.assets_panel_asset_left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n}\n\n.assets_panel_coin_icon {\n    border-radius: 50%;\n    object-fit: cover;\n    flex-shrink: 0;\n}\n\n.assets_panel_asset_meta {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.assets_panel_sym {\n    font-size: 13px;\n    font-weight: 700;\n    color: #eaecef;\n    font-family: \"Inter\", sans-serif;\n}\n\n.assets_panel_full {\n    font-size: 11px;\n    color: #848e9c;\n    font-weight: 500;\n}\n\n.assets_panel_bal {\n    font-size: 13px;\n    font-weight: 600;\n    color: #eaecef;\n    text-align: right;\n    font-family: \"Inter\", sans-serif;\n}\n\n.assets_panel_loading,\n.assets_panel_login_hint {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 28px 12px;\n    text-align: center;\n}\n\n.assets_panel_login_text {\n    font-size: 13px;\n    color: #848e9c;\n    margin: 0;\n}\n\n.assets_panel_empty {\n    padding: 16px 0;\n    text-align: center;\n    list-style: none;\n    border-bottom: none !important;\n}\n\n.mt_tr_pr .headline_bigName__dspVW i.faaa {\n    font-size: 20px;\n    opacity: 0.8;\n    font-weight: 300;\n    cursor: pointer;\n    margin-left: 6px;\n}\n\n.mt_tr_pr .headline_bigName__dspVW i.ri-menu-add-line:hover {\n    opacity: 1;\n}\n\n.spot-container {\n    max-width: 1520px;\n}\n\n.bs_dropbox .summay_dasboard_pop {\n    display: none !important;\n}\n\n.bs_dropbox .row .col-lg-6 {\n    width: 100% !important;\n    padding: 0px;\n}\n\n\n.bs_dropbox .trade_card.trade_chart.buysell_card {\n    width: 97.5%;\n    height: 660px;\n    position: relative;\n    left: 3px;\n    overflow: auto;\n}\n\n.treade_card_header {\n    border-bottom: 1px solid #47484a !important;\n    display: flex;\n    align-items: center;\n    padding-inline-start: 5px;\n    flex-shrink: 0;\n    width: 100%;\n    gap: 10px;\n    justify-content: space-between;\n}\n\nbody.light_theme .treade_card_header {\n    border-bottom: 1px solid #F2F3F4 !important;\n}\n\n.treade_card_header.buysell_heder {\n    border-bottom: none !important;\n}\n\n.menuitem {\n    display: flex;\n}\n\n.treade_card_header .toggle_dotted {\n    width: 10px;\n    cursor: pointer;\n    color: #8E949E;\n    width: 24px;\n}\n\nbody.light_theme .trade_favourites_lft .spotLists {\n    background: #fdfdfd;\n}\n\n.tch_main_tab {\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n}\n\n.tch_main_tab::-webkit-scrollbar {\n    display: none;\n}\n\nbody.light_theme .treade_card_header,\nbody.light_theme .price_card_head {\n    border-bottom: none;\n    opacity: 1;\n    padding-bottom: 0px !important;\n}\n\nbody.light_theme .card_header_title:before {\n    background-color: #d1aa67;\n}\n\nbody.light_theme .card_header_title.active {\n    color: #070808;\n}\n\n\nbody.light_theme .headline_left__lBBPY .headline_symbolName__KfmIZ {\n    color: #262626;\n}\n\nbody.light_theme ul.favorites_list_tabs li button.active {\n    color: #525252;\n    border-bottom: none;\n}\n\n.card_header_title {\n\n    padding: 10px 10px;\n    cursor: pointer;\n    position: relative;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13px;\n    font-weight: 500;\n    color: #84888C;\n}\n\n.trade_favourites_lft .spotLists {\n    display: block;\n    border-radius: 0px;\n    height: 99.6%;\n    padding-top: 12px;\n}\n\n.trade-wrapper .table-responsive {\n    min-height: 300px;\n    max-height: 700px;\n}\n\n.trade-wrapper div#tab_3.d-none.d-lg-block .table-responsive {\n    min-height: 570px;\n}\n\n.trade-wrapper div#tab_3.d-none.d-lg-block tr.no-data-row {\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    display: table-row !important;\n}\n\n.trade_card button.btn.btn-success {\n    color: #fff !important;\n    background-color: #5EBA89 !important;\n    border-radius: 50px;\n    font-size: 12px;\n    padding: 7px 16px;\n    border-color: #5EBA89;\n}\n\n.trade_card small {\n    font-size: 13px;\n    color: #afafaf;\n    padding-bottom: 10px;\n    margin-bottom: 0px !important;\n    display: block;\n}\n\nbody.light_theme .limit_buy_plus img {\n    filter: invert(1);\n}\n\nbody.light_theme .trade_card small {\n    color: #070808;\n}\n\nbutton.agce-margin-leverage-trigger-btn1 {\n    cursor: pointer !important;\n}\n\n.spot_limit .d-flex.justify-content-between {\n    width: 100%;\n}\n\n.spot_limit {\n    border-bottom: none;\n    position: relative;\n    gap: 15px !important;\n    width: 100%;\n}\n\n.spot_limit button {\n    background: transparent;\n    border: 0;\n    border-bottom: none;\n    position: relative;\n    padding: 4px 2px 6px;\n    font-size: 13px;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    color: #84888C;\n}\n\n.spot_limit button:before {\n    content: \"\";\n    content: \"\";\n    position: absolute;\n    content: \" \";\n    min-width: 30px;\n    /* max-width: 32px; */\n    height: 3px;\n    border-radius: 10px;\n    background-color: #d1aa67;\n    bottom: -1px;\n    left: 50%;\n    transform: translateX(-50%) scaleX(.5);\n    opacity: 0;\n    transition: all .16s ease-in;\n}\n\n.spot_limit button.active:before {\n    opacity: 1;\n}\n\nh3.headingspot {\n    font-size: 13px;\n    font-weight: 600;\n    font-family: \"Inter\", sans-serif;\n    color: #84888C;\n    margin: 0px;\n    padding: 14px 0px 14px 14px;\n}\n\n.spot_limit button.active {\n    color: #fff;\n}\n\n/* Spot tabs dropdown (Conditional) */\n.spot_limit_dropdown {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n}\n\n.spot_limit .spot_limit_dd_btn {\n    background: transparent;\n    border: 0;\n    position: relative;\n    padding: 4px 0 8px;\n    font-size: 13px;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    color: #84888C;\n    display: inline-flex;\n    align-items: center;\n    gap: 0px;\n}\n\n.info_icon {\n    color: #84888C;\n}\n\n/* Trade Info Tooltip */\n.trade-info-tooltip-wrapper {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.trade-info-tooltip-wrapper .trade-info-tooltip {\n    position: absolute;\n    top: calc(100% + 10px);\n    right: -10px;\n    width: 240px;\n    background-color: #1E2329;\n    color: #84888C;\n    padding: 12px;\n    border-radius: 6px;\n    font-size: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.2s ease-in-out;\n    z-index: 1000;\n    border: 1px solid #2B3139;\n    text-align: left;\n}\n\nbody.light_theme .trade-info-tooltip-wrapper .trade-info-tooltip {\n    background-color: #FFFFFF;\n    color: #474D57;\n    border: 1px solid #EAECEF;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.trade-info-tooltip-wrapper:hover .trade-info-tooltip {\n    opacity: 1;\n    visibility: visible;\n    top: calc(100% + 5px);\n}\n\n.trade-info-tooltip::after {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    right: 15px;\n    border-width: 6px;\n    border-style: solid;\n    border-color: transparent transparent #1E2329 transparent;\n}\n\nbody.light_theme .trade-info-tooltip::after {\n    border-color: transparent transparent #FFFFFF transparent;\n}\n\n.trade-info-tooltip .tooltip-item {\n    margin-bottom: 8px;\n    line-height: 1.4;\n}\n\n.trade-info-tooltip .tooltip-item:last-child {\n    margin-bottom: 0;\n}\n\n.trade-info-tooltip .tooltip-item strong {\n    color: #EAECEF;\n    font-weight: 500;\n}\n\nbody.light_theme .trade-info-tooltip .tooltip-item strong {\n    color: #1E2329;\n}\n\n.d-flex.spottabs_top {\n    border-bottom: 1px solid #47484a;\n}\n\nbody.light_theme .d-flex.spottabs_top {\n    border-bottom: 1px solid #EDEFF2;\n}\n\n.spot_limit .spot_limit_dd_btn i {\n    font-size: 18px;\n    line-height: 1;\n}\n\n.spot_limit .spot_limit_dd_btn.active {\n    color: #fff;\n}\n\n.assets_panel_balance_row {\n    font-size: 11px;\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.assets_panel_balances {\n    width: 100%;\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.spot_limit_dd_menu {\n    position: absolute;\n    top: calc(100% + 0px);\n    left: 0;\n    min-width: 140px;\n    background: #2a303a;\n    border: 1px solid rgba(15, 23, 43, 0.08);\n    border-radius: 10px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n    padding: 15px;\n    z-index: 9999;\n}\n\nbody.light_theme .spot_limit_dd_menu {\n    background: #ffffff;\n}\n\n.spot_limit_dd_item {\n    width: 100%;\n    border: 0;\n    background: transparent;\n    text-align: left;\n    padding: 12px 16px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #303236;\n    cursor: pointer;\n}\n\n.spot_limit.d-flex.align-items-center.flex-nowrap.margin_surface_tab_strip .spot_limit_dropdown {\n    display: none;\n}\n\n.limit_markettabs.margin-surface-tabs {\n    padding-bottom: 0px;\n}\n\n/* .spot_limit_dd_item:hover {\n    background: #f5f5f5;\n} */\n\n/* Order book aggregation (0.1 / 0.5 / 1 / 10 / 100) */\n.orderbook_agg_dd {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.orderbook_agg_dd_trigger {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 2px 4px 8px;\n    border: 0;\n    background: transparent;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    color: #fff;\n}\n\nbody.light_theme .orderbook_agg_dd_trigger {\n    color: #070808;\n}\n\n.orderbook_agg_dd_value {\n    color: #fff;\n    line-height: 1;\n}\n\nbody.light_theme .orderbook_agg_dd_value {\n    color: #070808;\n}\n\n.orderbook_agg_dd_caret {\n    width: 0;\n    height: 0;\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-top: 5px solid #fafafa;\n    transition: transform 0.15s ease;\n}\n\nbody.light_theme .orderbook_agg_dd_caret {\n    border-top: 5px solid #070808;\n}\n\n.orderbook_agg_dd_caret.is-open {\n    transform: rotate(180deg);\n}\n\n.orderbook_agg_dd_menu {\n    position: absolute;\n    right: 0;\n    top: calc(100% + 6px);\n    z-index: 10050;\n    min-width: 70px;\n    margin: 0;\n    padding: 0px 0;\n    list-style: none;\n    background: #2b313c;\n    border-radius: 8px;\n    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);\n}\n\nbody.light_theme .orderbook_agg_dd_menu {\n    background: #fff;\n}\n\n.orderbook_agg_dd_item {\n    display: block;\n    width: 100%;\n    padding: 7px 18px;\n    border: 0;\n    background: transparent;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 500;\n    color: #e3e3e3;\n    cursor: pointer;\n}\n\nbody.light_theme .orderbook_agg_dd_item {\n    color: #111827;\n}\n\n.orderbook_agg_dd_item:hover {\n    background: rgba(0, 0, 0, 0.04);\n}\n\n/* Order book view toggles (split / bids / asks) — buttons match former tab links */\n.buy_sell_cards ul.nav.custom-tabs.nav_order li button.orderbook-view-toggle {\n    display: block;\n    width: 100%;\n    text-align: center;\n    border-radius: 40px;\n    padding: 4px 0px;\n    color: #fff;\n    background-color: transparent;\n    font-size: 13px;\n    font-weight: 600;\n    margin: 0px;\n    border: 0;\n    cursor: pointer;\n    line-height: 1;\n}\n\n.buy_sell_cards ul.nav.custom-tabs.nav_order li button.orderbook-view-toggle img {\n    display: block;\n    margin: 0 auto;\n    vertical-align: middle;\n}\n\n/* Active toggle — mode-specific rings (Binance-style): split / bids / asks */\n.buy_sell_cards ul.nav.custom-tabs.nav_order li.fav-tab.activepop button.orderbook-view-toggle {\n    /* background: rgba(255, 255, 255, 0.14) !important; */\n    /* box-shadow: 0 0 0 1px rgba(148, 154, 164, 0.55), inset 0 0 0 1px rgba(255, 255, 255, 0.06); */\n    color: #e9e9e9 !important;\n}\n\n.buy_sell_cards ul.nav.custom-tabs.nav_order li.usdt-tab.activepop button.orderbook-view-toggle {\n    /* background: rgba(1, 188, 141, 0.14) !important;\n    box-shadow: 0 0 0 1.5px #01bc8d, 0 0 0 3px rgba(1, 188, 141, 0.22); */\n    color: #e9e9e9 !important;\n}\n\n.buy_sell_cards ul.nav.custom-tabs.nav_order li.btc-tab.activepop button.orderbook-view-toggle {\n    /* background: rgba(228, 85, 97, 0.14) !important; */\n    /* box-shadow: 0 0 0 1.5px #e45561, 0 0 0 3px rgba(228, 85, 97, 0.2); */\n    color: #e9e9e9 !important;\n}\n\nbody.light_theme .buy_sell_cards ul.nav.custom-tabs.nav_order li button.orderbook-view-toggle {\n    /* background-color: #f1f4f4; */\n    color: rgba(0, 0, 0, 0.75);\n}\n\nbody.light_theme .buy_sell_cards ul.nav.custom-tabs.nav_order li.fav-tab.activepop button.orderbook-view-toggle {\n    /* background: #f1f4f4 !important; */\n    /* box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14); */\n    color: #070808 !important;\n}\n\nbody.light_theme .buy_sell_cards ul.nav.custom-tabs.nav_order li.usdt-tab.activepop button.orderbook-view-toggle {\n    /* background: #ecf9f3 !important;\n    box-shadow: 0 0 0 1.5px #01bc8d, 0 0 0 3px rgba(1, 188, 141, 0.18); */\n    color: #070808 !important;\n}\n\nbody.light_theme .buy_sell_cards ul.nav.custom-tabs.nav_order li.btc-tab.activepop button.orderbook-view-toggle {\n    /* background: #ffedf0 !important; */\n    /* box-shadow: 0 0 0 1.5px #e45561, 0 0 0 3px rgba(228, 85, 97, 0.16); */\n    color: #070808 !important;\n}\n\n.buy_sell_cards ul.nav.custom-tabs.nav_order li.btc-tab button.orderbook-view-toggle,\n.buy_sell_cards ul.nav.custom-tabs.nav_order li button.orderbook-view-toggle--last {\n    margin-inline-end: 0;\n}\n\n.orderbook-single-side {\n    box-sizing: border-box;\n}\n\n/* —— Binance-style order book (screenshot match): grey headers, swap, neutral Amount/Total —— */\n.orderbook-table--ss .orderbook-thead {\n    display: table-header-group;\n}\n\n.orderbook-table--ss th.orderbook-th-sticky {\n    position: sticky;\n    top: 0;\n    z-index: 11;\n    background: var(--bs-body-bg, #181a20);\n    font-size: 12px;\n    font-weight: 500;\n    color: #848e9c !important;\n    border: 0;\n    padding: 6px 10px;\n    vertical-align: middle;\n    font-family: \"Inter\", sans-serif;\n}\n\nbody.light_theme .orderbook-table--ss th.orderbook-th-sticky {\n    background: #ffffff !important;\n    color: #848e9c !important;\n}\n\n.orderbook-th-total-inner {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n    width: 100%;\n    flex-wrap: nowrap;\n}\n\n.orderbook-col-swap-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px;\n    margin: 0;\n    border: 0;\n    background: transparent;\n    color: #848e9c;\n    cursor: pointer;\n    line-height: 1;\n    font-size: 14px;\n    flex-shrink: 0;\n}\n\n.orderbook-col-swap-btn:hover {\n    color: #01bc8d;\n}\n\n.orderbook-table--ss tbody td.orderbook-col-num {\n    color: #eaecef;\n    font-variant-numeric: tabular-nums;\n    font-weight: 500;\n}\n\nbody.light_theme .orderbook-table--ss tbody td.orderbook-col-num {\n    color: #1e2329 !important;\n}\n\n.orderbook-table--ss .orderbook-depth-text {\n    color: #eaecef !important;\n    font-variant-numeric: tabular-nums;\n    font-weight: 500;\n}\n\nbody.light_theme .orderbook-table--ss .orderbook-depth-text {\n    color: #1e2329 !important;\n}\n\n.orderbook-col-price--bid {\n    color: #01bc8d !important;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n}\n\n.orderbook-col-price--ask {\n    color: #e45561 !important;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n}\n\n.orderbook-mid-price--ss .orderbook-mid-main {\n    font-size: 1.25rem;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n}\n\n.orderbook-mid-price--ss .orderbook-mid-arrow {\n    font-size: 1.1rem;\n}\n\nbody.light_theme .orderbook-card--ss .price_card_body2,\nbody.light_theme .orderbook-card--ss {\n    background: #ffffff;\n}\n\n/* Order book depth (Total column) + bid/ask ratio */\n.orderbook-depth-cell {\n    position: relative;\n    overflow: hidden;\n    text-align: right !important;\n    vertical-align: middle;\n    padding-right: 10px !important;\n}\n\n.orderbook-depth-fill {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    height: 100%;\n    max-width: 100%;\n    pointer-events: none;\n    z-index: 0;\n    /* border-radius: 2px 0 0 2px; */\n}\n\n.orderbook-depth-fill--ask {\n    background: rgba(228, 85, 97, 0.16);\n}\n\n.orderbook-depth-fill--bid {\n    background: rgba(1, 188, 141, 0.16);\n}\n\nbody.light_theme .orderbook-depth-fill--ask {\n    background: rgba(228, 85, 97, 0.12);\n}\n\nbody.light_theme .orderbook-depth-fill--bid {\n    background: rgba(1, 188, 141, 0.12);\n}\n\n.orderbook-depth-text {\n    position: relative;\n    z-index: 1;\n}\n\n.orderbook_bid_ask_footer {\n    padding: 10px 12px 5px;\n    border-top: none;\n}\n\n\n\nbody.light_theme .orderbook_bid_ask_footer {\n    border-top-color: rgba(0, 0, 0, 0.06);\n}\n\n.orderbook_bid_ask_labels {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 11px;\n    font-weight: 700;\n    margin-bottom: 6px;\n}\n\n.orderbook_bid_ask_bar {\n    display: flex;\n    width: 100%;\n    height: 4px;\n    border-radius: 4px;\n    overflow: visible;\n    gap: 4px;\n    background: transparent;\n}\n\nbody.light_theme .orderbook_bid_ask_bar {\n    background: transparent;\n}\n\n.orderbook_bid_ask_seg {\n    min-width: 0;\n    height: 100%;\n    border-radius: 2px;\n}\n\n.orderbook_bid_ask_seg--bid {\n    background: #01bc8d;\n}\n\n.orderbook_bid_ask_seg--ask {\n    background: #e45561;\n}\n\n.orderbook-mid-price {\n    padding: 8px 12px;\n    /* border-top: 1px solid rgba(255, 255, 255, 0.06);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06); */\n}\n\nbody.light_theme .orderbook-mid-price {\n    border-top-color: rgba(0, 0, 0, 0.06);\n    border-bottom-color: rgba(0, 0, 0, 0.06);\n}\n\n.orderbook-mid-usd {\n    font-weight: 600;\n}\n\n/* Sell-only / buy-only: list first, dashed rule, then mid price (mobile app style) */\n.orderbook-section-dash {\n    margin: 0px;\n    height: 0;\n    border: 0;\n    border-top: none;\n}\n\nbody.light_theme .orderbook-section-dash {\n    border-top-color: rgba(0, 0, 0, 0.12);\n}\n\n.orderbook-mid-price--after-list {\n    border-top: none !important;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n/* Sell-only tab: brighter ask red, soft rose depth (screenshot match) */\n.orderbook-asks-only .orderbook-col-price--ask {\n    color: #f84960 !important;\n    font-weight: 700;\n}\n\n.orderbook-asks-only .orderbook-depth-fill--ask {\n    background: rgba(248, 73, 96, 0.14) !important;\n}\n\nbody.light_theme .orderbook-asks-only .orderbook-depth-fill--ask {\n    background: rgba(248, 73, 96, 0.1) !important;\n}\n\n.orderbook-asks-only .orderbook-mid-main.text-danger {\n    font-size: 1.35rem;\n}\n\n.orderbook-asks-scroll,\n.orderbook-bids-scroll {\n    flex: 1 1 auto;\n    min-height: 190px;\n}\n\n.orderbook-side-scroll {\n    min-height: 190px !important;\n}\n\n/* Order book: center loader / empty state in the scroll pane; data rows stay top-aligned when class is absent */\n.price_card_body.scroll_y.orderbook-side-scroll--placeholder,\n.orderbook-ob-table-wrap.orderbook-side-scroll--placeholder {\n    display: grid !important;\n    place-items: center;\n    align-content: center;\n    justify-items: center;\n    box-sizing: border-box;\n}\n\n.orderbook-side-scroll--placeholder>table.orderbook-table--ss,\n.orderbook-ob-table-wrap.orderbook-side-scroll--placeholder>table.orderbook-table--ss {\n    width: 100%;\n    max-width: 100%;\n    align-self: center;\n    justify-self: center;\n}\n\n.orderbook-empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    min-height: 0;\n    box-sizing: border-box;\n    padding: 12px;\n    text-align: center;\n}\n\n/* Theme-aware spinner — same colors as TV chart loader */\n.agce-theme-spinner {\n    width: 1.5rem;\n    height: 1.5rem;\n    border-color: rgba(255, 255, 255, 0.3) !important;\n    border-right-color: transparent !important;\n}\n\nbody.light_theme .agce-theme-spinner {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    border-right-color: transparent !important;\n}\n\n.spinner-border-sm.agce-theme-spinner {\n    width: 1rem;\n    height: 1rem;\n}\n\n/* Large layout bids-only: mid price row + table; center spinner in remaining area */\n.orderbook-single-side.orderbook-bids-scroll .orderbook-ob-table-wrap {\n    flex: 1 1 auto;\n    min-height: 0;\n}\n\n/* Stop order (Stop Limit / Stop Market) blocks */\n.stop_amt_suffix {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    min-width: 86px;\n}\n\n.stop_order_block {\n    margin-top: 6px;\n    margin-bottom: 12px;\n}\n\n.stop_slider_row {\n    margin: 6px 0 10px;\n}\n\n/* Percent slider — process bar (active/inactive track, thumb, dots, Inter labels) */\n.trade_pct_slider_row {\n    margin: 0px 0 5px;\n}\n\n.trade_pct_slider_shell {\n    --fill-pct: 25%;\n    position: relative;\n    width: 100%;\n    padding: 6px 0 4px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.trade_pct_track_line {\n    position: absolute;\n    left: 9px;\n    right: 7px;\n    top: 17px;\n    height: 1px;\n    border-radius: 2px;\n    background: linear-gradient(to right, #1e2329 0%, #1e2329 var(--fill-pct), #eaecef var(--fill-pct), #eaecef 100%);\n    pointer-events: none;\n    z-index: 0;\n}\n\n.trade_pct_slider_input {\n    position: relative;\n    z-index: 2;\n    display: block;\n    width: 100%;\n    height: 38px;\n    margin: 0;\n    padding: 0 8px;\n    box-sizing: border-box;\n    background: transparent;\n    -webkit-appearance: none;\n    appearance: none;\n    cursor: pointer;\n}\n\n.trade_pct_slider_input:focus {\n    outline: none;\n}\n\n.trade_pct_slider_input::-webkit-slider-runnable-track {\n    height: 3px;\n    background: transparent;\n    border: none;\n    border-radius: 2px;\n}\n\n.trade_pct_slider_input::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 12px;\n    height: 12px;\n    margin-top: -5px;\n    border-radius: 50%;\n    background: #1e2329;\n    border: 2px solid rgba(255, 255, 255, 0.35);\n    box-shadow: 0 0 0 4px rgba(30, 35, 41, 0.12), 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\n.trade_pct_slider_input::-moz-range-track {\n    height: 3px;\n    background: transparent;\n    border: none;\n    border-radius: 2px;\n}\n\n.trade_pct_slider_input::-moz-range-thumb {\n    width: 12px;\n    height: 12px;\n    border: 2px solid rgba(255, 255, 255, 0.35);\n    border-radius: 50%;\n    background: #1e2329;\n    box-shadow: 0 0 0 4px rgba(30, 35, 41, 0.12);\n}\n\n.trade_pct_marks {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 8px;\n    margin-top: -24px;\n    margin-bottom: 10px;\n    position: relative;\n    z-index: 1;\n    pointer-events: none;\n}\n\n.trade_pct_dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #eaecef;\n    flex-shrink: 0;\n}\n\n.trade_pct_dot--anchor,\n.trade_pct_dot--fill {\n    background: #1e2329;\n}\n\n.trade_pct_labels {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 0 4px;\n    font-size: 12px;\n    font-weight: 500;\n    color: #6b7280;\n    font-family: \"Inter\", sans-serif;\n}\n\n.trade_pct_labels span {\n    text-align: center;\n    min-width: 0;\n}\n\nhtml[data-theme=\"dark\"] .trade_pct_track_line {\n    background: linear-gradient(to right,\n            #f2f4f6 0%,\n            #f2f4f6 var(--fill-pct),\n            #374151 var(--fill-pct),\n            #374151 100%);\n}\n\nhtml[data-theme=\"dark\"] .trade_pct_dot {\n    background: #4b5563;\n}\n\nhtml[data-theme=\"dark\"] .trade_pct_dot--anchor,\nhtml[data-theme=\"dark\"] .trade_pct_dot--fill {\n    background: #f2f4f6;\n}\n\nhtml[data-theme=\"dark\"] .trade_pct_labels {\n    color: #9ca3af;\n}\n\nhtml[data-theme=\"dark\"] .trade_pct_slider_input::-webkit-slider-thumb {\n    background: #f2f4f6;\n    border-color: rgba(0, 0, 0, 0.15);\n    box-shadow: 0 0 0 4px rgba(242, 244, 246, 0.12);\n}\n\nhtml[data-theme=\"dark\"] .trade_pct_slider_input::-moz-range-thumb {\n    background: #f2f4f6;\n    border-color: rgba(0, 0, 0, 0.15);\n    box-shadow: 0 0 0 4px rgba(242, 244, 246, 0.12);\n}\n\n.stop_avail_block {\n    margin-top: 14px;\n    margin-bottom: 8px;\n}\n\n.stop_avail_row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 6px 0;\n}\n\n.stop_avail_label {\n    color: #9aa1af;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.stop_avail_val {\n    color: #fff;\n    font-size: 13px;\n    font-weight: 600;\n}\n\nbody.light_theme .stop_avail_val {\n    color: #111827;\n}\n\nhtml[data-theme='dark'] .stop_avail_val {\n    color: #f9fafb;\n}\n\n.stop_plus {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #0f172b;\n    color: #fff;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    line-height: 1;\n}\n\n.stop_checks {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 12px;\n}\n\n.stop_check {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 14px;\n    color: #111827;\n    font-weight: 600;\n}\n\nhtml[data-theme='dark'] .stop_check {\n    color: #f9fafb;\n}\n\n.stop_check input[type=\\\"checkbox\\\"] {\n    width: 18px;\n    height: 18px;\n    border-radius: 4px;\n}\n\n.stop_apr_card {\n    margin-top: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 14px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    background: rgb(255 255 255 / 20%);\n    cursor: pointer;\n}\n\nhtml[data-theme='dark'] .stop_apr_card {\n    border-color: rgba(255, 255, 255, 0.08);\n    background: rgba(43, 49, 60, 0.55);\n}\n\n.stop_apr_text {\n    color: #f59e0b;\n    font-weight: 700;\n}\n\n.stop_apr_card i {\n    color: #9aa1af;\n    font-size: 20px;\n}\n\n.mrkt_trde_tab span {\n    font-size: 11px;\n    color: #919499;\n}\n\n.d-flex.fullwidth_align {\n    width: 100%;\n    color: #84888C;\n    gap: 12px;\n}\n\n.trade-wrapper .assets_list .top_heading {\n    justify-content: space-between;\n    align-items: center;\n}\n\n.assets_list .more_btn {\n    font-size: 12px;\n    color: #d3d3d3;\n}\n\n.trade-wrapper .assets_list h4 {\n    font-size: 13px;\n    font-weight: 500;\n    color: #dbdbdb;\n    margin: 0px;\n}\n\n.assets_btn button a {\n    color: #F2F4F6;\n    font-weight: 500;\n}\n\n.card_header_title:before {\n    position: absolute;\n    content: \" \";\n    width: 16px;\n    height: 3px;\n    border-radius: 10px;\n    background-color: #F2F4F6;\n    bottom: -1px;\n    left: 50%;\n    transform: translateX(-50%) scaleX(.5);\n    opacity: 0;\n    transition: all .16s ease-in;\n}\n\n.card_header_title.active {\n    color: #F2F4F6;\n}\n\nbody.light_theme.card_header_title.active {\n    color: #000000;\n}\n\n.card_header_title.active:before {\n    opacity: 1;\n    transform: translateX(-50%) scaleX(1);\n}\n\n.nav.custom-tabs.nav_order {\n    width: auto !important;\n}\n\n.trade_tabs.buy_sell_cards.buy_sell_row.d-flex-between {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /* height: 26px; */\n    padding: 15px 15px 5px;\n    border: 0;\n    margin: 0;\n}\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {\n    background: transparent !important;\n}\n\nbody.light_theme.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {\n    background: #e9e9e9 !important;\n}\n\nbody.light_theme.price_card_head {\n    border-color: #00000012;\n}\n\n.scroll_y_hidden {\n    overflow: hidden;\n}\n\n\n\n.headline_left__lBBPY {\n    display: flex;\n    align-items: center;\n}\n\n.headline_left__lBBPY .headline_symbolName__KfmIZ {\n    white-space: nowrap;\n    margin-right: 0;\n    cursor: pointer;\n}\n\n.headline_bigName__dspVW {\n    display: flex;\n    align-items: center;\n    -webkit-margin-end: 7px;\n    margin-inline-end: 7px;\n}\n\n.headline_bigName__dspVW,\n.headline_bigName__dspVW h1 {\n    line-height: 20px;\n    font-size: 14px !important;\n    font-weight: 700;\n}\n\n.headline_bigName__dspVW h1 {\n    margin: 0;\n}\n\n.headline_etfDisplay__P4Hdv {\n    font-size: 10px;\n    line-height: 14px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    -webkit-margin-end: 10px;\n    margin-inline-end: 10px;\n    opacity: 0.7;\n}\n\n.headline_leftItem__7BFYq {\n    margin-inline-start: 15px;\n    font-size: 12px;\n    color: #4d4d4d;\n    line-height: 20px;\n    white-space: nowrap;\n    font-weight: 500;\n    font-weight: 400;\n}\n\n\n\n/* token info */\n\n.inf_row {\n    padding: 1.5rem;\n}\n\n.inf_row .mt_tr_pr {\n    margin-bottom: 16px;\n}\n\n.inf_row .headline_bigName__dspVW,\n.headline_bigName__dspVW h1 {\n    font-size: 14px !important;\n}\n\n\n.infor_row li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.infor_row li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 22px;\n    padding: 8px 0;\n}\n\n.infor_row li span {\n    font-weight: 600;\n    color: #fff;\n}\n\nbody.light_theme.infor_row li span {\n    color: #000;\n}\n\n\n.orderbook_two .buy_sell_row_price .scroll_y {\n    height: 197px;\n}\n\n/* Single-side mode: taller pane so full depth list scrolls (overrides 257px above) */\n.orderbook_two .buy_sell_row_price .scroll_y.orderbook-single-side {\n    height: 430px;\n    max-height: 430px;\n    min-height: 430px;\n    overflow: scroll;\n}\n\n.orderbook_two .buy_sell_row_price .scroll_y.orderbook-single-side.orderbook-asks-scroll.orderbook-asks-sell-list {\n    height: 380px;\n    max-height: 380px;\n    min-height: 380px;\n}\n\n.t_info h5 {\n    font-size: 15px;\n    font-weight: 700;\n}\n\n.t_info p {\n    font-weight: 400;\n    font-size: 13px;\n}\n\n.inf_row {\n    padding: 1.5rem;\n    height: 429px;\n    overflow-y: auto;\n}\n\n@media (min-width:1601px) {\n    .headline_leftItem__7BFYq {\n        margin-inline-start: 30px;\n    }\n\n}\n\n.headline_latestPrice__AYXu0 .headline_title__x1csO {\n    font-size: 14px;\n}\n\n.scroll-subtabs_scrollSubInfo__T5nZF {\n    flex: 1 1;\n    width: 0;\n    margin-inline-start: 0;\n    position: relative;\n}\n\n.scroll-subtabs_tabs__Prom8 {\n    flex-flow: row nowrap;\n    display: flex;\n    /* overflow: hidden; */\n    position: relative;\n    align-items: center;\n    justify-content: space-between;\n    gap: 15px;\n    padding-right: 10px;\n}\n\n.scroll-subtabs_subMarketWrap__XVmHp {\n    overflow: auto hidden;\n    white-space: nowrap;\n    scroll-behavior: smooth;\n    scrollbar-width: none;\n}\n\n.headline_extendInfoWrapper__dooIS,\n.headline_left__lBBPY,\n.headline_wrapper__BKn9L {\n    display: flex;\n    align-items: center;\n}\n\n.headline_leftItem__7BFYq {\n    /* margin-inline-end: 60px; */\n    font-size: 11px;\n    line-height: 20px;\n    white-space: nowrap;\n}\n\n.headline_withBorder__a6ZD2 {\n    border-bottom: 1px dashed transparent;\n    color: #fff;\n    font-weight: 600;\n}\n\nbody.light_theme .headline_withBorder__a6ZD2 {\n    color: #000;\n}\n\n/* 24h Volume: slightly higher contrast (labels use opacity 0.7 by default) */\n.headline_volumeStat__label {\n    opacity: 0.88 !important;\n}\n\n.headline_volumeStat__value {\n    color: #c8ccd4;\n}\n\nbody.light_theme .headline_volumeStat__value {\n    color: #4a4e55;\n}\n\nbody.light_theme .headline_volumeStat__label {\n    color: black;\n}\n\n.trade-wrapper.spot .container-fluid {\n    padding: 0px 5px;\n}\n\n.limit_markettabs {\n    padding: 10px 12px 10px 15px;\n}\n\n\n.buysell_heder {\n    padding: 0px 10px 14px 14px !important\n}\n\n.buysell_heder .custom-tabs {\n    padding: 0px 5px;\n    width: 100%;\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    border-radius: 0px;\n    gap: 10px;\n    background-color: transparent;\n    flex-wrap: nowrap;\n}\n\n\nbody.light_theme .buysell_heder .custom-tabs {\n    background: #F6F6F7;\n}\n\nbody.light_theme .spot_limit button.active {\n    border-bottom: none;\n    color: #070808;\n}\n\nbody.light_theme .actions_balance__kTHO0 {\n    color: #000;\n}\n\nbody.light_theme .buysellform .input-group {\n    background: #F6F6F7;\n}\n\nbody.light_theme .assets_list ul li {\n    color: #000;\n}\n\nbody.light_theme .assets_list ul li span {\n    color: #3a3a3a;\n}\n\nbody.light_theme .spotLists {\n    background: #ffffff50;\n}\n\n\nbody.light_theme .trade_favourites_lft .spot-list-search .ivu-input {\n    background: #f9f9f9;\n}\n\nbody.light_theme .trade_card {\n    background: #ffffffd1;\n}\n\n.buysell_heder .custom-tabs li {\n    width: 50%;\n    position: relative;\n}\n\n.status_info {\n    display: flex;\n    gap: 5px;\n}\n\n.status_info input {\n    background-color: #999;\n    border: 1px solid #666;\n    border-radius: 50px;\n}\n\n.status_info input {\n    background-color: #22242c;\n    border: 1px solid #353535;\n    border-radius: 50px;\n    color: #fff;\n    padding: 2px 12px;\n    width: 130px;\n}\n\n.status_info button {\n    border-radius: 50px !important;\n}\n\n.buysell_heder .custom-tabs li a {\n    width: 100%;\n    display: block;\n    /* transform: skewX(-20deg); */\n    text-align: center;\n    padding: 6px 0;\n    /* background-color: #ffffff0f; */\n    border-radius: 4px;\n    font-size: 12px;\n    color: currentColor !important;\n    transition: unset !important;\n}\n\n/* .buysell_heder .custom-tabs li a::before{     width: 16px;\n    transform: rotate(-19deg);\n    position: absolute;\n    left: -6px;\n    background-color: #1f1f22;\n    height: 110%;\n    content: \"\";\n    top: -3px; } */\n\n.buysell_heder .custom-tabs li a.active button {\n    background: #2BC287 !important;\n    color: #fff;\n}\n\n.buysell_heder .custom-tabs li a.active button span {\n    color: #fff !important;\n}\n\n/* .buysell_heder .custom-tabs li.sell-tab button::before {\n    left: inherit;\n    background-color: #1f1f22;\n    right: -6px;\n    top: 0px;\n} */\n\n/* .buysell_heder .custom-tabs li.sell-tab a.active::before{ background-color: #ed5765 !important; } */\n\n/* .buysell_heder .custom-tabs li.buysell-tab.buy-tab button {\n    border-radius: 4px;\n    -ms-transform: skewX(-20deg);\n    -webkit-transform: skewX(-20deg);\n    transform: skewX(-20deg);\n} */\n\n.buysell_heder .custom-tabs.padding-0 li a {\n    padding: 0px !important;\n}\n\n/* .buysell_heder .custom-tabs li button span {\n    -ms-transform: skewX(20deg);\n    -webkit-transform: skewX(20deg);\n    transform: skewX(20deg);\n    display: block;\n} */\n\n/* .buysell_two .buysell_heder .custom-tabs li button span {\n    -ms-transform: skewX(35deg);\n    -webkit-transform: skewX(35deg);\n    transform: skewX(35deg);\n    display: block;\n} */\n\n.actions_balance__kTHO0 {\n    margin-bottom: 12px;\n    min-height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.midgraph_col {\n    position: relative;\n    padding-right: 3px;\n}\n\n/* .col-12.col-lg-12.col-xl-5.col-xxl-5.mmn_btm_minus_spc .col-lg-6 {\n    padding: 2px;\n} */\n\nul.favorites_list_tabs {\n    display: flex;\n    gap: 12px;\n    overflow: auto;\n    align-items: center;\n    border-bottom: none;\n    margin: 12px 12px;\n}\n\nul.favorites_list_tabs li button {\n    font-size: 13px;\n    font-weight: 600;\n    color: #949AA4;\n    position: relative;\n    background-color: transparent;\n    border-bottom: none;\n    border: none;\n    padding: 0px 0px 8px;\n}\n\nul.favorites_list_tabs li button:before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    display: none;\n    right: 0;\n    margin: 0 auto;\n    width: 35%;\n    height: 2px;\n    background-color: #d1aa67;\n}\n\nul.favorites_list_tabs li button.active:before {\n    display: block;\n}\n\nul.favorites_list_tabs li button.active {\n    color: #fff;\n    border-bottom: none;\n}\n\n.midgraph_col .trade_card.trade_chart {\n    height: 594px;\n}\n\n.actions_primaryText__ufKT0 {\n    opacity: 0.7;\n    margin-right: 10px;\n}\n\nbody.light_theme.actions_primaryText__ufKT0 {\n    opacity: 1;\n}\n\nbody.light_theme.actions_balance__kTHO0 .text-muted {\n    color: #3b3d3e !important;\n}\n\na.actions_deposit__Ydutk {\n    color: #01BC8D;\n    font-size: 125%;\n    margin-left: 10px;\n    line-height: 1;\n}\n\n.buysellform .form-group label {\n    display: block;\n    margin-bottom: 4px;\n    font-weight: 400;\n    font-size: 11px;\n    /* opacity: 0.7; */\n    font-family: \"Inter\", sans-serif;\n    color: #F2F4F6;\n}\n\n.assets_list ul li span {\n    color: #c0c0c0;\n}\n\n.process_step {\n    position: relative;\n}\n\n.process_step:before {\n    width: 100%;\n    background-color: #DEDFE1;\n    height: 1px;\n    position: absolute;\n    content: \"\";\n    left: 0px;\n    top: 4px;\n}\n\n.process_step label.btn {\n    position: relative;\n}\n\n.process_step label.btn:before {\n    width: 7px;\n    background-color: #393F4F40;\n    height: 7px;\n    position: absolute;\n    content: \"\";\n    border-radius: 50px;\n    border: 1px solid #393F4F;\n    left: 0px;\n    top: 1px;\n}\n\n\n.process_step label.btn.checked:before {\n    width: 14px;\n    background-color: #181a20;\n    height: 14px;\n    border: 2px solid #F2F4F6;\n    top: -3px;\n}\n\n.pair-color {\n    color: #fff;\n    font-weight: 600;\n}\n\n.no-orderbook {\n    font-weight: 500;\n}\n\n.buysell_heder .custom-tabs {\n    padding: 1px;\n    width: 100%;\n    display: flex;\n    position: relative;\n    overflow: inherit;\n    border: none;\n    border-radius: 4px;\n    gap: 10px;\n    background-color: #2B313C;\n    flex-wrap: nowrap;\n    margin-top: 10px;\n}\n\n.buysell_heder .custom-tabs li button {\n    width: 100%;\n    display: block;\n    /* transform: skewX(-20deg); */\n    text-align: center;\n    border: none;\n    font-weight: 400;\n    padding: 4px 10px;\n    background-color: #2B313C;\n    border-radius: 4px;\n    font-size: 13px;\n    color: #87909F;\n    transition: unset !important;\n}\n\n.relative_select_right .buysell_heder .custom-tabs li.active button {\n    background-color: #5EBA89 !important;\n    border-bottom: none !important;\n}\n\n.relative_select_right .buysell_heder .custom-tabs li.selltab.active button {\n    background-color: #ed5765 !important;\n}\n\n.selltab\n/* .buysell_heder .custom-tabs li button::before {\n    width: 16px;\n    transform: rotate(0deg);\n    position: absolute;\n    transform: skewX(20deg);\n    left: -6px;\n    background-color: #1f1f22;\n    height: 100%;\n    content: \"\";\n    border-radius: 3px;\n    top: 0px;\n} */\n\n\n/* .buysell_heder .custom-tabs li.active button::before {\n    background: #01BC8D !important;\n}\n\n.buysell_heder .custom-tabs li a.active button::before {\n    background: #01BC8D !important;\n}\n\n.buysell_heder .custom-tabs li button.active::before {\n    background: #01BC8D !important;\n}\n\n.buysell_heder .custom-tabs li button.selltab::before {\n    left: inherit;\n    background-color: #1f1f22;\n    right: -5px;\n    top: 0px;\n    border-radius: 3px;\n} */\n\n.buysell_heder.padding_space_l {\n    padding: 0px !important;\n}\n\n.relative_select_right .cnt_table_two {\n    display: none;\n}\n\n.relative_select_right .cnt_table_two.active {\n    display: block;\n}\n\n/* .buysell_two .buysell_heder .custom-tabs li button::before {\n    width: 28px;\n    transform: skewX(35deg);\n    left: -11px;\n}\n\n.buysell_two .buysell_heder .custom-tabs li.sell-tab button::before {\n    left: inherit;\n    background-color: #1f1f22;\n    right: -10px;\n    top: 0px;\n} */\n\n.buysell_two .buysell_heder .custom-tabs li.sell-tab a.active button {\n    background-color: #F74B60 !important;\n}\n\n/* .buysell_heder .custom-tabs li.sell-tab a.active button:before {\n    background-color: #ed5765 !important;\n}\n\n.buysell_heder .custom-tabs li.selltab button.active::before {\n    background-color: #ed5765 !important;\n} */\n\n\nbody.light_theme.buysellform .form-group label {\n    opacity: 1;\n}\n\n.order-btns .btn-mini {\n    margin: 5px 0;\n    line-height: 1;\n    min-height: 36px;\n}\n\n\n.bs_box_header {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 13px;\n}\n\n.bs_box_header h6 {\n    font-size: 14px;\n    font-weight: 700;\n    margin: 0;\n}\n\n.bs_box_header i {\n    font-size: 22px;\n}\n\n\n\n.bs_tab_row {\n    position: fixed;\n    bottom: 0;\n    z-index: 9999;\n    width: 100%;\n    left: 0;\n    padding: 13px;\n    border-radius: 0;\n    border: 0;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    background: #1e1d3054;\n    border-top: 1px solid #2c2c3d8a;\n}\n\nbody.light_theme.bs_tab_row {\n    background: #ffffffc9;\n    border-color: #F5F5F5;\n}\n\n.bs_tab_row .btn {\n    font-weight: 600;\n}\n\n\n.bs_dropbox.spotLists_bs_dropbox {\n    display: none;\n}\n\n.bs_dropbox.spotLists_bs_dropbox.active {\n    display: flex;\n}\n\n\n\n.spotLists_bs_dropbox {\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background: #00000075;\n    top: 0;\n    bottom: 0;\n    z-index: 99;\n    left: 0;\n    align-items: center;\n    justify-content: center;\n\n}\n\n\nbody.light_theme .bs_tab_row {\n    background: #ffffff54;\n}\n\n@media screen and (max-width: 1100px) and (min-width: 768px) {\n\n    .mmn_btm_minus_spc .col-lg-6 {\n        margin: -1px;\n    }\n\n    div#tab_3 {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    div#tab_4 {\n        margin-top: -17px !important;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n\n\n}\n\n\n@media screen and (max-width: 991px) {\n\n    .mmn_btm_minus_spc {\n        display: block;\n    }\n\n    .mmn_btm_minus_spc .col-lg-6.ordermarketcntr {\n        display: none;\n    }\n\n    .price_card_body.scroll_y.orderbook-side-scroll.orderbook-asks-sell-list {\n        min-height: 210px !important;\n        height: 210px;\n    }\n\n    .price_card_body.scroll_y.orderbook-side-scroll.ordertwo {\n        height: 390px;\n    }\n\n    .price_card_body.scroll_y.orderbook-side-scroll.orderbook-asks-sell-list.orderthree {\n        height: 390px;\n    }\n\n    .price_card_body.scroll_y.orderbook-side-scroll {\n        min-height: 100% !important;\n        height: 180px;\n    }\n\n}\n\n/* Market Trades (below lg): empty = header row + flex region that fills viewport and centers art; with data = normal table */\n@media screen and (max-width: 991.98px) {\n    div#tab_4_mobile_trade {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    div#tab_4_mobile_trade>.trade_card.orderbook_two {\n        display: flex;\n        flex-direction: column;\n        flex: 1 1 auto;\n        min-height: 0;\n    }\n\n    div#tab_4_mobile_trade .trade_history_tab {\n        padding: 0;\n        display: flex;\n        flex-direction: column;\n        flex: 1 1 auto;\n        min-height: 0;\n    }\n\n    div#tab_4_mobile_trade .table-responsive {\n        max-height: calc(100vh - 400px);\n        overflow-y: auto;\n    }\n\n    div#tab_4_mobile_trade .price_card_body {\n        padding: 0;\n    }\n\n    /* Override global .trade-wrapper .table-responsive min-height for empty state */\n    .trade-wrapper div#tab_4_mobile_trade .table-responsive.market-trades-mobile--empty {\n        display: flex;\n        flex-direction: column;\n        flex: 1 1 auto;\n        min-height: calc(100vh - 200px) !important;\n        max-height: none;\n        overflow: hidden;\n    }\n\n    div#tab_4_mobile_trade .market-trades-mobile-empty-wrap {\n        display: flex;\n        flex-direction: column;\n        flex: 1 1 auto;\n        min-height: calc(100vh - 200px);\n        width: 100%;\n    }\n\n    div#tab_4_mobile_trade .market-trades-mobile-header-table {\n        flex: 0 0 auto;\n    }\n\n    div#tab_4_mobile_trade .market-trades-mobile-empty-body {\n        flex: 1 1 auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        min-height: min(62vh, 560px);\n        padding: 16px;\n        box-sizing: border-box;\n    }\n\n    div#tab_4_mobile_trade .market-trades-mobile-empty-body .no-data-wrapper {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        max-width: 100%;\n    }\n\n    div#tab_4_mobile_trade .market-trades-mobile-empty-body .no_data_s {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n@media screen and (max-width: 767px) and (min-width: 320px) {\n\n    .treade_card_header.tch_main_tab {\n        display: flex;\n    }\n\n    .limit_markettabs.margin-surface-tabs .d-lg-none.mt-1 {\n        margin: 0px !important;\n    }\n\n    .stop_avail_val {\n        font-size: 12px;\n    }\n\n    .stop_avail_label {\n        font-size: 12px;\n    }\n\n    .price_card_body.scroll_y.orderbook-side-scroll.orderbook-asks-sell-list {\n        min-height: 210px !important;\n        height: 210px;\n    }\n\n    .price_card_body.scroll_y.orderbook-side-scroll.ordertwo {\n        height: 410px;\n    }\n\n    .price_card_body.scroll_y.orderbook-side-scroll.orderbook-asks-sell-list.orderthree {\n        height: 410px;\n    }\n\n    .price_card_body.scroll_y.orderbook-side-scroll {\n        min-height: 100% !important;\n        height: 205px;\n    }\n\n    .orderbook-side-scroll {\n        min-height: 210px !important;\n    }\n\n    .trade_price_input {\n        font-size: 12px;\n    }\n\n    .trade_price_suffix {\n        font-size: 11px;\n    }\n\n    .headline_bigName__dspVW h1 i {\n        display: flex;\n    }\n\n\n    div#tab_3 {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    /* Hide tab_3 on mobile when Chart tab is active */\n    div#tab_3.d-none {\n        display: none !important;\n    }\n\n    div#tab_mobile_trade_history {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    /* Hide mobile Market Trades when Chart tab is active */\n    div#tab_mobile_trade_history.d-none {\n        display: none !important;\n    }\n\n    /* Mobile Market Trades styling */\n    div#tab_mobile_trade_history .trade_history_tab {\n        padding: 0;\n    }\n\n    div#tab_mobile_trade_history .table-responsive {\n        max-height: calc(100vh - 400px);\n        overflow-y: auto;\n    }\n\n    div#tab_mobile_trade_history .price_card_body {\n        padding: 0;\n    }\n\n    div#tab_4 {\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    /* Hide mobile Wallets when Chart tab is active */\n    div#tab_4_mobile.d-none {\n        display: none !important;\n    }\n\n    div#tab_4_mobile {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    /* Mobile Wallets styling */\n    div#tab_4_mobile .assets_list {\n        padding: 0px;\n    }\n\n    .assets_btn {\n        gap: 10px;\n    }\n\n    div#tab_4_mobile .table-responsive {\n        max-height: calc(100vh - 400px);\n        overflow-y: auto;\n    }\n\n    div#tab_4_mobile .price_card_body {\n        padding: 0;\n    }\n\n    .trade-wrapper.spot.pb-3 .col-12.col-lg-6.col-xl-3.col-xxl-3 {\n        margin-top: 7px;\n    }\n\n\n    .mmn_btm_minus_spc .col-lg-6 {\n        margin-top: -2px;\n    }\n\n    .trade-wrapper {\n        padding-top: 5px !important;\n        overflow-x: hidden;\n    }\n\n    .select_mini {\n        font-size: 14px;\n        min-width: initial !important;\n        height: unset !important;\n        padding: 5px 11px !important;\n    }\n\n\n    .container-chart-briefing .spotList {\n        background: #22242c;\n        left: 0;\n        top: 62px;\n    }\n\n\n    .container-chart-briefing {\n        height: auto;\n        padding: 15px 15px 0;\n    }\n\n    .spot-container-main .top {\n        flex-direction: column;\n    }\n\n    .spot-container {\n        flex-direction: column;\n    }\n\n    .buysellform .form-group label {\n        font-size: 12px;\n    }\n\n    .wm-50 {\n        flex: 0 0 auto;\n        margin-bottom: 17px;\n        width: 50%;\n    }\n\n    .container-chart-briefing-info {\n        width: 100%;\n        justify-content: unset;\n        flex-wrap: wrap;\n    }\n\n    .container-chart-briefing h2 {\n        justify-content: flex-start;\n    }\n\n    .spot-container-main .bottom {\n        min-height: unset;\n        flex-direction: column;\n    }\n\n    .bottom-left {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .bottom-right {\n        width: 100%;\n    }\n\n    .spot-container-right-right {\n        flex: auto;\n        max-width: 100%;\n    }\n\n    .trade_card {\n        padding: 11px 11px;\n        padding: 0;\n    }\n\n    ul.nav.custom-tabs.order_his_tabs li a {\n        padding: 8px 13px;\n        font-size: 13px;\n        line-height: 1;\n    }\n\n    .buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {\n        padding: 3px;\n        margin: 0 3px 0 0;\n    }\n\n    .buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {\n        background: transparent !important;\n    }\n\n}\n\n\n@media screen and (max-width: 991px) and (min-width: 768px) {\n\n\n    .spot-container-main .top {\n        flex-direction: column;\n    }\n\n    .spot-container {\n        flex-direction: column;\n    }\n\n    .wm-50 {\n        flex: 0 0 auto;\n        margin-bottom: 17px;\n        width: 33.3333333%;\n    }\n\n    .container-chart-briefing-info {\n        width: 100%;\n        justify-content: unset;\n        flex-wrap: wrap;\n    }\n\n    .container-chart-briefing h2 {\n        justify-content: flex-start;\n    }\n\n    .spot-container-main .bottom {\n        min-height: unset;\n        flex-direction: column;\n    }\n\n    .bottom-left {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .bottom-right,\n    .spot-container-main .top-right {\n        width: 100%;\n    }\n\n    .spot-container-right-right {\n        flex: auto;\n        max-width: 100%;\n    }\n\n    ul.nav.custom-tabs.order_his_tabs li a {\n        padding: 7px 20px;\n        font-size: 14px;\n    }\n\n    .container-chart-briefing {\n        height: unset;\n        padding-bottom: 10px;\n    }\n\n    .trade-wrapper.spot {\n        max-width: 100%;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .trade-wrapper.spot.pb-3 {\n        max-width: 100%;\n    }\n\n\n}\n\n\n@media screen and (max-width: 1299px) and (min-width: 992px) {\n\n    .spot-container {\n        flex-direction: column;\n    }\n\n    .spot-container-right-right {\n        flex: auto;\n        max-width: 100%;\n        display: flex;\n    }\n\n    /* .inner-page-banner {\n            padding: 77px 0 43px;\n        } */\n    section.pb-90.account_sec {\n        padding-bottom: 0;\n    }\n}\n\n@media screen and (max-width:1550px) {\n\n    .trade_card.p-2.overflow_card.mb-1 {\n        width: calc(100% + 28.5%);\n    }\n\n    ul.favorites_list_tabs {\n        gap: 12px;\n        margin: 12px 7px;\n    }\n\n    .trade_card .table> :not(caption)>*>* {\n        font-size: 11px;\n    }\n\n    .trade-wrapper .orderbook-table th {\n        padding: 4px 7px;\n    }\n\n    .trade-wrapper .orderbook-table td {\n        padding: 4px 7px;\n    }\n\n    ul.favorites_list_tabs li button {\n        font-size: 13px;\n    }\n\n\n\n\n}\n\n@media screen and (max-width:1440px) {\n    .assets_btn {\n        gap: 10px;\n    }\n\n    .stop_avail_val {\n        font-size: 12px;\n    }\n\n    .stop_avail_label {\n        font-size: 12px;\n    }\n\n    .trade-wrapper .orderbook-table th {\n        font-size: 10px !important;\n        padding: 4px 5px;\n    }\n\n    .trade-wrapper .orderbook-table td {\n        font-size: 10px !important;\n        padding: 4px 5px !important;\n    }\n\n    .card_header_title {\n        font-size: 12px;\n    }\n\n    ul.favorites_list_tabs li button {\n        font-size: 12px;\n        padding: 0px 0px 5px;\n    }\n\n    ul.favorites_list_tabs {\n        gap: 10px;\n        margin: 5px 5px;\n    }\n\n    .assets_btn button {\n        font-size: 12px;\n        padding: 5px 5px;\n    }\n\n}\n\n@media screen and (max-width:1367px) {\n\n    .trade_card.p-2.overflow_card.mb-1 {\n        width: calc(100% + 244px);\n    }\n\n    .assets_right {\n        width: 18.9%;\n    }\n\n    .trade_favourites_lft .spotLists {\n        height: 100%;\n    }\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card {\n        width: 98.5%;\n    }\n\n    div#tab_3 {\n        border-radius: 0px;\n    }\n\n\n}\n\n\n@media screen and (max-width: 1200px) {\n\n    .trade_card.p-2.overflow_card.mb-1 {\n        width: calc(100% + 0px);\n    }\n\n    .midgraph_col {\n        width: 100%;\n    }\n\n    .trade_favourites_lft {\n        width: 30%;\n    }\n\n    .trade-wrapper .row {\n        row-gap: 0px;\n    }\n\n    div#tab_3 {\n        border-radius: 0px;\n    }\n\n    div#tab_4 {\n        border-radius: 10px;\n        margin-top: 0px !important;\n    }\n\n}\n\n/* Ensure tab_3 shows on desktop (lg+) even if d-none is present */\n@media screen and (min-width: 992px) {\n    div#tab_3.d-none.d-lg-block {\n        display: block !important;\n    }\n}\n\n@media screen and (max-width: 991px) {\n\n    .midgraph_col {\n        width: 100%;\n    }\n\n    .trade_favourites_lft {\n        width: 100%;\n    }\n\n    .bs_tab_row {\n        z-index: 999999;\n    }\n\n    .mmn_btm_minus_spc button.btn.btn-danger {\n        font-size: 12px;\n        padding: 6px 16px;\n    }\n\n    .bs_tab_row button.btn.btn-success {\n        padding: 6px 16px;\n    }\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card {\n        left: 1px;\n    }\n\n}\n\n/* Trade account summary: mobile cardbox only (desktop unchanged) */\n@media screen and (max-width: 991px) {\n\n    /* Sticky container logic */\n    .trade_account_summary_assets {\n        position: sticky !important;\n        top: 80px !important;\n        z-index: 100;\n    }\n\n    .trade_account_summary_assets.is-stuck {\n        height: calc(100vh - 80px) !important;\n    }\n\n    /* When stuck, the table container becomes internally scrollable */\n    .trade_account_summary_assets.is-stuck .mobile_view2,\n    .trade_account_summary_assets.is-stuck .order_history_mobile_view {\n        max-height: calc(100vh - 80px - 55px) !important;\n        /* 55px accounts for the sticky tabs header */\n        overflow-y: auto !important;\n    }\n\n    /* When NOT stuck, everything displays fully and scrolls natively with the page */\n    .trade_account_summary_assets:not(.is-stuck) .mobile_view2,\n    .trade_account_summary_assets:not(.is-stuck) .order_history_mobile_view {\n        max-height: none !important;\n        overflow-y: visible !important;\n    }\n\n    .trade_summary_table_lft_position_order.position_order {\n        overflow: visible !important;\n    }\n\n    .trade_account_summary_assets .desktop_view2 {\n        display: none !important;\n    }\n\n    .trade_account_summary_assets .order_history_mobile_view {\n        display: block !important;\n        margin-top: 10px;\n        color: #000;\n        padding-bottom: 75px;\n        margin-bottom: 0px;\n    }\n\n    body.light_theme .trade_account_summary_assets {\n        background-color: #ffffff;\n        border-radius: 14px 14px 0px 0px;\n    }\n\n    .mobile-favourites-popup-overlay span.agce-margin-filter-arrow {\n        display: none;\n    }\n\n    .mobile-favourites-popup-overlay .agce-margin-filter-bar {\n        grid-template-columns: 1fr 1fr !important;\n        display: grid;\n    }\n\n    .mobile-favourites-popup-overlay .agce-margin-filter-select {\n        min-width: 100%;\n        max-width: 100%;\n    }\n\n    .mobile-favourites-popup-overlay .agce-margin-filter-input {\n        width: 100% !important;\n    }\n\n    .trade_account_summary_assets .order_history_mobile_view .d-flex.datalist_mbl {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n    }\n\n    /* Executed fills block sits under mobile order card (order history) */\n    .trade_account_summary_assets .trade_page_mob_execBelow {\n        /* margin: -8px 0 4px 0; */\n        /* padding: 10px 12px 12px;\n        border: 1px solid #efefef;\n        border-radius: 0 0 8px 8px;\n        background: #f9fafb; */\n    }\n\n    html[data-theme=\"dark\"] .trade_account_summary_assets .trade_page_mob_execBelow {\n        background: #181a20;\n        border-color: #2b3139;\n    }\n\n    .trade_account_summary_assets .order_datalist {\n        /* border: 1px solid #efefef;\n        padding: 12px; */\n        margin: 0;\n    }\n\n    .trade_account_summary_assets .order_datalist .listdata {\n        gap: 9px;\n        padding: 0;\n    }\n\n    .trade_account_summary_assets .order_datalist .listdata li {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        gap: 12px;\n        border-bottom: 1px dashed rgba(255, 255, 255, 0.08);\n        padding-bottom: 7px;\n    }\n\n    .trade_account_summary_assets .order_datalist .listdata li:last-child {\n        border-bottom: 0;\n        padding-bottom: 0;\n    }\n\n    .trade_account_summary_assets .order_datalist .listdata li span:first-child {\n        color: #8e949e;\n        min-width: 110px;\n        flex: 0 0 110px;\n    }\n\n    .trade_account_summary_assets .order_datalist .listdata li span:last-child {\n        text-align: right;\n        min-width: 0;\n        overflow-wrap: anywhere;\n        word-break: break-word;\n    }\n}\n\n/* Favourites left panel: open only on click */\n.trade_favourites_lft.is-collapsed {\n    display: none !important;\n}\n\n.trade_favourites_lft.is-open {\n    display: block !important;\n}\n\n/* Desktop hover dropdown behaviour: start below headline, extend to bottom */\n@media screen and (min-width: 992px) {\n    .trade-wrapper.spot.pb-3 .row.g-1.g-md-2 {\n        position: relative;\n    }\n\n    .trade_favourites_lft.is-open {\n        position: absolute;\n        left: 0;\n        top: auto;\n        margin-top: 75px;\n        height: 100%;\n        bottom: auto;\n        width: 360px;\n        max-width: calc(100vw - 16px);\n        z-index: 99999;\n        background-color: #2b313c;\n        border-radius: 0px;\n        padding: 0;\n        overflow: hidden;\n        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);\n        /* height: calc(100vh - 120px); */\n        border-radius: 5px;\n    }\n\n    .trade_favourites_lft.is-open .spotLists {\n        max-height: 100%;\n        flex-direction: column;\n        overflow: hidden;\n    }\n\n    .trade_favourites_lft.is-open .spot-list-search {\n        flex-shrink: 0;\n        padding: 12px 12px 0;\n    }\n\n    .trade_favourites_lft.is-open ul.favorites_list_tabs {\n        flex-shrink: 0;\n        margin: 12px 12px 0;\n        padding-bottom: 10px;\n        background-color: transparent;\n        position: sticky;\n        border: none;\n        top: 56px;\n        z-index: 2;\n    }\n\n    .trade_favourites_lft.is-open .price_card {\n        flex: 1;\n        min-height: 0;\n        overflow: auto;\n        padding: 0;\n    }\n\n    .trade_favourites_lft.is-open .price_card.table-responsive {\n        overflow: auto;\n        max-height: 96vh;\n    }\n}\n\n\n@media screen and (max-width: 1600px) and (min-width: 1200px) {\n    .spot-container .col-xxl-2 {\n        flex: 0 0 auto;\n        width: 24%;\n    }\n\n    .spot-container .col-xxl-4 {\n        flex: 0 0 auto;\n        width: 48%;\n    }\n\n    .spot-container .col-xxl-8 {\n        flex: 0 0 auto;\n        width: 52%;\n    }\n\n\n}\n\n@media screen and (max-width: 3000px) and (min-width: 1601px) {\n    .spot-container .col-xxl-2 {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n\n    .spot-container .col-xxl-4 {\n        flex: 0 0 auto;\n        width: 40%;\n    }\n\n    .spot-container .col-xxl-8 {\n        flex: 0 0 auto;\n        width: 60%;\n    }\n}\n\n.scroll_y_reverse {\n    display: flex;\n    flex-direction: column-reverse;\n}\n\n\n.font-weight-boldd {\n    font-weight: 500;\n    font-size: 13px;\n    color: #ebebeb;\n}\n\nbody.theme-light .font-weight-boldd {\n    color: #070808;\n}\n\nspan.font-weight-boldd.text-green {\n    font-weight: 600;\n}\n\n@media (max-width: 1200px) {\n\n    body .agce-margin-filter-toggle-btn {\n        border: none;\n        color: #fff;\n        padding: 0px !important;\n    }\n\n    body.light_theme .agce-margin-filter-toggle-btn {\n        color: #000;\n    }\n\n    .trade_account_summary_assets .order_history_mobile_view {\n        color: #f7f7f7;\n    }\n\n    body.light_theme .trade_account_summary_assets .order_history_mobile_view {\n        color: #000000;\n    }\n\n    .agce-margin-pos-val-primary {\n        font-size: 13px;\n    }\n\n}\n\n\n/* responsive */\n@media (max-width: 991.98px) {\n\n    /* Mobile Favourites Toggle Button */\n    .mobile-favourites-toggle-btn {\n        display: block;\n        margin-bottom: 15px;\n    }\n\n    ul.favorites_list_tabs {\n        border-bottom: none;\n    }\n\n    .favourites-toggle-btn-mobile {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 10px 20px;\n        background-color: #2B313C;\n        border: 1px solid #434343;\n        border-radius: 8px;\n        color: #fff;\n        font-size: 14px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.3s ease;\n    }\n\n    .favourites-toggle-btn-mobile:hover {\n        background-color: #373E4B;\n        border-color: #565A62;\n    }\n\n    .favourites-toggle-btn-mobile:focus-visible {\n        background-color: #373E4B;\n        border-color: #565A62;\n    }\n\n    .favourites-toggle-btn-mobile:active {\n        background-color: #373E4B !important;\n        border-color: #565A62 !important;\n    }\n\n    .favourites-toggle-btn-mobile i {\n        font-size: 16px;\n    }\n\n    body.light_theme.favourites-toggle-btn-mobile {\n        background-color: #f5f5f5;\n        border-color: #e0e0e0;\n        color: #333;\n    }\n\n\n    body.light_theme.favourites-toggle-btn-mobile:hover {\n        background-color: #e9e9e9;\n        border-color: #d0d0d0;\n    }\n\n    .trade_favourites_lft.hide-favourites-mobile {\n        display: none;\n    }\n\n    .trade_favourites_lft.show-favourites-mobile {\n        display: block;\n    }\n\n\n\n    .midgraph_col {\n        width: 100%;\n    }\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card {\n        left: 0px;\n    }\n\n    .trade_favourites_lft {\n        width: 100%;\n        display: none;\n    }\n\n    /* Mobile Favourites Popup */\n    .mobile-favourites-popup-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: rgb(0 0 0 / 50%);\n        backdrop-filter: blur(4px);\n        z-index: 9999999999 !important;\n        display: flex;\n        align-items: flex-end;\n        justify-content: center;\n        animation: fadeIn 0.3s ease;\n    }\n\n    body.light_theme .mobile-favourites-popup-overlay {\n        background-color: rgb(255 255 255 / 33%);\n    }\n\n    @keyframes fadeIn {\n        from {\n            opacity: 0;\n        }\n\n        to {\n            opacity: 1;\n        }\n    }\n\n    @keyframes slideUp {\n        from {\n            transform: translateY(100%);\n        }\n\n        to {\n            transform: translateY(0);\n        }\n    }\n\n    .mobile-favourites-popup {\n        width: 100%;\n        max-height: 85vh;\n        background-color: #000000a8;\n        backdrop-filter: blur(4px);\n        border-top-left-radius: 0px;\n        border-top-right-radius: 0px;\n        display: flex;\n        padding-bottom: 80px !important;\n        flex-direction: column;\n        animation: slideUp 0.3s ease;\n        box-shadow: 0px 5px 20px #494949;\n        overflow: hidden;\n        border-radius: 10px 10px 0px 0px;\n    }\n\n    .mobile-favourites-popup .spotLists {\n        backdrop-filter: blur(0px) !important;\n    }\n\n    .mobile-favourites-popup.pairpopup {\n        padding-bottom: 10px !important;\n    }\n\n    .mobile-favourites-popup .btn {\n        font-size: 14px !important;\n        margin-top: 0px !important;\n    }\n\n    .agce-margin-mobile-filter-header {\n        padding: 10px 0px !important;\n    }\n\n    .mobile-favourites-popup .orderbook-table th {\n        background: #2b313c00;\n        padding: 3px 8px;\n    }\n\n    .mobile-favourites-popup.pairpopup table thead th {\n        background-color: #121213;\n    }\n\n    body.light_theme .mobile-favourites-popup.pairpopup table thead th {\n        background-color: #fff;\n    }\n\n    .headline_bigName__dspVW h1 {\n        display: flex;\n    }\n\n    .treade_card_header {\n        border-bottom: none !important;\n    }\n\n    body.light_theme.mobile-favourites-popup {\n        background-color: #ffffff;\n    }\n\n    .mobile-favourites-popup-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        background-color: #000000a1;\n        padding: 9px 15px 5px;\n        border-bottom: none;\n    }\n\n    body.light_theme .mobile-favourites-popup-header {\n        border-bottom-color: #e0e0e0;\n        background-color: #ffffff2b;\n    }\n\n    .mobile-favourites-popup-header h4 {\n        margin: 0;\n        font-size: 15px;\n        font-weight: 500;\n        color: #fff;\n    }\n\n    body.light_theme.mobile-favourites-popup-header h4 {\n        color: #333;\n    }\n\n    .mobile-favourites-close-btn {\n        background: transparent;\n        border: none;\n        color: #9b9b9b;\n        font-size: 22px;\n        cursor: pointer;\n        padding: 5px;\n        font-weight: 400;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        transition: background-color 0.2s ease;\n    }\n\n\n\n    .mobile-favourites-close-btn:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n    }\n\n    body.light_theme.mobile-favourites-close-btn {\n        color: #333;\n    }\n\n    body.light_theme.mobile-favourites-close-btn:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    .mobile-favourites-popup-content {\n        flex: 1;\n        overflow-y: auto;\n    }\n\n    .mobile-favourites-popup-content .spotLists {\n        background: transparent;\n        padding: 0;\n        display: block;\n        top: 0px;\n        max-width: calc(100% - 0px);\n        left: 0px;\n    }\n\n    .mobile-favourites-popup-content ul.favorites_list_tabs {\n        padding: 0px 10px;\n    }\n\n    .mobile-favourites-popup-content img.round_img {\n        width: 24px !important;\n        height: 24px !important;\n        min-width: 24px;\n    }\n\n    .orderbook-table td {\n        padding: 4px 7px;\n    }\n\n    ul.favorites_list_tabs li button {\n        font-size: 14px;\n    }\n\n    ul.favorites_list_tabs {\n        gap: 15px;\n        margin: 7px 0px;\n    }\n\n    .headline_left__lBBPY_leftmain.d-flex.align-items-center {\n        width: 50%;\n    }\n\n    .scroll-subtabs_subMarketWrap__XVmHp {\n        /* max-width: 264px; */\n        min-width: 194px;\n    }\n\n    .mmn_btm_minus_spc {\n        margin: 4px 0px 0px\n    }\n\n    .tch_main_tab .card_header_title {\n        padding: 8px 7px 6px;\n    }\n\n    /* .trade_summary_table_lft {\n        padding: 10px !important;\n    } */\n\n    .infor_row li {\n        font-size: 13px;\n        font-weight: 500;\n        line-height: 18px;\n        padding: 5px 0;\n    }\n\n    .inf_row {\n        padding: 1rem;\n        height: 429px !important;\n        overflow-y: auto;\n    }\n\n\n\n    .scroll-subtabs_scrollSubInfo__T5nZF {\n        flex: 1 1;\n        width: 0;\n        margin-inline-start: 0;\n        position: relative;\n    }\n\n    .headline_left__lBBPY_leftmain.d-flex.align-items-center {\n        align-items: flex-start !important;\n        justify-content: flex-start;\n        flex-direction: column;\n    }\n\n    .trade_card.p-2.overflow_card.mb-1 {\n        height: auto;\n        padding: 20px 16px 12px !important;\n    }\n\n    .headline_left__lBBPY_leftmain .headline_symbolName__KfmIZ {\n        margin-bottom: 0;\n    }\n\n    /* .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS {\n        flex-direction: column;\n        align-items: flex-start !important;\n    } */\n\n    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 5px;\n        align-items: flex-start !important;\n    }\n\n    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq {\n        display: flex;\n        width: 100%;\n        justify-content: flex-end;\n    }\n\n    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq .headline_withBorder__a6ZD2 {\n        flex: 1 1;\n        font-size: 9px;\n        text-align: start;\n        margin-inline-end: 0;\n    }\n\n    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq .headline_title__x1csO {\n        flex: 1 1;\n        text-align: right;\n        -webkit-margin-end: 0;\n        margin-inline-end: 0;\n    }\n\n    .headline_latestPrice__AYXu0 .headline_title__x1csO {\n        font-size: 20px;\n    }\n\n    .trade-wrapper .assets_list h4 {\n        font-size: 14px;\n        align-items: center;\n        gap: 5px;\n        display: flex;\n    }\n\n    .inf_row .headline_bigName__dspVW,\n    .headline_bigName__dspVW h1 {\n        font-size: 14px !important;\n    }\n\n    span.headline_change__tGyxo {\n        font-size: 16px;\n    }\n\n    .headline_leftItem__7BFYq {\n        /* margin-inline-end: 60px; */\n        font-size: 12px;\n        line-height: 1.2;\n        white-space: nowrap;\n        padding: 4px 0;\n        font-weight: 500;\n    }\n\n    .headline_leftItem__7BFYq {\n        margin-inline-start: 0;\n        display: flex;\n        flex-direction: column;\n        align-items: start;\n        gap: 3px;\n    }\n\n    .scroll-container {\n        overflow-y: auto;\n        max-height: 175px;\n        height: auto;\n    }\n\n    .exchange_chartContent__Ijukg {\n        height: auto;\n        overflow-y: auto;\n    }\n\n    .information_bright__F_RTd {\n        opacity: 1 !important;\n        margin-left: 6px;\n    }\n\n    .information_left__vgFSY,\n    .information_right__kqyPI {\n        width: 41%;\n    }\n\n    .trade-wrapper .btn {\n        height: auto !important;\n        min-height: unset !important;\n        margin-top: 5px;\n        border-radius: 50px;\n    }\n\n    .btn-group.btn-group-mini {\n        margin-bottom: 3px;\n    }\n\n    .btn-group.btn-group-mini * {\n        padding: 0px 0px;\n        min-height: unset;\n        border-radius: 9px !important;\n        line-height: 29px;\n        font-size: 11px !important;\n    }\n\n    .col-12.col-sm-6.col-lg-6.col-xl-3.col-xxl-2.order-2,\n    .col-12.col-sm-6.col-lg-6.col-xl-3.col-xxl-2.order-3.order-xl-3 {\n        margin-top: 0;\n    }\n\n    .price_card_body.price_card_body_full,\n    .scroll_y {\n        height: 240px;\n    }\n\n    .scroll_y_full {\n        height: 502.8px;\n    }\n\n    .scroll_y_full {\n        /* height: 480px; */\n    }\n\n    .scroll_y_coins {\n        height: 339px;\n    }\n\n    footer.footer-wrapper {\n        margin-top: 0;\n    }\n\n    .trade-wrapper .container-fluid {\n        padding-right: 8px;\n        padding-left: 8px;\n        overflow: hidden;\n    }\n\n    .scroll-subtabs_tabs__Prom8 {\n        justify-content: flex-end;\n    }\n\n    .d-flex.spottabs_top {\n        border-bottom: none;\n    }\n\n\n    .trade_tabs .num-select {\n        font-size: 10px;\n    }\n\n    .buysell_heder {\n        padding: 10px !important;\n    }\n\n    .spot .form-control,\n    .spot select {\n        padding: 4px 18px;\n        min-width: unset;\n    }\n\n    .trade_chart .form-select-sm {\n        padding: 6px 9px !important;\n        font-size: 12px;\n    }\n\n    .actions_balance__kTHO0 {\n        flex-direction: column;\n        align-items: start;\n        line-height: 1.5;\n    }\n\n    .actions_primaryText__ufKT0 {\n        opacity: 0.7;\n        margin-right: 10px;\n        font-size: 10px;\n        margin-bottom: 3px;\n    }\n\n    .trade-wrapper .mb-1 {\n        margin-bottom: 4px !important;\n    }\n\n    .price_card_head>div {\n        word-break: break-all;\n        font-size: 10px;\n        vertical-align: bottom;\n        padding: 0 6px;\n    }\n\n    .price_card .price_card_head {\n        padding: 0 5px;\n        margin: 0;\n        min-height: 24px;\n        line-height: 1.1;\n    }\n\n    .trade_tabs.buy_sell_cards.buy_sell_row.d-flex-between {\n        padding: 0px 7px 0px 9px;\n    }\n\n    .price_item_value span:first-child,\n    .price_card_head>div:first-child {\n        padding-left: 5px;\n    }\n\n    body .trade_card#tab_mobile_trade_history .table> :not(caption)>*>* {\n        padding: 5px !important;\n    }\n\n    .price_item_value span {\n        word-break: break-all;\n        white-space: nowrap;\n        line-height: 1.1;\n    }\n\n    .buysellform .input-group {\n        padding: 0px 11px;\n    }\n\n    .buysell_card {\n        /* height: 504px; */\n    }\n\n    .price_item_value span:last-child,\n    .price_card_head>div:last-child {\n        padding-right: 5px;\n    }\n\n    .buy_sell_row_price .scroll_y {\n        height: 400px;\n    }\n\n    .usd_future_dashboard .table_info_data table tr td {\n        font-size: 10px;\n    }\n\n    .usd_future_dashboard .table_info_data table tr th {\n        font-size: 10px;\n    }\n\n    .buy_sell_row_price .scroll_y.orderbook-single-side {\n        height: 400px;\n        max-height: min(65vh, 560px);\n    }\n\n    .spotLists {\n        width: 100%;\n        max-width: calc(100% - 12px);\n        left: 6px;\n        top: 162px;\n        min-height: 150px;\n        max-height: 470px;\n    }\n\n    .mobile-favourites-popup-overlay .pair-color {\n        font-weight: 400;\n    }\n\n    .limit_markettabs {\n        padding: 10px 16px 0px 16px;\n    }\n\n    .bs_dropbox .spotLists {\n        width: 100%;\n        width: 100%;\n        max-width: 500px;\n        top: unset;\n        left: 0;\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .spotLists .price_card_body.tab-content.scroll_y {\n        height: 345px;\n    }\n\n    body .agce-margin-leverage-row {\n        padding: 0px 0px 8px;\n    }\n\n}\n\n@media screen and (max-width: 660px) {\n\n    .headline_leftItem__7BFYq {\n        font-size: 11px;\n    }\n}\n\n@media screen and (max-width: 991px) and (min-width: 320px) {\n\n    /* .bs_dropbox .summay_dasboard_pop {\n        display: block !important;\n    } */\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card {\n        width: 100%;\n        min-height: 100%;\n    }\n\n    div#tab_4 {\n        margin-top: -0.5rem;\n    }\n\n    .bs_dropbox .col-lg-6 {\n        padding: 0px;\n    }\n\n    .summay_dasboard_pop {\n        height: auto !important;\n        width: 40%;\n        border-radius: 0px !important;\n    }\n\n    .letsidebar_tradetbl .bs_tab_row {\n        background: none;\n        border-top: none;\n        -webkit-backdrop-filter: blur(5px);\n        backdrop-filter: blur(5px);\n        /* background: #1e1d3054; */\n    }\n\n    .letsidebar_tradetbl .bs_tab_row button.btn.btn-danger {\n        font-size: 14px;\n    }\n\n    .letsidebar_tradetbl .bs_tab_row button.btn.btn-success {\n        font-size: 14px;\n    }\n\n\n    .bs_dropbox {\n        position: fixed;\n        width: 100%;\n        background-color: rgba(109, 109, 109, 0.4);\n        backdrop-filter: blur(5px);\n        -webkit-backdrop-filter: blur(5px);\n        top: 0;\n        bottom: 0;\n        z-index: 99999999;\n        left: 0;\n        display: flex;\n        align-items: end;\n        justify-content: center;\n        min-width: 100%;\n        max-width: 100%;\n    }\n\n\n    body.light_theme .bs_dropbox {\n        background-color: rgb(255 255 255 / 20%);\n    }\n\n    .trade-wrapper .bs_dropbox .row {\n        width: 100%;\n    }\n\n    .bs_dropbox .buysell_card {\n        height: auto;\n        width: 100%;\n        max-width: 100%;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        overflow-y: auto;\n        max-height: 100%;\n        background-color: #111114b8;\n    }\n\n    .bs_dropbox .summay_dasboard_pop {\n        padding: 0px 3px;\n    }\n\n    .bs_dropbox .price_card_head>div {\n        font-size: 8px;\n    }\n\n    .bottm_lightbox_two {\n        height: 80vh;\n        box-shadow: 0px 0px 30px #0000009c;\n        border-radius: 14px 14px 0px 0px;\n        overflow: hidden;\n    }\n\n    .bottm_lightbox_two .trade_card,\n    .spotLists {\n        border: none;\n        border-radius: 0px;\n    }\n\n    .bs_box_header h6 {\n        font-size: 18px;\n    }\n\n    .bottm_lightbox_two .assets_btn {\n        flex-direction: row;\n    }\n\n    .bottm_lightbox_two .assets_list {\n        margin: 10px 20px 20px;\n    }\n\n    .bs_dropbox .buysell_card .btn-mini {\n        font-size: 12px !important;\n        padding: 10px 10px 9px;\n    }\n\n    .bs_dropbox .bs_box_header {\n        margin-bottom: 3px;\n    }\n\n    .bs_dropbox .spot_limit select {\n        background: transparent !important;\n        box-shadow: none;\n        -webkit-backdrop-filter: blur(5px);\n        backdrop-filter: blur(5px);\n        border: none;\n        padding: 0px;\n        min-width: unset;\n        border-radius: 0px !important;\n    }\n\n    .bs_dropbox .buysell_card .p-2.p-md-3 {\n        padding: 15px !important;\n    }\n\n    .bs_dropbox .price_card_body.scroll_y.scroll_y_reverse {\n        align-items: normal;\n        justify-content: start;\n        max-height: 100%;\n        min-height: 100%;\n        height: 100%;\n    }\n\n    .bs_dropbox .buysell_heder .custom-tabs li.buysell-tab.buy-tab a {\n        border-radius: 0px;\n    }\n\n    .bs_dropbox .buysell_heder .custom-tabs li a {\n        border-radius: 0px;\n    }\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card .assets_list {\n        margin: 0px 15px 15px;\n    }\n\n\n    .bs_dropbox .buysellform .input-group .form-control {\n        font-size: 12px !important;\n        padding: 3px 6px;\n    }\n\n    .bs_dropbox .price_card_body.scroll_y {\n        max-height: 39%;\n        min-height: 39%;\n        overflow: auto;\n    }\n\n    .bs_dropbox .buysell_card.trade_chart .form-select-sm {\n        padding: 0px !important;\n        font-size: 12px;\n    }\n\n    .bs_dropbox .buysellform .input-group {\n        padding: 7px 7px 7px 3px;\n    }\n\n    .bs_dropbox .btn-group.btn-group-mini * {\n        font-size: 10px !important;\n    }\n\n    .bs_dropbox .assets_list h4 {\n        font-size: 15px;\n    }\n\n    .bs_dropbox a.more_btn {\n        font-size: 11px;\n    }\n\n    .bs_dropbox .assets_list .top_heading {\n        flex-direction: row;\n    }\n\n    .bs_dropbox .buysell_heder {\n        padding: 13px 15px !important;\n    }\n\n    .bs_dropbox .buysell_heder .custom-tabs li a {\n        padding: 4px 0;\n        font-size: 12px;\n        font-weight: 700;\n    }\n\n\n    .headline_extendInfoWrapper__dooIS,\n    .headline_left__lBBPY,\n    .headline_wrapper__BKn9L {\n        display: flex;\n        align-items: start;\n    }\n\n    .bs_dropbox.active {\n        display: flex !important;\n    }\n}\n\n@media (max-width: 991.98px) {\n\n    /* Allow chart card to grow on small screens (desktop had fixed 594px) */\n    .midgraph_col .trade_card.trade_chart {\n        height: auto !important;\n        min-height: 0;\n    }\n\n    body.light_theme .trade-wrapper .orderbook-table td {\n        color: #191919 !important;\n    }\n\n    /* Chart tab: let TVChartContainer set height (taller while loading for centered spinner) */\n    .trade_card.trade_chart #tab_1.cc_tab:not(.d-none) {\n        display: flex;\n        flex-direction: column;\n        flex: 1 1 auto;\n        min-height: 0;\n        height: auto !important;\n    }\n}\n\n@media (max-width: 480px) {\n    #tab_1 {\n        min-height: 400px;\n    }\n}\n\n/* —— Spot bottom panel: Open Orders (tabs, filters, table, empty state) —— */\n.position_order .cnt_table {\n    display: none;\n    flex-direction: column;\n    width: 100%;\n    padding: 0px 13px;\n}\n\n.position_order .cnt_table.active {\n    display: flex;\n}\n\n.trade_summary_table_lft_position_order.position_order {\n    background: #181a20;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n/* .position_order .spot_orders_top {\n    background: #ececec;\n} */\n\n.spot_orders_primary_tabs_scrollWrap {\n    position: relative;\n    width: 100%;\n    min-width: 0;\n}\n\n.position_order .position_list.spot_orders_primary_tabs {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 4px 8px;\n    list-style: none;\n    margin: 0;\n    padding: 0 12px;\n    border-bottom: 1px solid #d1d5db2e;\n}\n\nbody.light_theme .position_order .position_list.spot_orders_primary_tabs {\n    border-bottom: 1px solid #d1d5db\n}\n\n/* Single horizontal row: never wrap tabs; scroll when needed (arrows on narrow viewports below) */\n.position_order .position_list.spot_orders_primary_tabs.spot_orders_primary_tabs--scroller {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    overscroll-behavior-x: contain;\n    min-width: 0;\n}\n\n.position_order .position_list.spot_orders_primary_tabs.spot_orders_primary_tabs--scroller::-webkit-scrollbar {\n    display: none;\n}\n\n.position_order .position_list.spot_orders_primary_tabs.spot_orders_primary_tabs--scroller>li {\n    flex: 0 0 auto;\n}\n\n.position_order .spot_orders_primary_tabs li {\n    margin: 0;\n    padding: 0;\n}\n\n.position_order .spot_orders_primary_tabs li button {\n    border: none;\n    background: transparent;\n    color: #6b7280;\n    font-size: 13px;\n    font-weight: 600;\n    position: relative;\n    font-family: \"Inter\", sans-serif;\n    padding: 12px 8px 10px;\n    margin: 0;\n    border-bottom: none;\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.position_order .spot_orders_primary_tabs li button::before {\n    content: \"\";\n    position: absolute;\n    content: \" \";\n    min-width: 30px;\n    height: 3px;\n    border-radius: 10px;\n    background-color: #d1aa67;\n    bottom: -1px;\n    left: 50%;\n    transform: translateX(-50%) scaleX(.5);\n    opacity: 0;\n    transition: all .16s ease-in;\n}\n\n.position_order .spot_orders_primary_tabs li.active button::before {\n    opacity: 1;\n}\n\n.position_order .spot_orders_primary_tabs li.active button {\n    color: #fff;\n    font-weight: 600;\n    border-bottom-color: #111827;\n}\n\nbody.light_theme .position_order .spot_orders_primary_tabs li.active button {\n    color: #111827;\n}\n\n.spot_orders_filter_bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: start;\n    gap: 10px;\n    padding: 12px 18px 10px;\n    background: none;\n    border-bottom: none;\n}\n\n/* Scroll row + arrows (Open Orders chips) — inner scroller; arrows shown on mobile only */\n.spot_orders_filter_scrollWrap {\n    position: relative;\n    width: 100%;\n    min-width: 0;\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n}\n\n.spot_orders_filter_chips--scroll {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    align-items: center;\n    flex: 1;\n    min-width: 0;\n}\n\n.spot_orders_chipsArrow {\n    display: none;\n}\n\n.spot_orders_filter_chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    align-items: center;\n    flex: 1;\n    min-width: 0;\n}\n\n.spot_orders_chip {\n    border: none;\n    background: #f6f6f714;\n    color: #909397;\n    font-size: 12px;\n    font-weight: 400;\n    font-family: \"Inter\", sans-serif;\n    padding: 7px 16px;\n    border-radius: 999px;\n    border-radius: 4px !important;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.agce-margin-filter-popup-content .spot_orders_chip {\n    background: #f0f0f017;\n}\n\nbody.light_theme .spot_orders_chip {\n    background: #f6f6f7;\n}\n\n\n.spot_orders_chip.is-active {\n    background: #F6F6F7;\n    color: #000000;\n    font-weight: 500;\n}\n\n.spot_orders_filter_actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n}\n\n.spot_orders_side_select {\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    background: #fff;\n    color: #111827;\n    font-size: 12px;\n    padding: 6px 28px 6px 10px;\n    font-family: \"Inter\", sans-serif;\n    cursor: pointer;\n}\n\n.spot_orders_reset {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    border: none;\n    background: transparent;\n    color: #909397;\n    font-size: 14px;\n    font-weight: 500;\n    font-family: \"Inter\", sans-serif;\n    cursor: pointer;\n    padding: 4px 11px;\n}\n\n.spot_orders_reset:hover {\n    color: #e7e7e7;\n}\n\nbody.light_theme .spot_orders_reset:hover {\n    color: #111827;\n}\n\n.spot_orders_table thead th {\n    font-size: 11px;\n    font-weight: 600;\n    color: #9ca3af;\n    text-transform: none;\n    border-bottom: 1px solid #ececec;\n    padding: 10px 8px !important;\n    white-space: nowrap;\n    font-family: \"Inter\", sans-serif;\n}\n\n.spot_orders_table tbody td {\n    font-size: 12px;\n    color: #111827;\n    vertical-align: middle;\n    padding: 10px 8px !important;\n    font-family: \"Inter\", sans-serif;\n}\n\n.spot_orders_no_data_row {\n    width: 100% !important;\n    display: table-row !important;\n}\n\n.spot_orders_no_data_row td {\n    width: 100% !important;\n    display: table-cell !important;\n    border: none !important;\n    vertical-align: middle !important;\n    text-align: center !important;\n    padding: 0 !important;\n}\n\n.spot_orders_empty_state {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    justify-content: center !important;\n    text-align: center !important;\n    width: 100% !important;\n    min-height: 280px;\n    padding: 48px 0 !important;\n}\n\n.spot_orders_empty_telescope {\n    display: block !important;\n    margin: 0 auto !important;\n}\n\n.spot_orders_empty_caption {\n    margin: 16px 0 0;\n    font-size: 14px;\n    color: #6b7280;\n    font-family: \"Inter\", sans-serif;\n}\n\n.spot_orders_placeholder_shell {\n    min-height: 320px;\n    background: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_table_wrap,\nhtml[data-theme=\"dark\"] .spot_orders_placeholder_shell {\n    background: #181a20;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_table thead th {\n    color: #848e9c;\n    border-bottom-color: #2b3138;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_table tbody td {\n    color: #eaecef;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_empty_caption {\n    color: #9ca3af;\n}\n\n.spot_orders_empty_telescope {\n    display: block;\n    max-width: 120px;\n    height: auto;\n    filter: none;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_empty_telescope {\n    filter: invert(1) brightness(1.08);\n}\n\nbody.light_theme .spot_orders_empty_telescope {\n    filter: none !important;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_filter_bar {\n    background: #1e2329;\n    border-bottom-color: #2b3138;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_chip {\n    color: #9ca3af;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_chip.is-active {\n    background: #2b3138;\n    color: #eaecef;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_side_select {\n    background: #181a20;\n    border-color: #2b3138;\n    color: #eaecef;\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_reset {\n    color: #9ca3af;\n}\n\nhtml[data-theme=\"dark\"] .position_order .spot_orders_top {\n    background: #181a20;\n}\n\nhtml[data-theme=\"dark\"] .position_order .position_list.spot_orders_primary_tabs {\n    background: #181a20;\n    border-bottom-color: #2b3138;\n}\n\nhtml[data-theme=\"dark\"] .position_order .spot_orders_primary_tabs li button {\n    color: #9ca3af;\n}\n\nhtml[data-theme=\"dark\"] .position_order .spot_orders_primary_tabs li.active button {\n    color: #eaecef;\n    border-bottom-color: #eaecef;\n}\n\nbody.light_theme .trade_summary_table_lft_position_order.position_order {\n    background: #ffffff;\n}\n\n.bs_dropbox.d-lg-block.false {\n    margin-top: 0px;\n}\n\n.col-lg-6.ordermarketcntr {\n    padding: 0px 2px;\n    width: 48%;\n}\n\n.col-lg-6.letsidebar_tradetbl {\n    /* min-width: 328px; */\n    width: 52%;\n}\n\n\nbody.light_theme .position_order .spot_orders_top {\n    background: none;\n}\n\nbody.light_theme .position_order .position_list.spot_orders_primary_tabs {\n    background: none;\n    border-bottom-color: #EDEFF2;\n}\n\nbody.light_theme .spot_orders_filter_bar {\n    background: none;\n    border-bottom-color: #EDEFF2;\n}\n\n/* Tablet + mobile: primary tabs + chip filters — one row, scroll + left/right arrows when overflow */\n@media (max-width: 991.98px) {\n\n\n    .agce-margin-order-tabs-scroller .spot_limit {\n        width: auto;\n    }\n\n    .position_order .top_th_easyop.spot_orders_top {\n        display: block;\n        min-width: 0;\n        overflow: visible;\n    }\n\n    .stop_apr_card {\n        margin-bottom: 20px;\n    }\n\n    .position_order .spot_orders_primary_tabs_scrollWrap {\n        min-width: 0;\n    }\n\n    .position_order .position_list.spot_orders_primary_tabs.spot_orders_primary_tabs--scroller {\n        padding: 0 5px;\n    }\n\n    .spot_orders_filter_bar {\n        flex-wrap: nowrap;\n        overflow-x: visible;\n        overflow-y: visible;\n        justify-content: flex-start;\n        gap: 8px;\n        padding: 12px 8px 10px;\n        min-width: 0;\n    }\n\n    .spot_orders_filter_chips--scroll {\n        /* flex-wrap: nowrap; */\n        /* overflow-x: auto; */\n        /* overflow-y: hidden; */\n        -webkit-overflow-scrolling: touch;\n        /* scrollbar-width: none; */\n        /* overscroll-behavior-x: contain; */\n        gap: 8px;\n        padding: 0 5px;\n    }\n\n    .spot_orders_filter_chips--scroll::-webkit-scrollbar {\n        display: none;\n    }\n\n    .spot_orders_chipsArrow {\n        display: inline-flex;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        align-items: center;\n        justify-content: center;\n        /* width: 28px; */\n        height: 28px;\n        font-size: 18px;\n        padding: 0;\n        border-radius: 0px !important;\n        border: none;\n        border-radius: 999px;\n        background: #26292f;\n        color: #afafaf;\n        box-shadow: none;\n        z-index: 2;\n    }\n\n    body.light_theme .spot_orders_chipsArrow {\n        background: #ffffff;\n        color: #111827;\n    }\n\n    .spot_orders_chipsArrow--left {\n        left: 0;\n    }\n\n    .spot_orders_chipsArrow--right {\n        right: 0;\n    }\n\n    .spot_orders_chipsArrow.is-hidden {\n        display: none !important;\n    }\n\n    .spot_orders_filter_actions {\n        flex-shrink: 0;\n    }\n\n    .spot_orders_chip {\n        flex: 0 0 auto;\n    }\n}\n\nhtml[data-theme=\"dark\"] .spot_orders_chipsArrow {\n    background: #2b3138;\n    color: #eaecef;\n    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .spot_orders_chipsArrow {\n    background: #ffffff;\n    color: #7d7d7d;\n}\n\n/* Amount field: base / quote currency picker (Market, Stop Market, Stop Limit — not plain Limit) */\n.trade_amt_denom_addon {\n    display: flex;\n    align-items: stretch;\n}\n\n.trade_amt_denom_select {\n    position: relative;\n    flex-shrink: 0;\n    z-index: 5;\n}\n\n.trade_amt_denom_select__trigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 2px;\n    padding: 0;\n    margin: 0;\n    font-size: 13px;\n    font-weight: 500;\n    color: #fff;\n    background: none;\n    border: none;\n    cursor: pointer;\n    line-height: 1.2;\n    height: 100%;\n}\n\nbody.light_theme .trade_amt_denom_select__trigger {\n    color: #070808;\n}\n\n.input-group-text.text-start.trade_amt_denom_addon.trade_amount_coin_badge {\n    padding: 0;\n    min-width: auto;\n}\n\n.trade_amt_denom_select__trigger:hover {\n    background: none;\n}\n\n.trade_amt_denom_select__label {\n    text-align: left;\n}\n\n.trade_amt_denom_select__chev {\n    font-size: 14px;\n    color: #fff;\n}\n\nbody.light_theme .trade_amt_denom_select__chev {\n    color: #070808;\n}\n\n.trade_amt_denom_select__panel {\n    list-style: none;\n    margin: 4px 0 0;\n    padding: 6px 0;\n    position: absolute;\n    right: 0;\n    top: 100%;\n    min-width: 120px;\n    background: #fff;\n    border: 1px solid #e8e8e8;\n    border-radius: 10px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n    z-index: 20;\n}\n\n.trade_amt_denom_select__option {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    gap: 10px;\n    padding: 10px 14px;\n    border: none;\n    background: transparent;\n    font-size: 14px;\n    font-weight: 600;\n    color: #070808;\n    cursor: pointer;\n    text-align: left;\n}\n\n.trade_amt_denom_select__option:hover {\n    background: #f5f5f5;\n}\n\n.trade_amt_denom_select__check {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: rgb(255 255 255 / 30%);\n    color: #fff;\n    flex-shrink: 0;\n}\n\nbody.light_theme .trade_amt_denom_select__check {\n    background: #000;\n}\n\n.trade_amt_denom_select__check i {\n    font-size: 10px;\n    line-height: 1;\n}\n\nbody.light_theme .trade_amt_denom_select__trigger {\n    color: #070808;\n}\n\nbody:not(.light_theme) .trade_amt_denom_select__trigger {\n\n    color: #eaecef;\n}\n\nbody:not(.light_theme) .trade_amt_denom_select__panel {\n    background: #1e2329;\n    border-color: #2b3138;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);\n}\n\nbody:not(.light_theme) .trade_amt_denom_select__option {\n    color: #eaecef;\n}\n\nbody:not(.light_theme) .trade_amt_denom_select__option:hover {\n    background: #2b3138;\n}\n\n\n@media screen and (max-width: 1367px) {\n\n    .orderbook_two .buy_sell_row_price .scroll_y {\n        height: 190px;\n    }\n\n}\n\n\n\n@media screen and (max-width: 1200px) {\n\n\n    .col-lg-6.ordermarketcntr {\n        width: 50%;\n        margin: 0px;\n    }\n\n    .col-lg-6.ordermarketcntr div#tab_3 {\n        height: 660px;\n        margin-top: 0px;\n    }\n\n    .orderbook_two .buy_sell_row_price .scroll_y {\n        height: 225px;\n    }\n\n    .orderbook_two .buy_sell_row_price .scroll_y.orderbook-single-side {\n        height: 490px;\n        max-height: 490px;\n    }\n\n    .orderbook_two .buy_sell_row_price .scroll_y.orderbook-single-side.orderbook-asks-scroll.orderbook-asks-sell-list {\n        height: 430px;\n        max-height: 430px;\n    }\n\n    .col-lg-6.letsidebar_tradetbl {\n        width: 50%;\n        margin: 0px;\n    }\n\n    div#tab_3.d-none.d-lg-block {\n        border-radius: 4px;\n    }\n\n\n}\n\n@media screen and (max-width: 767px) {\n\n    /* .bs_dropbox .limit_markettabs {\n        overflow: hidden;\n    } */\n\n    .limit_markettabs {\n        padding: 10px 16px 15px 16px;\n    }\n\n    .position_order .position_list.spot_orders_primary_tabs {\n        border-bottom: none !important;\n    }\n\n    .spot_orders_empty_state {\n        min-height: 500px;\n    }\n\n    #TVChartContainer iframe {\n        height: 404px;\n    }\n\n    .trade_amt_denom_select__check {\n        width: 12px;\n        height: 12px;\n    }\n\n    .trade_amt_denom_select__check i {\n        font-size: 10px;\n    }\n\n    .trade_amt_denom_select__option {\n        padding: 4px 12px;\n        font-size: 12px;\n    }\n\n    body .agce-margin-lvg-btn {\n        padding: 9px 14px;\n        border-radius: 8px;\n        font-size: 13px;\n    }\n\n}\n\n/* --- Spot BUY/SELL accents: dedicated classes (+ !important) override .spot_orders_table tbody td etc. --- */\n.trade_summary_table_lft td.agce-spot-side-buy {\n    color: #01bc8d !important;\n}\n\n.trade_summary_table_lft td.agce-spot-side-sell {\n    color: #e45561 !important;\n}\n\n.trade_summary_table_lft .order_history_mobile_view .order_datalist .listdata li span.agce-spot-side-buy {\n    color: #01bc8d !important;\n}\n\n.trade_summary_table_lft .order_history_mobile_view .order_datalist .listdata li span.agce-spot-side-sell {\n    color: #e45561 !important;\n}\n\n.buysell_heder .custom-tabs li.buysell-tab.buy-tab a:not(.active) button span {\n    color: #01bc8d !important;\n}\n\n.buysell_heder .custom-tabs li.sell-tab a:not(.active) button span {\n    color: #e45561 !important;\n}\n\nhtml[data-theme=\"dark\"] .trade_summary_table_lft table.spot_orders_table tbody td.agce-spot-side-buy {\n    color: #01bc8d !important;\n}\n\nhtml[data-theme=\"dark\"] .trade_summary_table_lft table.spot_orders_table tbody td.agce-spot-side-sell {\n    color: #e45561 !important;\n}\n\nhtml[data-theme=\"dark\"] .trade_summary_table_lft table.table_home tbody td.agce-spot-side-buy {\n    color: #01bc8d !important;\n}\n\nhtml[data-theme=\"dark\"] .trade_summary_table_lft table.table_home tbody td.agce-spot-side-sell {\n    color: #e45561 !important;\n}\n\n.margin_surface_tab_strip {\n    gap: 12px 16px;\n}\n\n/* --- Mobile Filter Popup Styles Ported from Margin --- */\n.agce-margin-mobile-filter-wrap {\n    display: none;\n}\n\n@media (max-width: 1200px) {\n    .agce-margin-mobile-filter-wrap {\n        display: block;\n    }\n\n    .spot_orders_chip {\n        min-height: 34px;\n    }\n}\n\n.spot_orders_filter_bar.agce-margin-filter-bar {\n    flex-wrap: wrap;\n    overflow-x: visible;\n}\n\n.agce-margin-filter-toggle-btn {\n    border-radius: 6px;\n    font-size: 13px;\n    background: transparent;\n    border: 1px solid #4a4a4a;\n    color: inherit;\n}\n\n.agce-filter-overlay-active {\n    display: flex !important;\n    z-index: 99999999;\n}\n\n.agce-margin-filter-popup {\n    height: auto !important;\n    max-height: 80vh !important;\n    padding-bottom: 60px;\n}\n\n.agce-margin-filter-popup-content {\n    background: transparent !important;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px 10px;\n    padding-bottom: 15px !important;\n}\n\n.agce-margin-filter-popup-content>* {\n    grid-column: 1 / -1;\n}\n\n.agce-margin-filter-popup-content>.agce-margin-filter-btn {\n    grid-column: span 1;\n}\n\n.agce-margin-filter-popup-content>.agce-margin-filter-arrow {\n    display: none !important;\n}\n\n.agce-margin-filter-apply-btn {\n    background: #000000 !important;\n    border: none !important;\n    border-radius: 50px !important;\n    font-weight: 600 !important;\n    padding: 8px !important;\n    font-size: 13px;\n    color: white;\n}\n\n.agce-margin-filter-apply-btn:hover,\n.agce-margin-filter-apply-btn:active {\n    background: #141414 !important;\n}\n\n/* ── Trade page skeleton/shimmer while data loads ── */\n@keyframes agce-shimmer {\n    0% {\n        background-position: -400px 0;\n    }\n\n    100% {\n        background-position: 400px 0;\n    }\n}\n\n.agce-skel {\n    display: inline-block;\n    border-radius: 4px;\n    background: linear-gradient(90deg, rgba(128, 128, 128, 0.12) 25%, rgba(128, 128, 128, 0.22) 50%, rgba(128, 128, 128, 0.12) 75%);\n    background-size: 800px 100%;\n    animation: agce-shimmer 1.4s infinite linear;\n    color: transparent !important;\n    user-select: none;\n    min-width: 40px;\n    min-height: 1em;\n    vertical-align: middle;\n}\n\n.agce-skel--sm {\n    min-width: 28px;\n    min-height: 0.8em;\n}\n\n.agce-skel--md {\n    min-width: 60px;\n}\n\n.agce-skel--lg {\n    min-width: 90px;\n}\n\n/* Dark Theme Fixes for Filters Popup */\n.agce-margin-filter-popup {\n    background: rgb(30 35 41 / 50%) !important;\n}\n\nbody.light_theme .agce-margin-filter-popup {\n    background: rgb(255 255 255 / 20%) !important;\n    box-shadow: 0px 5px 22px #0000009c;\n}\n\nbody.light_theme .futures-margin-modal.position-fixed.w-100.h-100.top-0.start-0 {\n    background-color: rgb(255 255 255 / 50%) !important;\n}\n\n.futures-margin-modal.position-fixed.w-100.h-100.top-0.start-0 {\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n}\n\n.agce-margin-filter-popup h6 {\n    color: #eaecef !important;\n}\n\nbody.light_theme .agce-margin-filter-popup h6 {\n    color: #1e2329 !important;\n}\n\n.agce-margin-filter-popup .btn-close {\n    filter: invert(1) brightness(200%);\n}\n\nbody.light_theme .agce-margin-filter-popup .btn-close {\n    filter: none;\n}\n\n.spot_orders_side_select {\n    background: #181a20 !important;\n    border-color: #2b3138 !important;\n    color: #eaecef !important;\n}\n\nbody.light_theme .spot_orders_side_select {\n    background: #ffffff !important;\n    border-color: #d1d5db !important;\n    color: #111827 !important;\n}\n\n.spot_orders_reset {\n    color: #eaecef !important;\n}\n\nbody.light_theme .spot_orders_reset {\n    color: #909397 !important;\n}\n\n.spot_orders_reset:hover {\n    color: #ffffff !important;\n}\n\nbody.light_theme .spot_orders_reset:hover {\n    color: #111827 !important;\n}\n\n.agce-margin-filter-apply-btn {\n    background: #fcd535 !important;\n    color: #181a20 !important;\n}\n\nbody.light_theme .agce-margin-filter-apply-btn {\n    background: #000000 !important;\n    color: #ffffff !important;\n}\n\n@supports (-webkit-touch-callout: none) {\n    .trade-wrapper.spot {\n        padding-bottom: env(safe-area-inset-bottom) !important;\n    }\n}\n\n/* AGCX Custom Filter Select Styles */\n.agce-custom-select-container {\n    position: relative;\n    width: auto;\n    min-width: 95px;\n    display: inline-block;\n    margin-right: 6px;\n    margin-bottom: 0;\n    vertical-align: middle;\n}\n\n.agce-custom-select-trigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: 30px;\n    padding: 0 10px;\n    background: #181a20;\n    border: 1px solid #2b3139;\n    border-radius: 4px;\n    color: #eaecef;\n    font-size: 12px;\n    font-weight: 500;\n    cursor: pointer;\n    user-select: none;\n    box-sizing: border-box;\n    transition: border-color 0.2s, background-color 0.2s;\n    gap: 8px;\n    white-space: nowrap;\n}\n\nbody.light_theme .agce-custom-select-trigger {\n    background: #f6f6f7;\n    border: 1px solid #cbd5e1;\n    color: #1e2329;\n}\n\n/* .agce-custom-select-trigger:focus,\n.agce-custom-select-trigger:hover {\n    border-color: #d1aa67;\n} */\n\n.agce-custom-select-trigger i {\n    font-size: 14px;\n    transition: transform 0.2s ease;\n    color: #848e9c;\n}\n\n.agce-custom-select-trigger i.open {\n    transform: rotate(180deg);\n}\n\n.agce-custom-select-options {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    min-width: 100%;\n    width: max-content;\n    max-width: 200px;\n    max-height: 220px;\n    overflow-y: auto;\n    background: #181a20;\n    border: 1px solid #2b3139;\n    border-radius: 6px;\n    z-index: 100000;\n    padding: 4px 0;\n    margin: 0;\n    list-style: none;\n    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);\n    box-sizing: border-box;\n}\n\nbody.light_theme .agce-custom-select-options {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.agce-custom-select-option {\n    padding: 8px 14px;\n    font-size: 12px;\n    color: #eaecef;\n    cursor: pointer;\n    text-align: left;\n    transition: background-color 0.15s, color 0.15s;\n    white-space: nowrap;\n}\n\nbody.light_theme .agce-custom-select-option {\n    color: #1e2329;\n}\n\n.agce-custom-select-option:hover {\n    background: #2b3139;\n    color: #d1aa67;\n}\n\nbody.light_theme .agce-custom-select-option:hover {\n    background: #f1f5f9;\n    color: #d1aa67;\n}\n\n.agce-custom-select-option.selected {\n    background: rgba(209, 170, 103, 0.15);\n    color: #d1aa67;\n    font-weight: 600;\n}\n\nbody.light_theme .agce-custom-select-option.selected {\n    background: rgba(209, 170, 103, 0.1);\n    color: #d1aa67;\n    font-weight: 600;\n}\n\n/* Scrollbar customization for custom dropdown list */\n.agce-custom-select-options::-webkit-scrollbar {\n    width: 4px;\n}\n\n.agce-custom-select-options::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.agce-custom-select-options::-webkit-scrollbar-thumb {\n    background: #474f59;\n    border-radius: 4px;\n}\n\nbody.light_theme .agce-custom-select-options::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n}\n\n/* Mobile popup filter content adjustments */\n.agce-margin-filter-popup-content .agce-custom-select-container {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 12px;\n}\n\n.agce-margin-filter-popup-content .agce-custom-select-trigger {\n    height: 38px;\n    font-size: 13px;\n    padding: 0 12px;\n    border-radius: 8px;\n}\n\n/* Table Header Side Select Dropdown Styles */\n.th-side-select-container {\n    position: relative;\n    display: inline-block;\n}\n\n.th-side-select-trigger {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-weight: 500;\n    font-size: 12px;\n    user-select: none;\n    padding: 2px 6px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.th-side-select-trigger:hover {\n    background-color: rgba(255, 255, 255, 0.08) !important;\n}\n\n.th-side-select-arrow {\n    font-size: 14px;\n    transition: transform 0.2s ease;\n    opacity: 0.8;\n}\n\n.th-side-select-arrow.open {\n    transform: rotate(180deg);\n}\n\n.th-side-select-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin-top: 4px;\n    min-width: 90px;\n    background: #181a20;\n    border: 1px solid #2b3139;\n    border-radius: 6px;\n    padding: 0px 0;\n    margin: 0;\n    list-style: none;\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    text-align: left;\n}\n\n.th-side-select-item {\n    font-size: 12px;\n    font-weight: 400;\n    padding: 6px 12px;\n    transition: background-color 0.15s ease;\n    color: #eaecef;\n}\n\n.th-side-select-item.active {\n    font-weight: 600;\n    background-color: rgb(255 255 255 / 10%);\n}\n\n.th-side-select-item:hover {\n    background-color: #2b3139 !important;\n}\n\n.th-side-select-check {\n    color: #d3d3d3;\n    font-size: 13px;\n}\n\nbody.light_theme .th-side-select-check {\n    color: #4e4e4e;\n}\n\n/* Light Theme Overrides */\nbody.light_theme .th-side-select-trigger:hover {\n    background-color: rgba(0, 0, 0, 0.06) !important;\n}\n\nbody.light_theme .th-side-select-menu {\n    background: #ffffff !important;\n    border: 1px solid #e2e8f0 !important;\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;\n}\n\nbody.light_theme .th-side-select-item {\n    color: #1e2329 !important;\n}\n\nbody.light_theme .th-side-select-item:hover {\n    background-color: #f1f5f9 !important;\n}\n\nbody.light_theme .th-side-select-item.active {\n    background-color: rgba(240, 185, 11, 0.1) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
